import React from "react";
import { connect } from "react-redux";
import BackButton from "./BackButton";
import ToggleButton from "./ToggleButton";
import $ from "jquery";
import Modal from "./Modal";
import Button from "components/CustomButtons/Button.jsx";
import withStyles from "@material-ui/core/styles/withStyles";
import notificationsStyle from "assets/jss/material-dashboard-pro-react/views/notificationsStyle.jsx";
import pencil from "assets/img/pencil.svg";
import close from "assets/img/close.svg";
import API from "@aws-amplify/api";
import "assets/scss/styles.css";
import Parser from "html-react-parser";
import CryptoJS from "crypto-js";
import cmpClientIdObject from "client-id";
import { getClientIdNameMap } from "../../../util/clients/getClientIdNameMap";

let apiName = process.env.REACT_APP_AMPLIFY_API;

class AddRule extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      localStorageClientId: "",
      // client id -> name, scanned from the cmp-v2-clients dynamo table
      // (via the /clients API) instead of being hardcoded.
      globalClientName: "",
    };
  }

  async componentDidMount() {
    let clientId = "";
    if (localStorage.getItem("clientId") !== null) {
      clientId = this.decryptLocal("clientId");
    }
    let cmpClientIdWithName = await getClientIdNameMap();
    this.setState({
      localStorageClientId: clientId,
      globalClientName: cmpClientIdWithName[clientId],
    });
  }

  decryptLocal(item_id) {
    return JSON.parse(
      CryptoJS.AES.decrypt(
        localStorage.getItem(item_id),
        process.env.REACT_APP_PASS
      ).toString(CryptoJS.enc.Utf8)
    )
  }

  deleteRuleClick(selectedRule) {
    this.props.dispatch({
      type: "CUST_TILL_SQL_POP_SEGMENT",
      selectedIndex: this.props.index,
      selectedRule: selectedRule,
    });
    this.props.dispatch({ type: "CUST_Add_SEGMENT" });
  }

  fetchProspectQueryData(
    modelDecileCondition,
    nonModelDecileCondition,
    samplingCondition,
    segmentQueryCondition,
    fQS,
    filtersNonModelDecileSelectedRule,
    filtersModelDecileSelectedRule,
    filtersSamplingSelectedRule
  ) {
    // console.log("fetch Prospect Query Data Called");
    // console.log("Model Decile Condition " + modelDecileCondition);
    // console.log("Non Model Decile Condition " + nonModelDecileCondition);
    // console.log("Segment Condition Is " + segmentQueryCondition);
    // console.log("Fqs Is " + fQS);
    // console.log(
    //   "Filters Non Model Decile  " + filtersNonModelDecileSelectedRule
    // );
    // console.log("Filters Model Decile  " + filtersModelDecileSelectedRule);

    this.props.dispatch({
      type: "CUST_UPDATE_OVERLAY_SPINNER",
      overlaySpinner: true,
    });

    let selectedCustomerType = this.decryptLocal("selectedCustomerType");
    if (selectedCustomerType === "Acquistion") {
      let channel = "display";

      if (
        this.decryptLocal("activeChannel") === "d977fc2b-2352-473b-9a54-b80765f0400c" ||
        this.decryptLocal("activeChannel") === "1905c46e-6f48-4ed8-b2a9-35dbbf3bae91"
      ) {
        channel = "email";
      }
      if (this.decryptLocal("activeChannel") === "2c77a7b6-60e9-4c75-819e-e93b60d47b82") {
        channel = "direct_mail";
      }

      fetch(
        "https://v56uvo3jhtilsarixxweiwahum0nrabn.lambda-url.us-west-2.on.aws/",
        {
          method: "post",
          body: JSON.stringify({
            maximumAudienceSizeParameterValue: this.decryptLocal("maximumAudienceSizeLocalStorage"),
            prospectMinimumParameterValue: this.decryptLocal("prospectMinimumValueLocalStorage"),
            channelType: channel,
            // nonModelDecileProspectFilterRule: nonModelDecileCondition,
            nonModelDecileProspectSegmentRule: nonModelDecileCondition,
            // modelDecileProspectFilterRule: modelDecileCondition,
            modelDecileProspectSegmentRule: modelDecileCondition,
            samplingProspectsSegmentRule: samplingCondition,
            clientName: this.state.globalClientName,
            selectedType: "segment",
            segmentSelectedRule: segmentQueryCondition,
            nonModelDecileProspectFilterRule: filtersNonModelDecileSelectedRule,
            modelDecileProspectFilterRule: filtersModelDecileSelectedRule,
            samplingFilterRule: filtersSamplingSelectedRule,
          }),
        }
      )
        .then((res) => res.json())
        .then((result) => {
          console.log("Result", result);
          if (result.hasOwnProperty("ERROR")) {
            this.setState(
              {
                errorFlag: true,
              },
              () => {
                this.setState({
                  overlaySpinnerSummary: false,
                });
              }
            );
          } else {
            this.prepareProspectQueryResponse(result, fQS);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }

  prepareProspectQueryResponse(response, fQS) {
    this.props.dispatch({
      type: "CUST_UPDATE_SUMMARY_DETAILS",
      segmentsTabPayload: fQS,
      segmentsTabValue: response["final_result"]["Items"],
    });
    this.props.dispatch({
      type: "CUST_UPDATE_QUERY_COUNT_SEGMENT",
      segmentData: response["final_result"]["Items"],
    });
    this.props.dispatch({
      type: "CUST_UPDATE_OVERLAY_SPINNER",
      overlaySpinner: false,
    });
  }

  getWhereCondition() {
    let selectedRule = "";
    let selectedOptionValue = "";
    let selectedResult = [];
    let groupLeveltoggle = this.props.cust_groupLeveltoggle;
    let ruleLeveltoggle = this.props.cust_ruleLeveltoggle;
    let count = 0;
    let sqlAndOrOperator = "";
    let automationIdOrListId = "";
    let automationIdOrListIdExists = false;
    let menuItemsSelected = false;
    let menuSubCategorySelected = false;

    // Changes for Prospect query
    let prospectConditionExists = false;
    let modelDecileConditionExists = false;
    let modelDecileSelectedRule = "";
    let nonModelDecileSelectedRule = "";
    let samplingConditionExists = false;
    let samplingSelectedRule = "";

    let selectedCustomerType = this.decryptLocal("selectedCustomerType");

    this.props.cust_tillSqlSelectionArr.map((resultData, index) => {
      selectedRule += `(`;
      resultData.map((options, key) => {
        if (options.find((test) => test.value === "li.list_id") !== undefined) {
          automationIdOrListIdExists = true;
        } else {
          automationIdOrListIdExists = false;
        }
        if (options.find((test) => test.value.includes("hh.")) !== undefined) {
          prospectConditionExists = true;
        } else {
          prospectConditionExists = false;
        }
        if (
          options.find(
            (menuItem) =>
              menuItem.value ===
              "ca.cust_id in (select cust_id from fridays_refined.trans_pay where trans_id in (select trans_id from fridays_refined.trans_detail where item_id"
          ) !== undefined
        ) {
          menuItemsSelected = true;
        } else {
          menuItemsSelected = false;
        }

        if (
          options.find(
            (menuItemBajaFresh) =>
              menuItemBajaFresh.value ===
              "ca.cust_id in (select cust_id from bajafresh_refined.trans_pay where trans_id in (select trans_id from bajafresh_refined.trans_detail where item_id"
          ) !== undefined
        ) {
          menuItemsSelected = true;
        } else {
          menuItemsSelected = false;
        }

        if (
          options.find(
            (menuSubCategory) =>
              menuSubCategory.value ===
              "ca.cust_id in (select cust_id from fridays_refined.trans_pay where trans_id in (select trans_id from fridays_refined.trans_detail where item_id in (select item_id from fridays_refined.item where concat(item_hier_1, '-', item_hier_2)"
          ) !== undefined
        ) {
          menuSubCategorySelected = true;
        } else {
          menuSubCategorySelected = false;
        }

        if (
          options.find(
            (menuSubCategoryBajaFresh) =>
              menuSubCategoryBajaFresh.value ===
              "ca.cust_id in (select cust_id from bajafresh_refined.trans_pay where trans_id in (select trans_id from bajafresh_refined.trans_detail where item_id in (select item_id from bajafresh_refined.item where concat(item_hier_1, '-', item_hier_2)"
          ) !== undefined
        ) {
          menuSubCategorySelected = true;
        } else {
          menuSubCategorySelected = false;
        }

        if (
          options.find((test) => test.value.includes("model_decile")) !==
          undefined
        ) {
          modelDecileConditionExists = true;
        } else {
          modelDecileConditionExists = false;
        }

        if (
          options.find((rule) => rule.value.includes("Sampling")) !== undefined
        ) {
          samplingConditionExists = true;
        } else {
          samplingConditionExists = false;
        }

        let length = options.length;
        if (
          "value" in options[length - 2] &&
          options[length - 2].value.includes("+++")
        ) {
          options[length - 2].value = options[length - 2].value.split("+++")[0];
        }
        if (
          options[length - 1].value === "BETWEEN" ||
          options[length - 1].value === "NOT BETWEEN"
        ) {
          selectedRule += "(";
          if (modelDecileConditionExists) {
            modelDecileSelectedRule += "(";
          } else if (!modelDecileConditionExists && !samplingConditionExists) {
            nonModelDecileSelectedRule += "(";
          }

          if (samplingConditionExists) {
            samplingSelectedRule += "(";
          }
        }

        if (
          options[length - 1].value === "cardinality(array_intersect(" ||
          options[length - 1].value === "cardinality(array_except("
        ) {
          selectedRule +=
            "(" +
            options[length - 1].value +
            options[length - 2].value +
            ", array";
          if (modelDecileConditionExists) {
            modelDecileSelectedRule +=
              "(" +
              options[length - 1].value +
              options[length - 2].value +
              ", array";
          } else if (!modelDecileConditionExists && !samplingConditionExists) {
            nonModelDecileSelectedRule +=
              "(" +
              options[length - 1].value +
              options[length - 2].value +
              ", array";
          }

          if (samplingConditionExists) {
            samplingSelectedRule +=
              "(" +
              options[length - 1].value +
              options[length - 2].value +
              ", array";
          }
        } else {
          selectedRule +=
            "(" + options[length - 2].value + " " + options[length - 1].value;
          if (modelDecileConditionExists) {
            modelDecileSelectedRule +=
              "(" + options[length - 2].value + " " + options[length - 1].value;
          } else if (!modelDecileConditionExists && !samplingConditionExists) {
            nonModelDecileSelectedRule +=
              "(" + options[length - 2].value + " " + options[length - 1].value;
          }

          if (samplingConditionExists) {
            samplingSelectedRule +=
              "(" + options[length - 2].value + " " + options[length - 1].value;
          }
        }

        let data = this.props.cust_afterSqlSelectionArr[index][key];
        if (data.length > 0) {
          data.map((result, resultKey) => {
            count = count + 1;
            sqlAndOrOperator = "";
            if (
              options[length - 1].value == "IN" ||
              options[length - 1].value == "NOT IN"
            ) {
              if (resultKey == 0) {
                selectedRule += `(`;
                if (modelDecileConditionExists) {
                  modelDecileSelectedRule += `(`;
                } else if (
                  !modelDecileConditionExists &&
                  !samplingConditionExists
                ) {
                  nonModelDecileSelectedRule += `(`;
                }

                if (samplingConditionExists) {
                  samplingSelectedRule += `(`;
                }
              }
              if (resultKey == data.length - 1) {
                let num = result.value;
                if (automationIdOrListIdExists) {
                  automationIdOrListId = num;
                }
                if (typeof num == "string") {
                  selectedRule += ` '${result.value}', `;
                  if (modelDecileConditionExists) {
                    modelDecileSelectedRule += ` '${result.value}', `;
                  } else if (
                    !modelDecileConditionExists &&
                    !samplingConditionExists
                  ) {
                    nonModelDecileSelectedRule += ` '${result.value}', `;
                  }

                  if (samplingConditionExists) {
                    samplingSelectedRule += ` '${result.value}', `;
                  }
                } else {
                  selectedRule += ` ${result.value}, `;
                  if (modelDecileConditionExists) {
                    modelDecileSelectedRule += ` ${result.value}, `;
                  } else if (
                    !modelDecileConditionExists &&
                    !samplingConditionExists
                  ) {
                    nonModelDecileSelectedRule += ` ${result.value}, `;
                  }

                  if (samplingConditionExists) {
                    samplingSelectedRule += ` ${result.value}, `;
                  }
                }
                selectedRule = selectedRule.replace(/,(\s+)?$/, "");
                if (modelDecileConditionExists) {
                  modelDecileSelectedRule = modelDecileSelectedRule.replace(
                    /,(\s+)?$/,
                    ""
                  );
                } else if (
                  !modelDecileConditionExists &&
                  !samplingConditionExists
                ) {
                  nonModelDecileSelectedRule = nonModelDecileSelectedRule.replace(
                    /,(\s+)?$/,
                    ""
                  );
                }

                if (samplingConditionExists) {
                  samplingSelectedRule = samplingSelectedRule.replace(
                    /,(\s+)?$/,
                    ""
                  );
                }

                if (menuItemsSelected) {
                  if (selectedCustomerType === "Customer") {
                    selectedRule += `))) AND ${this.decryptLocal("globalFilter")})`;
                  } else {
                    selectedRule += `))))`;
                    // selectedRule += `))) ${
                    //   JSON.parse(
                    //     CryptoJS.AES.decrypt(
                    //       localStorage.getItem("selectedCustomerType"),
                    //       process.env.REACT_APP_PASS
                    //     ).toString(CryptoJS.enc.Utf8)
                    //   ) === "Acquistion" ||
                    //   JSON.parse(
                    //     CryptoJS.AES.decrypt(
                    //       localStorage.getItem("selectedCustomerType"),
                    //       process.env.REACT_APP_PASS
                    //     ).toString(CryptoJS.enc.Utf8)
                    //   ) === "Combined"
                    //     ? ""
                    //     : "AND"
                    // } ${
                    //   JSON.parse(
                    //     CryptoJS.AES.decrypt(
                    //       localStorage.getItem("selectedCustomerType"),
                    //       process.env.REACT_APP_PASS
                    //     ).toString(CryptoJS.enc.Utf8)
                    //   ) === "Acquistion" ||
                    //   JSON.parse(
                    //     CryptoJS.AES.decrypt(
                    //       localStorage.getItem("selectedCustomerType"),
                    //       process.env.REACT_APP_PASS
                    //     ).toString(CryptoJS.enc.Utf8)
                    //   ) === "Combined"
                    //     ? ""
                    //     : JSON.parse(
                    //         CryptoJS.AES.decrypt(
                    //           localStorage.getItem("globalFilter"),
                    //           process.env.REACT_APP_PASS
                    //         ).toString(CryptoJS.enc.Utf8)
                    //       )
                    // })`;
                  }
                } else if (menuSubCategorySelected) {
                  if (selectedCustomerType === "Customer") {
                    selectedRule += `)))) AND ${this.decryptLocal("globalFilter")})`;
                  } else {
                    selectedRule += `))`;
                    if (modelDecileConditionExists) {
                      modelDecileSelectedRule += `))`;
                    } else if (
                      !modelDecileConditionExists &&
                      !samplingConditionExists
                    ) {
                      nonModelDecileSelectedRule += `))`;
                    }

                    if (samplingConditionExists) {
                      samplingSelectedRule += `))`;
                    }
                    // selectedRule += `) ${
                    //   JSON.parse(
                    //     CryptoJS.AES.decrypt(
                    //       localStorage.getItem("selectedCustomerType"),
                    //       process.env.REACT_APP_PASS
                    //     ).toString(CryptoJS.enc.Utf8)
                    //   ) === "Acquistion" ||
                    //   JSON.parse(
                    //     CryptoJS.AES.decrypt(
                    //       localStorage.getItem("selectedCustomerType"),
                    //       process.env.REACT_APP_PASS
                    //     ).toString(CryptoJS.enc.Utf8)
                    //   ) === "Combined"
                    //     ? ""
                    //     : "AND"
                    // } ${
                    //   JSON.parse(
                    //     CryptoJS.AES.decrypt(
                    //       localStorage.getItem("selectedCustomerType"),
                    //       process.env.REACT_APP_PASS
                    //     ).toString(CryptoJS.enc.Utf8)
                    //   ) === "Acquistion" ||
                    //   JSON.parse(
                    //     CryptoJS.AES.decrypt(
                    //       localStorage.getItem("selectedCustomerType"),
                    //       process.env.REACT_APP_PASS
                    //     ).toString(CryptoJS.enc.Utf8)
                    //   ) === "Combined"
                    //     ? ""
                    //     : JSON.parse(
                    //         CryptoJS.AES.decrypt(
                    //           localStorage.getItem("globalFilter"),
                    //           process.env.REACT_APP_PASS
                    //         ).toString(CryptoJS.enc.Utf8)
                    //       )
                    // })`;
                  }
                } else {
                  if (selectedCustomerType === "Customer") {
                    selectedRule += `) AND ${this.decryptLocal("globalFilter")})`;
                  } else {
                    selectedRule += `))`;
                    selectedRule += `))`;
                    if (modelDecileConditionExists) {
                      modelDecileSelectedRule += `))`;
                    } else if (
                      !modelDecileConditionExists &&
                      !samplingConditionExists
                    ) {
                      nonModelDecileSelectedRule += `))`;
                    }

                    if (samplingConditionExists) {
                      samplingSelectedRule += `))`;
                    }
                    // selectedRule += `) ${
                    //   JSON.parse(
                    //     CryptoJS.AES.decrypt(
                    //       localStorage.getItem("selectedCustomerType"),
                    //       process.env.REACT_APP_PASS
                    //     ).toString(CryptoJS.enc.Utf8)
                    //   ) === "Acquistion" ||
                    //   JSON.parse(
                    //     CryptoJS.AES.decrypt(
                    //       localStorage.getItem("selectedCustomerType"),
                    //       process.env.REACT_APP_PASS
                    //     ).toString(CryptoJS.enc.Utf8)
                    //   ) === "Combined"
                    //     ? ""
                    //     : "AND"
                    // } ${
                    //   JSON.parse(
                    //     CryptoJS.AES.decrypt(
                    //       localStorage.getItem("selectedCustomerType"),
                    //       process.env.REACT_APP_PASS
                    //     ).toString(CryptoJS.enc.Utf8)
                    //   ) === "Acquistion" ||
                    //   JSON.parse(
                    //     CryptoJS.AES.decrypt(
                    //       localStorage.getItem("selectedCustomerType"),
                    //       process.env.REACT_APP_PASS
                    //     ).toString(CryptoJS.enc.Utf8)
                    //   ) === "Combined"
                    //     ? ""
                    //     : JSON.parse(
                    //         CryptoJS.AES.decrypt(
                    //           localStorage.getItem("globalFilter"),
                    //           process.env.REACT_APP_PASS
                    //         ).toString(CryptoJS.enc.Utf8)
                    //       )
                    // })`;
                  }
                }

                // if (selectedCustomerType === "Customer") {
                //   selectedRule += `) AND ${JSON.parse(
                //     CryptoJS.AES.decrypt(
                //       localStorage.getItem("globalFilter"),
                //       process.env.REACT_APP_PASS
                //     ).toString(CryptoJS.enc.Utf8)
                //   )})`;
                // } else {
                //   selectedRule += `) ${
                //     JSON.parse(
                //       CryptoJS.AES.decrypt(
                //         localStorage.getItem("selectedCustomerType"),
                //         process.env.REACT_APP_PASS
                //       ).toString(CryptoJS.enc.Utf8)
                //     ) === "Acquistion" ||
                //     JSON.parse(
                //       CryptoJS.AES.decrypt(
                //         localStorage.getItem("selectedCustomerType"),
                //         process.env.REACT_APP_PASS
                //       ).toString(CryptoJS.enc.Utf8)
                //     ) === "Combined"
                //       ? ""
                //       : "AND"
                //   } ${
                //     JSON.parse(
                //       CryptoJS.AES.decrypt(
                //         localStorage.getItem("selectedCustomerType"),
                //         process.env.REACT_APP_PASS
                //       ).toString(CryptoJS.enc.Utf8)
                //     ) === "Acquistion" ||
                //     JSON.parse(
                //       CryptoJS.AES.decrypt(
                //         localStorage.getItem("selectedCustomerType"),
                //         process.env.REACT_APP_PASS
                //       ).toString(CryptoJS.enc.Utf8)
                //     ) === "Combined"
                //       ? ""
                //       : JSON.parse(
                //           CryptoJS.AES.decrypt(
                //             localStorage.getItem("globalFilter"),
                //             process.env.REACT_APP_PASS
                //           ).toString(CryptoJS.enc.Utf8)
                //         )
                //   })`;
                // }

                if (
                  ruleLeveltoggle.length > 0 &&
                  ruleLeveltoggle[index] !== undefined &&
                  ruleLeveltoggle[index][key] !== undefined
                ) {
                  sqlAndOrOperator = ruleLeveltoggle[index][key];
                  selectedRule += ` ${sqlAndOrOperator} `;
                  if (modelDecileConditionExists) {
                    modelDecileSelectedRule += ` ${sqlAndOrOperator} `;
                  } else if (
                    !modelDecileConditionExists &&
                    !samplingConditionExists
                  ) {
                    nonModelDecileSelectedRule += ` ${sqlAndOrOperator} `;
                  }

                  if (samplingConditionExists) {
                    samplingSelectedRule += ` ${sqlAndOrOperator} `;
                  }
                }
              } else {
                let num = result.value;
                if (automationIdOrListIdExists) {
                  automationIdOrListId = num;
                }
                if (typeof num == "string") {
                  selectedRule += ` '${result.value}', `;
                  if (modelDecileConditionExists) {
                    modelDecileSelectedRule += ` '${result.value}', `;
                  } else if (
                    !modelDecileConditionExists &&
                    !samplingConditionExists
                  ) {
                    nonModelDecileSelectedRule += ` '${result.value}', `;
                  }

                  if (samplingConditionExists) {
                    samplingSelectedRule += ` '${result.value}', `;
                  }
                } else {
                  selectedRule += ` ${result.value}, `;
                  if (modelDecileConditionExists) {
                    modelDecileSelectedRule += ` ${result.value}, `;
                  } else if (
                    !modelDecileConditionExists &&
                    !samplingConditionExists
                  ) {
                    nonModelDecileSelectedRule += ` ${result.value}, `;
                  }

                  if (samplingConditionExists) {
                    samplingSelectedRule += ` ${result.value}, `;
                  }
                }
              }
            } else if (
              options[length - 1].value == "cardinality(array_intersect("
            ) {
              if (resultKey == 0) {
                selectedRule += `[`;
                if (modelDecileConditionExists) {
                  modelDecileSelectedRule += `[`;
                } else if (
                  !modelDecileConditionExists &&
                  !samplingConditionExists
                ) {
                  nonModelDecileSelectedRule += `[`;
                }

                if (samplingConditionExists) {
                  samplingSelectedRule += `[`;
                }
              }
              if (resultKey == data.length - 1) {
                let num = result.value;
                let aggarray = [];
                selectedRule += ` '${result.value}', `;
                if (modelDecileConditionExists) {
                  modelDecileSelectedRule += ` '${result.value}', `;
                } else if (
                  !modelDecileConditionExists &&
                  !samplingConditionExists
                ) {
                  nonModelDecileSelectedRule += ` '${result.value}', `;
                }

                if (samplingConditionExists) {
                  samplingSelectedRule += ` '${result.value}', `;
                }
                selectedRule = selectedRule.replace(/,(\s+)?$/, "");
                if (modelDecileConditionExists) {
                  modelDecileSelectedRule = modelDecileSelectedRule.replace(
                    /,(\s+)?$/,
                    ""
                  );
                } else if (
                  !modelDecileConditionExists &&
                  !samplingConditionExists
                ) {
                  nonModelDecileSelectedRule = nonModelDecileSelectedRule.replace(
                    /,(\s+)?$/,
                    ""
                  );
                }

                if (samplingConditionExists) {
                  samplingSelectedRule = samplingSelectedRule.replace(
                    /,(\s+)?$/,
                    ""
                  );
                }

                if (selectedCustomerType === "Customer") {
                  selectedRule += `])) > 0 AND ${this.decryptLocal("globalFilter")})`;
                } else {
                  selectedRule += `])) > 0)`;
                  // selectedRule += `])) > 0 ${
                  //   JSON.parse(
                  //     CryptoJS.AES.decrypt(
                  //       localStorage.getItem("selectedCustomerType"),
                  //       process.env.REACT_APP_PASS
                  //     ).toString(CryptoJS.enc.Utf8)
                  //   ) === "Acquistion" ||
                  //   JSON.parse(
                  //     CryptoJS.AES.decrypt(
                  //       localStorage.getItem("selectedCustomerType"),
                  //       process.env.REACT_APP_PASS
                  //     ).toString(CryptoJS.enc.Utf8)
                  //   ) === "Combined"
                  //     ? ""
                  //     : "AND"
                  // } ${
                  //   JSON.parse(
                  //     CryptoJS.AES.decrypt(
                  //       localStorage.getItem("selectedCustomerType"),
                  //       process.env.REACT_APP_PASS
                  //     ).toString(CryptoJS.enc.Utf8)
                  //   ) === "Acquistion" ||
                  //   JSON.parse(
                  //     CryptoJS.AES.decrypt(
                  //       localStorage.getItem("selectedCustomerType"),
                  //       process.env.REACT_APP_PASS
                  //     ).toString(CryptoJS.enc.Utf8)
                  //   ) === "Combined"
                  //     ? ""
                  //     : JSON.parse(
                  //         CryptoJS.AES.decrypt(
                  //           localStorage.getItem("globalFilter"),
                  //           process.env.REACT_APP_PASS
                  //         ).toString(CryptoJS.enc.Utf8)
                  //       )
                  // })`;
                }
                if (modelDecileConditionExists) {
                  modelDecileSelectedRule += `])) > 0 ${
                    this.decryptLocal("selectedCustomerType") === "Acquistion" ||
                    (this.decryptLocal("selectedCustomerType") === "Combined" &&
                      prospectConditionExists)
                      ? ""
                      : "AND"
                  } ${
                    this.decryptLocal("selectedCustomerType") === "Acquistion" ||
                    (this.decryptLocal("selectedCustomerType") === "Combined" &&
                      prospectConditionExists)
                      ? ""
                      : this.decryptLocal("globalFilter")
                  })`;
                } else if (
                  !modelDecileConditionExists &&
                  !samplingConditionExists
                ) {
                  nonModelDecileSelectedRule += `])) > 0 ${
                    this.decryptLocal("selectedCustomerType") === "Acquistion" ||
                    (this.decryptLocal("selectedCustomerType") === "Combined" &&
                      prospectConditionExists)
                      ? ""
                      : "AND"
                  } ${
                    this.decryptLocal("selectedCustomerType") === "Acquistion" ||
                    (this.decryptLocal("selectedCustomerType") === "Combined" &&
                      prospectConditionExists)
                      ? ""
                      : this.decryptLocal("globalFilter")
                  })`;
                }

                if (samplingConditionExists) {
                  samplingSelectedRule += `])) > 0 ${
                    this.decryptLocal("selectedCustomerType") === "Acquistion" ||
                    (this.decryptLocal("selectedCustomerType") === "Combined" &&
                      prospectConditionExists)
                      ? ""
                      : "AND"
                  } ${
                    this.decryptLocal("selectedCustomerType") === "Acquistion" ||
                    (this.decryptLocal("selectedCustomerType") === "Combined" &&
                      prospectConditionExists)
                      ? ""
                      : this.decryptLocal("globalFilter")
                  })`;
                }
                if (
                  ruleLeveltoggle.length > 0 &&
                  ruleLeveltoggle[index] !== undefined &&
                  ruleLeveltoggle[index][key] !== undefined
                ) {
                  sqlAndOrOperator = ruleLeveltoggle[index][key];
                  selectedRule += ` ${sqlAndOrOperator} `;
                  if (modelDecileConditionExists) {
                    modelDecileSelectedRule += ` ${sqlAndOrOperator} `;
                  } else if (
                    !modelDecileConditionExists &&
                    !samplingConditionExists
                  ) {
                    nonModelDecileSelectedRule += ` ${sqlAndOrOperator} `;
                  }

                  if (samplingConditionExists) {
                    samplingSelectedRule += ` ${sqlAndOrOperator} `;
                  }
                }
              } else {
                let num = result.value;
                selectedRule += ` '${result.value}', `;
                if (modelDecileConditionExists) {
                  modelDecileSelectedRule += ` '${result.value}', `;
                } else if (
                  !modelDecileConditionExists &&
                  !samplingConditionExists
                ) {
                  nonModelDecileSelectedRule += ` '${result.value}', `;
                }

                if (samplingConditionExists) {
                  samplingSelectedRule += ` '${result.value}', `;
                }
              }
            } else if (
              options[length - 1].value == "cardinality(array_except("
            ) {
              if (resultKey == 0) {
                selectedRule += `[`;
                if (modelDecileConditionExists) {
                  modelDecileSelectedRule += `[`;
                } else if (
                  !modelDecileConditionExists &&
                  !samplingConditionExists
                ) {
                  nonModelDecileSelectedRule += `[`;
                }

                if (samplingConditionExists) {
                  samplingSelectedRule += `[`;
                }
              }
              if (resultKey == data.length - 1) {
                let num = result.value;
                let aggarray = [];
                selectedRule += ` '${result.value}', `;
                if (modelDecileConditionExists) {
                  modelDecileSelectedRule += ` '${result.value}', `;
                } else if (
                  !modelDecileConditionExists &&
                  !samplingConditionExists
                ) {
                  nonModelDecileSelectedRule += ` '${result.value}', `;
                }

                if (samplingConditionExists) {
                  samplingSelectedRule += ` '${result.value}', `;
                }
                selectedRule = selectedRule.replace(/,(\s+)?$/, "");
                if (modelDecileConditionExists) {
                  modelDecileSelectedRule = modelDecileSelectedRule.replace(
                    /,(\s+)?$/,
                    ""
                  );
                } else if (
                  !modelDecileConditionExists &&
                  !samplingConditionExists
                ) {
                  nonModelDecileSelectedRule = nonModelDecileSelectedRule.replace(
                    /,(\s+)?$/,
                    ""
                  );
                }

                if (samplingConditionExists) {
                  samplingSelectedRule = samplingSelectedRule.replace(
                    /,(\s+)?$/,
                    ""
                  );
                }

                if (selectedCustomerType === "Customer") {
                  selectedRule += `])) > 0 AND ${this.decryptLocal("globalFilter")})`;
                } else {
                  selectedRule += `])) > 0)`;
                  // selectedRule += `])) > 0 ${
                  //   JSON.parse(
                  //     CryptoJS.AES.decrypt(
                  //       localStorage.getItem("selectedCustomerType"),
                  //       process.env.REACT_APP_PASS
                  //     ).toString(CryptoJS.enc.Utf8)
                  //   ) === "Acquistion" ||
                  //   JSON.parse(
                  //     CryptoJS.AES.decrypt(
                  //       localStorage.getItem("selectedCustomerType"),
                  //       process.env.REACT_APP_PASS
                  //     ).toString(CryptoJS.enc.Utf8)
                  //   ) === "Combined"
                  //     ? ""
                  //     : "AND"
                  // } ${
                  //   JSON.parse(
                  //     CryptoJS.AES.decrypt(
                  //       localStorage.getItem("selectedCustomerType"),
                  //       process.env.REACT_APP_PASS
                  //     ).toString(CryptoJS.enc.Utf8)
                  //   ) === "Acquistion" ||
                  //   JSON.parse(
                  //     CryptoJS.AES.decrypt(
                  //       localStorage.getItem("selectedCustomerType"),
                  //       process.env.REACT_APP_PASS
                  //     ).toString(CryptoJS.enc.Utf8)
                  //   ) === "Combined"
                  //     ? ""
                  //     : JSON.parse(
                  //         CryptoJS.AES.decrypt(
                  //           localStorage.getItem("globalFilter"),
                  //           process.env.REACT_APP_PASS
                  //         ).toString(CryptoJS.enc.Utf8)
                  //       )
                  // })`;
                }

                if (modelDecileConditionExists) {
                  modelDecileSelectedRule += `])) > 0 ${
                    this.decryptLocal("selectedCustomerType") === "Acquistion" ||
                    (this.decryptLocal("selectedCustomerType") === "Combined" &&
                      prospectConditionExists)
                      ? ""
                      : "AND"
                  } ${
                    this.decryptLocal("selectedCustomerType") === "Acquistion" ||
                    (this.decryptLocal("selectedCustomerType") === "Combined" &&
                      prospectConditionExists)
                      ? ""
                      : this.decryptLocal("globalFilter")
                  })`;
                } else if (
                  !modelDecileConditionExists &&
                  !samplingConditionExists
                ) {
                  nonModelDecileSelectedRule += `])) > 0 ${
                    this.decryptLocal("selectedCustomerType") === "Acquistion" ||
                    (this.decryptLocal("selectedCustomerType") === "Combined" &&
                      prospectConditionExists)
                      ? ""
                      : "AND"
                  } ${
                    this.decryptLocal("selectedCustomerType") === "Acquistion" ||
                    (this.decryptLocal("selectedCustomerType") === "Combined" &&
                      prospectConditionExists)
                      ? ""
                      : this.decryptLocal("globalFilter")
                  })`;
                }

                if (samplingConditionExists) {
                  samplingSelectedRule += `])) > 0 ${
                    this.decryptLocal("selectedCustomerType") === "Acquistion" ||
                    (this.decryptLocal("selectedCustomerType") === "Combined" &&
                      prospectConditionExists)
                      ? ""
                      : "AND"
                  } ${
                    this.decryptLocal("selectedCustomerType") === "Acquistion" ||
                    (this.decryptLocal("selectedCustomerType") === "Combined" &&
                      prospectConditionExists)
                      ? ""
                      : this.decryptLocal("globalFilter")
                  })`;
                }

                if (
                  ruleLeveltoggle.length > 0 &&
                  ruleLeveltoggle[index] !== undefined &&
                  ruleLeveltoggle[index][key] !== undefined
                ) {
                  sqlAndOrOperator = ruleLeveltoggle[index][key];
                  selectedRule += ` ${sqlAndOrOperator} `;
                  if (modelDecileConditionExists) {
                    modelDecileSelectedRule += ` ${sqlAndOrOperator} `;
                  } else if (
                    !modelDecileConditionExists &&
                    !samplingConditionExists
                  ) {
                    nonModelDecileSelectedRule += ` ${sqlAndOrOperator} `;
                  }

                  if (samplingConditionExists) {
                    samplingSelectedRule += ` ${sqlAndOrOperator} `;
                  }
                }
              } else {
                let num = result.value;
                selectedRule += ` '${result.value}', `;
                if (modelDecileConditionExists) {
                  modelDecileSelectedRule += ` '${result.value}', `;
                } else if (
                  !modelDecileConditionExists &&
                  !samplingConditionExists
                ) {
                  nonModelDecileSelectedRule += ` '${result.value}', `;
                }

                if (samplingConditionExists) {
                  samplingSelectedRule += ` '${result.value}', `;
                }
              }
            } else if (options[length - 1].value == "= ") {
              if (selectedCustomerType === "Customer") {
                selectedRule += ` ${result.value} AND ${this.decryptLocal("globalFilter")})`;
              } else {
                selectedRule += ` ${result.value})`;
                // selectedRule += ` ${result.value} ${
                //   JSON.parse(
                //     CryptoJS.AES.decrypt(
                //       localStorage.getItem("selectedCustomerType"),
                //       process.env.REACT_APP_PASS
                //     ).toString(CryptoJS.enc.Utf8)
                //   ) === "Acquistion" ||
                //   JSON.parse(
                //     CryptoJS.AES.decrypt(
                //       localStorage.getItem("selectedCustomerType"),
                //       process.env.REACT_APP_PASS
                //     ).toString(CryptoJS.enc.Utf8)
                //   ) === "Combined"
                //     ? ""
                //     : "AND"
                // } ${
                //   JSON.parse(
                //     CryptoJS.AES.decrypt(
                //       localStorage.getItem("selectedCustomerType"),
                //       process.env.REACT_APP_PASS
                //     ).toString(CryptoJS.enc.Utf8)
                //   ) === "Acquistion" ||
                //   JSON.parse(
                //     CryptoJS.AES.decrypt(
                //       localStorage.getItem("selectedCustomerType"),
                //       process.env.REACT_APP_PASS
                //     ).toString(CryptoJS.enc.Utf8)
                //   ) === "Combined"
                //     ? ""
                //     : JSON.parse(
                //         CryptoJS.AES.decrypt(
                //           localStorage.getItem("globalFilter"),
                //           process.env.REACT_APP_PASS
                //         ).toString(CryptoJS.enc.Utf8)
                //       )
                // })`;
              }
              if (modelDecileConditionExists) {
                modelDecileSelectedRule += ` ${result.value} ${
                  this.decryptLocal("selectedCustomerType") === "Acquistion" ||
                  this.decryptLocal("selectedCustomerType") === "Combined"
                    ? ""
                    : "AND"
                } ${
                  this.decryptLocal("selectedCustomerType") === "Acquistion" ||
                  this.decryptLocal("selectedCustomerType") === "Combined"
                    ? ""
                    : this.decryptLocal("globalFilter")
                })`;
              } else if (
                !modelDecileConditionExists &&
                !samplingConditionExists
              ) {
                nonModelDecileSelectedRule += ` ${result.value} ${
                  this.decryptLocal("selectedCustomerType") === "Acquistion" ||
                  this.decryptLocal("selectedCustomerType") === "Combined"
                    ? ""
                    : "AND"
                } ${
                  this.decryptLocal("selectedCustomerType") === "Acquistion" ||
                  this.decryptLocal("selectedCustomerType") === "Combined"
                    ? ""
                    : this.decryptLocal("globalFilter")
                })`;
              }

              if (samplingConditionExists) {
                samplingSelectedRule += ` ${result.value} ${
                  this.decryptLocal("selectedCustomerType") === "Acquistion" ||
                  this.decryptLocal("selectedCustomerType") === "Combined"
                    ? ""
                    : "AND"
                } ${
                  this.decryptLocal("selectedCustomerType") === "Acquistion" ||
                  this.decryptLocal("selectedCustomerType") === "Combined"
                    ? ""
                    : this.decryptLocal("globalFilter")
                })`;
              }
            } else {
              let num = result.value;
              if (
                options[length - 1].value === "BETWEEN" ||
                options[length - 1].value === "NOT BETWEEN"
              ) {
                if (selectedCustomerType === "Customer") {
                  selectedRule += ` ${result.value}) AND ${this.decryptLocal("globalFilter")}),`;
                } else {
                  selectedRule += ` ${result.value})),`;
                  // selectedRule += ` ${result.value}) ${
                  //   JSON.parse(
                  //     CryptoJS.AES.decrypt(
                  //       localStorage.getItem("selectedCustomerType"),
                  //       process.env.REACT_APP_PASS
                  //     ).toString(CryptoJS.enc.Utf8)
                  //   ) === "Acquistion" ||
                  //   JSON.parse(
                  //     CryptoJS.AES.decrypt(
                  //       localStorage.getItem("selectedCustomerType"),
                  //       process.env.REACT_APP_PASS
                  //     ).toString(CryptoJS.enc.Utf8)
                  //   ) === "Combined"
                  //     ? ""
                  //     : "AND"
                  // } ${
                  //   JSON.parse(
                  //     CryptoJS.AES.decrypt(
                  //       localStorage.getItem("selectedCustomerType"),
                  //       process.env.REACT_APP_PASS
                  //     ).toString(CryptoJS.enc.Utf8)
                  //   ) === "Acquistion" ||
                  //   JSON.parse(
                  //     CryptoJS.AES.decrypt(
                  //       localStorage.getItem("selectedCustomerType"),
                  //       process.env.REACT_APP_PASS
                  //     ).toString(CryptoJS.enc.Utf8)
                  //   ) === "Combined"
                  //     ? ""
                  //     : JSON.parse(
                  //         CryptoJS.AES.decrypt(
                  //           localStorage.getItem("globalFilter"),
                  //           process.env.REACT_APP_PASS
                  //         ).toString(CryptoJS.enc.Utf8)
                  //       )
                  // }),`;
                }
                if (modelDecileConditionExists) {
                  modelDecileSelectedRule += ` ${result.value}) ${
                    this.decryptLocal("selectedCustomerType") === "Acquistion" ||
                    (this.decryptLocal("selectedCustomerType") === "Combined" &&
                      prospectConditionExists)
                      ? ""
                      : "AND"
                  } ${
                    this.decryptLocal("selectedCustomerType") === "Acquistion" ||
                    (this.decryptLocal("selectedCustomerType") === "Combined" &&
                      prospectConditionExists)
                      ? ""
                      : this.decryptLocal("globalFilter")
                  }),`;
                } else if (
                  !modelDecileConditionExists &&
                  !samplingConditionExists
                ) {
                  nonModelDecileSelectedRule += ` ${result.value}) ${
                    this.decryptLocal("selectedCustomerType") === "Acquistion" ||
                    (this.decryptLocal("selectedCustomerType") === "Combined" &&
                      prospectConditionExists)
                      ? ""
                      : "AND"
                  } ${
                    this.decryptLocal("selectedCustomerType") === "Acquistion" ||
                    (this.decryptLocal("selectedCustomerType") === "Combined" &&
                      prospectConditionExists)
                      ? ""
                      : this.decryptLocal("globalFilter")
                  }),`;
                }
                if (samplingConditionExists) {
                  samplingSelectedRule += ` ${result.value}) ${
                    this.decryptLocal("selectedCustomerType") === "Acquistion" ||
                    (this.decryptLocal("selectedCustomerType") === "Combined" &&
                      prospectConditionExists)
                      ? ""
                      : "AND"
                  } ${
                    this.decryptLocal("selectedCustomerType") === "Acquistion" ||
                    (this.decryptLocal("selectedCustomerType") === "Combined" &&
                      prospectConditionExists)
                      ? ""
                      : this.decryptLocal("globalFilter")
                  }),`;
                }
              } else if (typeof num == "string") {
                if (selectedCustomerType === "Customer") {
                  selectedRule += ` '${result.value}' AND ${this.decryptLocal("globalFilter")}), `;
                } else {
                  selectedRule += ` '${result.value}'), `;
                  // selectedRule += ` ${result.value}) ${
                  //   JSON.parse(
                  //     CryptoJS.AES.decrypt(
                  //       localStorage.getItem("selectedCustomerType"),
                  //       process.env.REACT_APP_PASS
                  //     ).toString(CryptoJS.enc.Utf8)
                  //   ) === "Acquistion" ||
                  //   JSON.parse(
                  //     CryptoJS.AES.decrypt(
                  //       localStorage.getItem("selectedCustomerType"),
                  //       process.env.REACT_APP_PASS
                  //     ).toString(CryptoJS.enc.Utf8)
                  //   ) === "Combined"
                  //     ? ""
                  //     : "AND"
                  // } ${
                  //   JSON.parse(
                  //     CryptoJS.AES.decrypt(
                  //       localStorage.getItem("selectedCustomerType"),
                  //       process.env.REACT_APP_PASS
                  //     ).toString(CryptoJS.enc.Utf8)
                  //   ) === "Acquistion" ||
                  //   JSON.parse(
                  //     CryptoJS.AES.decrypt(
                  //       localStorage.getItem("selectedCustomerType"),
                  //       process.env.REACT_APP_PASS
                  //     ).toString(CryptoJS.enc.Utf8)
                  //   ) === "Combined"
                  //     ? ""
                  //     : JSON.parse(
                  //         CryptoJS.AES.decrypt(
                  //           localStorage.getItem("globalFilter"),
                  //           process.env.REACT_APP_PASS
                  //         ).toString(CryptoJS.enc.Utf8)
                  //       )
                  // }),`;
                }
              } else {
                if (selectedCustomerType === "Customer") {
                  selectedRule += ` ${result.value}  AND ${this.decryptLocal("globalFilter")}), `;
                } else {
                  selectedRule += ` ${result.value}), `;
                  // selectedRule += ` ${result.value}) ${
                  //   JSON.parse(
                  //     CryptoJS.AES.decrypt(
                  //       localStorage.getItem("selectedCustomerType"),
                  //       process.env.REACT_APP_PASS
                  //     ).toString(CryptoJS.enc.Utf8)
                  //   ) === "Acquistion" ||
                  //   JSON.parse(
                  //     CryptoJS.AES.decrypt(
                  //       localStorage.getItem("selectedCustomerType"),
                  //       process.env.REACT_APP_PASS
                  //     ).toString(CryptoJS.enc.Utf8)
                  //   ) === "Combined"
                  //     ? ""
                  //     : "AND"
                  // } ${
                  //   JSON.parse(
                  //     CryptoJS.AES.decrypt(
                  //       localStorage.getItem("selectedCustomerType"),
                  //       process.env.REACT_APP_PASS
                  //     ).toString(CryptoJS.enc.Utf8)
                  //   ) === "Acquistion" ||
                  //   JSON.parse(
                  //     CryptoJS.AES.decrypt(
                  //       localStorage.getItem("selectedCustomerType"),
                  //       process.env.REACT_APP_PASS
                  //     ).toString(CryptoJS.enc.Utf8)
                  //   ) === "Combined"
                  //     ? ""
                  //     : JSON.parse(
                  //         CryptoJS.AES.decrypt(
                  //           localStorage.getItem("globalFilter"),
                  //           process.env.REACT_APP_PASS
                  //         ).toString(CryptoJS.enc.Utf8)
                  //       )
                  // }),`;
                }

                if (modelDecileConditionExists) {
                  modelDecileSelectedRule += ` ${result.value} ${
                    this.decryptLocal("selectedCustomerType") === "Acquistion" ||
                    (this.decryptLocal("selectedCustomerType") === "Combined" &&
                      prospectConditionExists)
                      ? ""
                      : "AND"
                  } ${
                    this.decryptLocal("selectedCustomerType") === "Acquistion" ||
                    (this.decryptLocal("selectedCustomerType") === "Combined" &&
                      prospectConditionExists)
                      ? ""
                      : this.decryptLocal("globalFilter")
                  }),`;
                } else if (
                  !modelDecileConditionExists &&
                  !samplingConditionExists
                ) {
                  nonModelDecileSelectedRule += ` ${result.value} ${
                    this.decryptLocal("selectedCustomerType") === "Acquistion" ||
                    (this.decryptLocal("selectedCustomerType") === "Combined" &&
                      prospectConditionExists)
                      ? ""
                      : "AND"
                  } ${
                    this.decryptLocal("selectedCustomerType") === "Acquistion" ||
                    (this.decryptLocal("selectedCustomerType") === "Combined" &&
                      prospectConditionExists)
                      ? ""
                      : this.decryptLocal("globalFilter")
                  }),`;
                }

                if (samplingConditionExists) {
                  samplingSelectedRule += ` ${result.value} ${
                    this.decryptLocal("selectedCustomerType") === "Acquistion" ||
                    (this.decryptLocal("selectedCustomerType") === "Combined" &&
                      prospectConditionExists)
                      ? ""
                      : "AND"
                  } ${
                    this.decryptLocal("selectedCustomerType") === "Acquistion" ||
                    (this.decryptLocal("selectedCustomerType") === "Combined" &&
                      prospectConditionExists)
                      ? ""
                      : this.decryptLocal("globalFilter")
                  }),`;
                }
              }
              selectedRule = selectedRule.replace(/,(\s+)?$/, "");
              if (modelDecileConditionExists) {
                modelDecileSelectedRule = modelDecileSelectedRule.replace(
                  /,(\s+)?$/,
                  ""
                );
              } else if (
                !modelDecileConditionExists &&
                !samplingConditionExists
              ) {
                nonModelDecileSelectedRule = nonModelDecileSelectedRule.replace(
                  /,(\s+)?$/,
                  ""
                );
              }

              if (samplingConditionExists) {
                samplingSelectedRule = samplingSelectedRule.replace(
                  /,(\s+)?$/,
                  ""
                );
              }
              if (
                ruleLeveltoggle.length > 0 &&
                key !== resultData.length - 1 &&
                ruleLeveltoggle[index] !== undefined &&
                ruleLeveltoggle[index][key] !== undefined
              ) {
                sqlAndOrOperator = ruleLeveltoggle[index][key];
                selectedRule += ` ${sqlAndOrOperator} `;
                if (modelDecileConditionExists) {
                  modelDecileSelectedRule += ` ${sqlAndOrOperator} `;
                } else if (
                  !modelDecileConditionExists &&
                  !samplingConditionExists
                ) {
                  nonModelDecileSelectedRule += ` ${sqlAndOrOperator} `;
                }

                if (samplingConditionExists) {
                  samplingSelectedRule += ` ${sqlAndOrOperator} `;
                }
              }
            }
          });
        }
      });
      selectedRule += `)`;
      sqlAndOrOperator = "";
      if (
        groupLeveltoggle.length > 0 &&
        this.props.cust_tillSqlSelectionArr.length - 1 != index &&
        groupLeveltoggle[0] != undefined &&
        groupLeveltoggle[0][index] != undefined
      ) {
        sqlAndOrOperator = groupLeveltoggle[0][index];
        selectedRule += ` ${sqlAndOrOperator} `;
        if (selectedCustomerType === "Acquistion") {
          if (modelDecileConditionExists) {
            modelDecileSelectedRule += ` ${sqlAndOrOperator} `;
          } else if (!modelDecileConditionExists && !samplingConditionExists) {
            nonModelDecileSelectedRule += ` ${sqlAndOrOperator} `;
          }

          if (samplingConditionExists) {
            samplingSelectedRule += ` ${sqlAndOrOperator} `;
          }
        }
      }
      selectedRule = selectedRule.replace(/,(\s+)?$/, "");
      if (modelDecileConditionExists) {
        modelDecileSelectedRule = modelDecileSelectedRule.replace(
          /,(\s+)?$/,
          ""
        );
      } else if (!modelDecileConditionExists && !samplingConditionExists) {
        nonModelDecileSelectedRule = nonModelDecileSelectedRule.replace(
          /,(\s+)?$/,
          ""
        );
      }

      if (samplingConditionExists) {
        samplingSelectedRule = samplingSelectedRule.replace(/,(\s+)?$/, "");
      }
    });

    // Delivery File Suppression Changes
    if (automationIdOrListId != null || automationIdOrListId !== "") {
      if (
        this.decryptLocal("model") === "restaurant_v3"
      ) {
        let currDb = this.decryptLocal("custDb")
        // IN
        let currRegex = /\( *li\.list_id +IN *\((.*?)\)/g;
        let currMatch = (' ' + selectedRule).slice(1).match(currRegex);
        let singleRegex, currAutomation
        if (currMatch) {
          let singleRegex = /\( *li\.list_id +IN *\((.*?)\)/;
          for(let idx in currMatch) {
            currAutomation = (' ' + currMatch[idx]).slice(1).match(singleRegex)
            selectedRule = selectedRule.replace(
              singleRegex,
              // Replace With
              "(ca.cust_id IN" +
                "(" + 
                  "SELECT cust_id from " +
                  currDb + ".deliveries where delivery_id IN " +
                  "(" +
                    "select delivery_id " +
                    "from " + currDb + ".cmp_deliveries " + 
                    "where automation_id in ("+currAutomation[1]+")" +
                  ")" + 
                ")"
            );
          }
        }
        
        // NOT IN
        currRegex = /\( *li\.list_id +NOT +IN *\((.*?)\)/g;
        currMatch = (' ' + selectedRule).slice(1).match(currRegex);
        if (currMatch) {
          singleRegex = /\( *li\.list_id +NOT +IN *\((.*?)\)/;
          for(let idx in currMatch) {
            currAutomation = (' ' + currMatch[idx]).slice(1).match(singleRegex)
            selectedRule = selectedRule.replace(
              singleRegex,
              // Replace With
              "(ca.cust_id NOT IN" +
                "(" + 
                  "SELECT cust_id from " +
                  currDb + ".deliveries where delivery_id IN " +
                  "(" +
                    "select delivery_id " +
                    "from " + currDb + ".cmp_deliveries " + 
                    "where automation_id in ("+currAutomation[1]+")" +
                  ")" + 
                ")"
            );
          }
        }
      }
    }

    let originaltext = selectedRule;
    let test = originaltext
      .split(
        "(ca.cust_id IN (select cust_id from goodwill_refined.loyalty where loyalty_id IN(select customer_id from goodwill_source.tb_coupon where coupon_id NOT IN (select coupon_id from goodwill_source.tb_coupon_used) AND date(date_parse(act_date, '%c/%e/%Y %r')) <= current_date AND date(date_parse(deact_time, '%c/%e/%Y %r')) = date_add('day',{daysFromExpiration},current_date) AND orig_template_id = '{offerCode}')) = "
      )
      .pop();
    let final = test.replace(")", "");
    let test1 = final
      .replaceAll("'", "")
      .split("THEN")[0]
      .split("AND")[0];
    let test2 = final
      .replaceAll("'", "")
      .split("THEN")[0]
      .split("AND")[1];

    if (test1 !== "" && test1 !== undefined) {
      test1 = test1.trim();
    }

    if (test2 !== "" && test2 !== undefined) {
      test2 = test2.trim();
    }

    if (test1 !== null && test2 !== null) {
      selectedRule = selectedRule.replace(
        `ca.cust_id IN (select cust_id from goodwill_refined.loyalty where loyalty_id IN(select customer_id from goodwill_source.tb_coupon where coupon_id NOT IN (select coupon_id from goodwill_source.tb_coupon_used) AND date(date_parse(act_date, '%c/%e/%Y %r')) <= current_date AND date(date_parse(deact_time, '%c/%e/%Y %r')) = date_add('day',{daysFromExpiration},current_date) AND orig_template_id = '{offerCode}')) = '${test1} AND ${test2}'`,
        `ca.cust_id IN (select cust_id from goodwill_refined.loyalty where loyalty_id IN(select customer_id from goodwill_source.tb_coupon where coupon_id NOT IN (select coupon_id from goodwill_source.tb_coupon_used) AND date(date_parse(act_date, '%c/%e/%Y %r')) <= current_date AND date(date_parse(deact_time, '%c/%e/%Y %r')) = date_add('day',${test2},current_date) AND orig_template_id = '${test1}'))`
      );
    }

    selectedRule = selectedRule.replace(
      "((menu_sub_category = 'item_hier_1 = '5' and item_hier_2 = '26'' AND ca.geo_concept = '1'))",
      "((ca.cust_id in (select cust_id from fridays_refined.trans_pay where trans_id in (select trans_id from fridays_refined.trans_detail where item_id in (select item_id from fridays_refined.item where item_hier_1 = '5' and item_hier_2 = '26'))) AND ca.geo_concept = '1'))"
    );

    selectedRule = selectedRule.replace(
      "((menu_sub_category = 'item_hier_1 = '13' and item_hier_2 = '1'' AND ca.geo_concept = '1'))",
      "((ca.cust_id in (select cust_id from fridays_refined.trans_pay where trans_id in (select trans_id from fridays_refined.trans_detail where item_id in (select item_id from fridays_refined.item where item_hier_1 = '13' and item_hier_2 = '1'))) AND ca.geo_concept = '1'))"
    );

    selectedRule = selectedRule.replace(
      "((menu_sub_category = 'item_hier_1 = '13' and item_hier_2 = '22'' AND ca.geo_concept = '1'))",
      "((ca.cust_id in (select cust_id from fridays_refined.trans_pay where trans_id in (select trans_id from fridays_refined.trans_detail where item_id in (select item_id from fridays_refined.item where item_hier_1 = '13' and item_hier_2 = '22'))) AND ca.geo_concept = '1'))"
    );

    selectedRule = selectedRule.replace(
      "((menu_sub_category = 'item_hier_1 = '18' and item_hier_2 = '265'' AND ca.geo_concept = '1'))",
      "((ca.cust_id in (select cust_id from fridays_refined.trans_pay where trans_id in (select trans_id from fridays_refined.trans_detail where item_id in (select item_id from fridays_refined.item where item_hier_1 = '18' and item_hier_2 = '265'))) AND ca.geo_concept = '1'))"
    );

    selectedRule = selectedRule.replace(
      "((menu_sub_category = 'item_hier_1 = '13' and item_hier_2 = '293'' AND ca.geo_concept = '1'))",
      "((ca.cust_id in (select cust_id from fridays_refined.trans_pay where trans_id in (select trans_id from fridays_refined.trans_detail where item_id in (select item_id from fridays_refined.item where item_hier_1 = '13' and item_hier_2 = '293'))) AND ca.geo_concept = '1'))"
    );

    selectedRule = selectedRule.replace(
      "((menu_sub_category = 'item_hier_1 = '5' and item_hier_2 = '6'' AND ca.geo_concept = '1'))",
      "((ca.cust_id in (select cust_id from fridays_refined.trans_pay where trans_id in (select trans_id from fridays_refined.trans_detail where item_id in (select item_id from fridays_refined.item where item_hier_1 = '5' and item_hier_2 = '6'))) AND ca.geo_concept = '1'))"
    );

    selectedRule = selectedRule.replace(
      "((menu_sub_category = 'item_hier_1 = '13' and item_hier_2 = '400'' AND ca.geo_concept = '1'))",
      "((ca.cust_id in (select cust_id from fridays_refined.trans_pay where trans_id in (select trans_id from fridays_refined.trans_detail where item_id in (select item_id from fridays_refined.item where item_hier_1 = '13' and item_hier_2 = '400'))) AND ca.geo_concept = '1'))"
    );

    selectedRule = selectedRule.replace(
      "((menu_sub_category = 'item_hier_1 = '5' and item_hier_2 = '32'' AND ca.geo_concept = '1'))",
      "((ca.cust_id in (select cust_id from fridays_refined.trans_pay where trans_id in (select trans_id from fridays_refined.trans_detail where item_id in (select item_id from fridays_refined.item where item_hier_1 = '5' and item_hier_2 = '32'))) AND ca.geo_concept = '1'))"
    );

    selectedRule = selectedRule.replace(
      "((menu_sub_category = 'item_hier_1 = '18' and item_hier_2 = '266'' AND ca.geo_concept = '1'))",
      "((ca.cust_id in (select cust_id from fridays_refined.trans_pay where trans_id in (select trans_id from fridays_refined.trans_detail where item_id in (select item_id from fridays_refined.item where item_hier_1 = '18' and item_hier_2 = '266'))) AND ca.geo_concept = '1'))"
    );

    selectedRule = selectedRule.replace(
      "((menu_sub_category = 'item_hier_1 = '13' and item_hier_2 = '20'' AND ca.geo_concept = '1'))",
      "((ca.cust_id in (select cust_id from fridays_refined.trans_pay where trans_id in (select trans_id from fridays_refined.trans_detail where item_id in (select item_id from fridays_refined.item where item_hier_1 = '13' and item_hier_2 = '20'))) AND ca.geo_concept = '1'))"
    );

    selectedRule = selectedRule.replace(
      "((menu_sub_category = 'item_hier_1 = '13' and item_hier_2 = '244'' AND ca.geo_concept = '1'))",
      "((ca.cust_id in (select cust_id from fridays_refined.trans_pay where trans_id in (select trans_id from fridays_refined.trans_detail where item_id in (select item_id from fridays_refined.item where item_hier_1 = '13' and item_hier_2 = '244'))) AND ca.geo_concept = '1'))"
    );

    selectedRule = selectedRule.replace(
      "((menu_sub_category = 'item_hier_1 = '18' and item_hier_2 = '251'' AND ca.geo_concept = '1'))",
      "((ca.cust_id in (select cust_id from fridays_refined.trans_pay where trans_id in (select trans_id from fridays_refined.trans_detail where item_id in (select item_id from fridays_refined.item where item_hier_1 = '18' and item_hier_2 = '251'))) AND ca.geo_concept = '1'))"
    );

    selectedRule = selectedRule.replace(
      "((menu_sub_category = 'item_hier_1 = '13' and item_hier_2 = '33'' AND ca.geo_concept = '1'))",
      "((ca.cust_id in (select cust_id from fridays_refined.trans_pay where trans_id in (select trans_id from fridays_refined.trans_detail where item_id in (select item_id from fridays_refined.item where item_hier_1 = '13' and item_hier_2 = '33'))) AND ca.geo_concept = '1'))"
    );

    selectedRule = selectedRule.replace(
      "((menu_sub_category = 'item_hier_1 = '18' and item_hier_2 = '312'' AND ca.geo_concept = '1'))",
      "((ca.cust_id in (select cust_id from fridays_refined.trans_pay where trans_id in (select trans_id from fridays_refined.trans_detail where item_id in (select item_id from fridays_refined.item where item_hier_1 = '18' and item_hier_2 = '312'))) AND ca.geo_concept = '1'))"
    );

    selectedRule = selectedRule.replace(
      "((menu_sub_category = 'item_hier_1 = '13' and item_hier_2 = '36'' AND ca.geo_concept = '1'))",
      "((ca.cust_id in (select cust_id from fridays_refined.trans_pay where trans_id in (select trans_id from fridays_refined.trans_detail where item_id in (select item_id from fridays_refined.item where item_hier_1 = '13' and item_hier_2 = '36'))) AND ca.geo_concept = '1'))"
    );

    selectedRule = selectedRule.replace(
      "((menu_sub_category = 'item_hier_1 = '13' and item_hier_2 = '35'' AND ca.geo_concept = '1'))",
      "((ca.cust_id in (select cust_id from fridays_refined.trans_pay where trans_id in (select trans_id from fridays_refined.trans_detail where item_id in (select item_id from fridays_refined.item where item_hier_1 = '13' and item_hier_2 = '35'))) AND ca.geo_concept = '1'))"
    );

    selectedRule = selectedRule.replace(
      "((menu_sub_category = 'item_hier_1 = '13' and item_hier_2 = '250'' AND ca.geo_concept = '1'))",
      "((ca.cust_id in (select cust_id from fridays_refined.trans_pay where trans_id in (select trans_id from fridays_refined.trans_detail where item_id in (select item_id from fridays_refined.item where item_hier_1 = '13' and item_hier_2 = '250'))) AND ca.geo_concept = '1'))"
    );

    selectedRule = selectedRule.replace(
      "((menu_sub_category = 'item_hier_1 = '13' and item_hier_2 = '277'' AND ca.geo_concept = '1'))",
      "((ca.cust_id in (select cust_id from fridays_refined.trans_pay where trans_id in (select trans_id from fridays_refined.trans_detail where item_id in (select item_id from fridays_refined.item where item_hier_1 = '13' and item_hier_2 = '277'))) AND ca.geo_concept = '1'))"
    );

    selectedRule = selectedRule.replace(
      "((menu_sub_category = 'item_hier_1 = '38' and item_hier_2 = '27'' AND ca.geo_concept = '1'))",
      "((ca.cust_id in (select cust_id from fridays_refined.trans_pay where trans_id in (select trans_id from fridays_refined.trans_detail where item_id in (select item_id from fridays_refined.item where item_hier_1 = '38' and item_hier_2 = '27'))) AND ca.geo_concept = '1'))"
    );

    selectedRule = selectedRule.replace(
      "((menu_sub_category = 'item_hier_1 = '18' and item_hier_2 = '268'' AND ca.geo_concept = '1'))",
      "((ca.cust_id in (select cust_id from fridays_refined.trans_pay where trans_id in (select trans_id from fridays_refined.trans_detail where item_id in (select item_id from fridays_refined.item where item_hier_1 = '18' and item_hier_2 = '268'))) AND ca.geo_concept = '1'))"
    );

    selectedRule = selectedRule.replace(
      "((menu_sub_category = 'item_hier_1 = '18' and item_hier_2 = '252'' AND ca.geo_concept = '1'))",
      "((ca.cust_id in (select cust_id from fridays_refined.trans_pay where trans_id in (select trans_id from fridays_refined.trans_detail where item_id in (select item_id from fridays_refined.item where item_hier_1 = '18' and item_hier_2 = '252'))) AND ca.geo_concept = '1'))"
    );

    selectedRule = selectedRule.replace(
      "((menu_sub_category = 'item_hier_1 = '38' and item_hier_2 = '16'' AND ca.geo_concept = '1'))",
      "((ca.cust_id in (select cust_id from fridays_refined.trans_pay where trans_id in (select trans_id from fridays_refined.trans_detail where item_id in (select item_id from fridays_refined.item where item_hier_1 = '38' and item_hier_2 = '16'))) AND ca.geo_concept = '1'))"
    );

    selectedRule = selectedRule.replace(
      "((menu_sub_category = 'item_hier_1 = '13' and item_hier_2 = '10'' AND ca.geo_concept = '1'))",
      "((ca.cust_id in (select cust_id from fridays_refined.trans_pay where trans_id in (select trans_id from fridays_refined.trans_detail where item_id in (select item_id from fridays_refined.item where item_hier_1 = '13' and item_hier_2 = '10'))) AND ca.geo_concept = '1'))"
    );

    selectedRule = selectedRule.replace(
      "((menu_sub_category = 'item_hier_1 = '13' and item_hier_2 = '285'' AND ca.geo_concept = '1'))",
      "((ca.cust_id in (select cust_id from fridays_refined.trans_pay where trans_id in (select trans_id from fridays_refined.trans_detail where item_id in (select item_id from fridays_refined.item where item_hier_1 = '13' and item_hier_2 = '285'))) AND ca.geo_concept = '1'))"
    );

    selectedRule = selectedRule.replace(
      "((menu_sub_category = 'item_hier_1 = '13' and item_hier_2 = '2'' AND ca.geo_concept = '1'))",
      "((ca.cust_id in (select cust_id from fridays_refined.trans_pay where trans_id in (select trans_id from fridays_refined.trans_detail where item_id in (select item_id from fridays_refined.item where item_hier_1 = '13' and item_hier_2 = '2'))) AND ca.geo_concept = '1'))"
    );

    selectedRule = selectedRule.replace(
      "((menu_sub_category = 'item_hier_1 = '13' and item_hier_2 = '248'' AND ca.geo_concept = '1'))",
      "((ca.cust_id in (select cust_id from fridays_refined.trans_pay where trans_id in (select trans_id from fridays_refined.trans_detail where item_id in (select item_id from fridays_refined.item where item_hier_1 = '13' and item_hier_2 = '248'))) AND ca.geo_concept = '1'))"
    );

    selectedRule = selectedRule.replace(
      "((menu_sub_category = 'item_hier_1 = '13' and item_hier_2 = '323'' AND ca.geo_concept = '1'))",
      "((ca.cust_id in (select cust_id from fridays_refined.trans_pay where trans_id in (select trans_id from fridays_refined.trans_detail where item_id in (select item_id from fridays_refined.item where item_hier_1 = '13' and item_hier_2 = '323'))) AND ca.geo_concept = '1'))"
    );
    selectedRule = selectedRule.replace(
      "((menu_sub_category = 'item_hier_1 = '13' and item_hier_2 = '888'' AND ca.geo_concept = '1'))",
      "((ca.cust_id in (select cust_id from fridays_refined.trans_pay where trans_id in (select trans_id from fridays_refined.trans_detail where item_id in (select item_id from fridays_refined.item where item_hier_1 = '13' and item_hier_2 = '888'))) AND ca.geo_concept = '1'))"
    );
    selectedRule = selectedRule.replace(
      "((menu_sub_category = 'item_hier_1 = '13' and item_hier_2 = '242'' AND ca.geo_concept = '1'))",
      "((ca.cust_id in (select cust_id from fridays_refined.trans_pay where trans_id in (select trans_id from fridays_refined.trans_detail where item_id in (select item_id from fridays_refined.item where item_hier_1 = '13' and item_hier_2 = '242'))) AND ca.geo_concept = '1'))"
    );
    selectedRule = selectedRule.replace(
      "((menu_sub_category = 'item_hier_1 = '13' and item_hier_2 = '245'' AND ca.geo_concept = '1'))",
      "((ca.cust_id in (select cust_id from fridays_refined.trans_pay where trans_id in (select trans_id from fridays_refined.trans_detail where item_id in (select item_id from fridays_refined.item where item_hier_1 = '13' and item_hier_2 = '245'))) AND ca.geo_concept = '1'))"
    );
    selectedRule = selectedRule.replace(
      "((menu_sub_category = 'item_hier_1 = '18' and item_hier_2 = '267'' AND ca.geo_concept = '1'))",
      "((ca.cust_id in (select cust_id from fridays_refined.trans_pay where trans_id in (select trans_id from fridays_refined.trans_detail where item_id in (select item_id from fridays_refined.item where item_hier_1 = '18' and item_hier_2 = '267'))) AND ca.geo_concept = '1'))"
    );
    selectedRule = selectedRule.replace(
      "((menu_sub_category = 'item_hier_1 = '13' and item_hier_2 = '249'' AND ca.geo_concept = '1'))",
      "((ca.cust_id in (select cust_id from fridays_refined.trans_pay where trans_id in (select trans_id from fridays_refined.trans_detail where item_id in (select item_id from fridays_refined.item where item_hier_1 = '13' and item_hier_2 = '249'))) AND ca.geo_concept = '1'))"
    );
    selectedRule = selectedRule.replace(
      "((menu_sub_category = 'item_hier_1 = '27' and item_hier_2 = '23'' AND ca.geo_concept = '1'))",
      "((ca.cust_id in (select cust_id from fridays_refined.trans_pay where trans_id in (select trans_id from fridays_refined.trans_detail where item_id in (select item_id from fridays_refined.item where item_hier_1 = '27' and item_hier_2 = '23'))) AND ca.geo_concept = '1'))"
    );
    selectedRule = selectedRule.replace(
      "((menu_sub_category = 'item_hier_1 = '13' and item_hier_2 = '278'' AND ca.geo_concept = '1'))",
      "((ca.cust_id in (select cust_id from fridays_refined.trans_pay where trans_id in (select trans_id from fridays_refined.trans_detail where item_id in (select item_id from fridays_refined.item where item_hier_1 = '13' and item_hier_2 = '278'))) AND ca.geo_concept = '1'))"
    );
    selectedRule = selectedRule.replace(
      "((menu_sub_category = 'item_hier_1 = '13' and item_hier_2 = '19'' AND ca.geo_concept = '1'))",
      "((ca.cust_id in (select cust_id from fridays_refined.trans_pay where trans_id in (select trans_id from fridays_refined.trans_detail where item_id in (select item_id from fridays_refined.item where item_hier_1 = '13' and item_hier_2 = '19'))) AND ca.geo_concept = '1'))"
    );
    selectedRule = selectedRule.replace(
      "((menu_sub_category = 'item_hier_1 = '38' and item_hier_2 = '16'' AND ca.geo_concept = '1'))",
      "((ca.cust_id in (select cust_id from fridays_refined.trans_pay where trans_id in (select trans_id from fridays_refined.trans_detail where item_id in (select item_id from fridays_refined.item where item_hier_1 = '38' and item_hier_2 = '16'))) AND ca.geo_concept = '1'))"
    );
    selectedRule = selectedRule.replace(
      "((menu_sub_category = 'item_hier_1 = '5' and item_hier_2 = '348'' AND ca.geo_concept = '1'))",
      "((ca.cust_id in (select cust_id from fridays_refined.trans_pay where trans_id in (select trans_id from fridays_refined.trans_detail where item_id in (select item_id from fridays_refined.item where item_hier_1 = '5' and item_hier_2 = '348'))) AND ca.geo_concept = '1'))"
    );
    selectedRule = selectedRule.replace(
      "((menu_sub_category = 'item_hier_1 = '13' and item_hier_2 = '1'' AND ca.geo_concept = '1'))",
      "((ca.cust_id in (select cust_id from fridays_refined.trans_pay where trans_id in (select trans_id from fridays_refined.trans_detail where item_id in (select item_id from fridays_refined.item where item_hier_1 = '13' and item_hier_2 = '1'))) AND ca.geo_concept = '1'))"
    );
    selectedRule = selectedRule.replace(
      "((menu_sub_category = 'item_hier_1 = '13' and item_hier_2 = '31'' AND ca.geo_concept = '1'))",
      "((ca.cust_id in (select cust_id from fridays_refined.trans_pay where trans_id in (select trans_id from fridays_refined.trans_detail where item_id in (select item_id from fridays_refined.item where item_hier_1 = '13' and item_hier_2 = '31'))) AND ca.geo_concept = '1'))"
    );
    selectedRule = selectedRule.replace(
      "((menu_sub_category = 'item_hier_1 = '5' and item_hier_2 = '269'' AND ca.geo_concept = '1'))",
      "((ca.cust_id in (select cust_id from fridays_refined.trans_pay where trans_id in (select trans_id from fridays_refined.trans_detail where item_id in (select item_id from fridays_refined.item where item_hier_1 = '5' and item_hier_2 = '269'))) AND ca.geo_concept = '1'))"
    );

    // Friday's Redemption Filter changes

    selectedRule = selectedRule.replace(
      "((ca.cust_id in (select distinct cust_id from fridays_refined.loyalty_checkins where points_spent > 0 and trans_dt >= current_date - interval '30' day) = false  AND ca.geo_concept = '1'))",
      "((ca.cust_id in (select distinct cust_id from fridays_refined.loyalty_checkins where points_spent = 0 and trans_dt >= current_date - interval '30' day) AND ca.geo_concept = '1'))"
    );

    selectedRule = selectedRule.replace(
      "((ca.cust_id in (select distinct cust_id from fridays_refined.loyalty_checkins where points_spent > 0 and trans_dt >= current_date - interval '30' day) = true  AND ca.geo_concept = '1'))",
      "((ca.cust_id in (select distinct cust_id from fridays_refined.loyalty_checkins where points_spent > 0 and trans_dt >= current_date - interval '30' day) AND ca.geo_concept = '1'))"
    );

    selectedRule = selectedRule.replace(
      "((ca.cust_id in (select distinct cust_id from fridays_refined.loyalty_checkins where points_spent > 0 and trans_dt >= current_date - interval '60' day) = false  AND ca.geo_concept = '1'))",
      "((ca.cust_id in (select distinct cust_id from fridays_refined.loyalty_checkins where points_spent = 0 and trans_dt >= current_date - interval '60' day) AND ca.geo_concept = '1'))"
    );

    selectedRule = selectedRule.replace(
      "((ca.cust_id in (select distinct cust_id from fridays_refined.loyalty_checkins where points_spent > 0 and trans_dt >= current_date - interval '60' day) = true  AND ca.geo_concept = '1'))",
      "((ca.cust_id in (select distinct cust_id from fridays_refined.loyalty_checkins where points_spent > 0 and trans_dt >= current_date - interval '60' day) AND ca.geo_concept = '1'))"
    );

    selectedRule = selectedRule.replace(
      "((ca.cust_id in (select distinct cust_id from fridays_refined.loyalty_checkins where points_spent > 0 and trans_dt >= current_date - interval '90' day) = false  AND ca.geo_concept = '1'))",
      "((ca.cust_id in (select distinct cust_id from fridays_refined.loyalty_checkins where points_spent = 0 and trans_dt >= current_date - interval '90' day) AND ca.geo_concept = '1'))"
    );

    selectedRule = selectedRule.replace(
      "((ca.cust_id in (select distinct cust_id from fridays_refined.loyalty_checkins where points_spent > 0 and trans_dt >= current_date - interval '90' day) = true  AND ca.geo_concept = '1'))",
      "((ca.cust_id in (select distinct cust_id from fridays_refined.loyalty_checkins where points_spent > 0 and trans_dt >= current_date - interval '90' day) AND ca.geo_concept = '1'))"
    );

    selectedRule = selectedRule.replace(
      "((ca.cust_id in (select distinct cust_id from fridays_refined.loyalty_checkins where points_spent > 0 and trans_dt >= current_date - interval '180' day) = false  AND ca.geo_concept = '1'))",
      "((ca.cust_id in (select distinct cust_id from fridays_refined.loyalty_checkins where points_spent = 0 and trans_dt >= current_date - interval '180' day) AND ca.geo_concept = '1'))"
    );

    selectedRule = selectedRule.replace(
      "((ca.cust_id in (select distinct cust_id from fridays_refined.loyalty_checkins where points_spent > 0 and trans_dt >= current_date - interval '180' day) = true  AND ca.geo_concept = '1'))",
      "((ca.cust_id in (select distinct cust_id from fridays_refined.loyalty_checkins where points_spent > 0 and trans_dt >= current_date - interval '180' day) AND ca.geo_concept = '1'))"
    );

    selectedRule = selectedRule.replace(
      "((ca.cust_id in (select distinct cust_id from fridays_refined.loyalty_checkins where points_spent > 0 and trans_dt >= current_date - interval '365' day) = false  AND ca.geo_concept = '1'))",
      "((ca.cust_id in (select distinct cust_id from fridays_refined.loyalty_checkins where points_spent = 0 and trans_dt >= current_date - interval '365' day) AND ca.geo_concept = '1'))"
    );

    selectedRule = selectedRule.replace(
      "((ca.cust_id in (select distinct cust_id from fridays_refined.loyalty_checkins where points_spent > 0 and trans_dt >= current_date - interval '365' day) = true  AND ca.geo_concept = '1'))",
      "((ca.cust_id in (select distinct cust_id from fridays_refined.loyalty_checkins where points_spent > 0 and trans_dt >= current_date - interval '365' day) AND ca.geo_concept = '1'))"
    );

    // Friday's Discount Sales Filter changes

    selectedRule = selectedRule.replace(
      "((ca.cust_id in (select distinct cust_id from fridays_refined.trans_pay where pay_disc_amt > 0 and cust_id is not null and trans_dt >= current_date - interval '30' day) = false  AND ca.geo_concept = '1'))",
      "((ca.cust_id in (select distinct cust_id from fridays_refined.trans_pay where pay_disc_amt = 0 and cust_id is not null and trans_dt >= current_date - interval '30' day) AND ca.geo_concept = '1'))"
    );

    selectedRule = selectedRule.replace(
      "((ca.cust_id in (select distinct cust_id from fridays_refined.trans_pay where pay_disc_amt > 0 and cust_id is not null and trans_dt >= current_date - interval '30' day) = true  AND ca.geo_concept = '1'))",
      "((ca.cust_id in (select distinct cust_id from fridays_refined.trans_pay where pay_disc_amt > 0 and cust_id is not null and trans_dt >= current_date - interval '30' day) AND ca.geo_concept = '1'))"
    );

    selectedRule = selectedRule.replace(
      "((ca.cust_id in (select distinct cust_id from fridays_refined.trans_pay where pay_disc_amt > 0 and cust_id is not null and trans_dt >= current_date - interval '60' day) = false  AND ca.geo_concept = '1'))",
      "((ca.cust_id in (select distinct cust_id from fridays_refined.trans_pay where pay_disc_amt = 0 and cust_id is not null and trans_dt >= current_date - interval '60' day) AND ca.geo_concept = '1'))"
    );

    selectedRule = selectedRule.replace(
      "((ca.cust_id in (select distinct cust_id from fridays_refined.trans_pay where pay_disc_amt > 0 and cust_id is not null and trans_dt >= current_date - interval '60' day) = true  AND ca.geo_concept = '1'))",
      "((ca.cust_id in (select distinct cust_id from fridays_refined.trans_pay where pay_disc_amt > 0 and cust_id is not null and trans_dt >= current_date - interval '60' day) AND ca.geo_concept = '1'))"
    );

    selectedRule = selectedRule.replace(
      "((ca.cust_id in (select distinct cust_id from fridays_refined.trans_pay where pay_disc_amt > 0 and cust_id is not null and trans_dt >= current_date - interval '90' day) = false  AND ca.geo_concept = '1'))",
      "((ca.cust_id in (select distinct cust_id from fridays_refined.trans_pay where pay_disc_amt = 0 and cust_id is not null and trans_dt >= current_date - interval '90' day) AND ca.geo_concept = '1'))"
    );

    selectedRule = selectedRule.replace(
      "((ca.cust_id in (select distinct cust_id from fridays_refined.trans_pay where pay_disc_amt > 0 and cust_id is not null and trans_dt >= current_date - interval '90' day) = true  AND ca.geo_concept = '1'))",
      "((ca.cust_id in (select distinct cust_id from fridays_refined.trans_pay where pay_disc_amt > 0 and cust_id is not null and trans_dt >= current_date - interval '90' day) AND ca.geo_concept = '1'))"
    );

    selectedRule = selectedRule.replace(
      "((ca.cust_id in (select distinct cust_id from fridays_refined.trans_pay where pay_disc_amt > 0 and cust_id is not null and trans_dt >= current_date - interval '180' day) = false  AND ca.geo_concept = '1'))",
      "((ca.cust_id in (select distinct cust_id from fridays_refined.trans_pay where pay_disc_amt = 0 and cust_id is not null and trans_dt >= current_date - interval '180' day) AND ca.geo_concept = '1'))"
    );

    selectedRule = selectedRule.replace(
      "((ca.cust_id in (select distinct cust_id from fridays_refined.trans_pay where pay_disc_amt > 0 and cust_id is not null and trans_dt >= current_date - interval '180' day) = true  AND ca.geo_concept = '1'))",
      "((ca.cust_id in (select distinct cust_id from fridays_refined.trans_pay where pay_disc_amt > 0 and cust_id is not null and trans_dt >= current_date - interval '180' day) AND ca.geo_concept = '1'))"
    );

    selectedRule = selectedRule.replace(
      "((ca.cust_id in (select distinct cust_id from fridays_refined.trans_pay where pay_disc_amt > 0 and cust_id is not null and trans_dt >= current_date - interval '365' day) = false  AND ca.geo_concept = '1'))",
      "((ca.cust_id in (select distinct cust_id from fridays_refined.trans_pay where pay_disc_amt = 0 and cust_id is not null and trans_dt >= current_date - interval '365' day) AND ca.geo_concept = '1'))"
    );

    selectedRule = selectedRule.replace(
      "((ca.cust_id in (select distinct cust_id from fridays_refined.trans_pay where pay_disc_amt > 0 and cust_id is not null and trans_dt >= current_date - interval '365' day) = true  AND ca.geo_concept = '1'))",
      "((ca.cust_id in (select distinct cust_id from fridays_refined.trans_pay where pay_disc_amt > 0 and cust_id is not null and trans_dt >= current_date - interval '365' day) AND ca.geo_concept = '1'))"
    );

    if (
      (this.decryptLocal("clientId") === "3fe7e557-16f5-406c-bbc8-887fdec7ba8b" ||
        this.decryptLocal("clientId") === "d1522630-2b9d-424e-a399-7ab3f7be274f" ||
        this.decryptLocal("clientId") === "8c001fde-3728-48dc-9950-b8480ca9fbee" ||
        this.decryptLocal("clientId") === "7203dd51-f88b-4a4b-877c-92326d027915" ||
        this.decryptLocal("clientId") === "f1fbce23-e2ef-463c-bc97-6cde3c4cc4ac" ||
        this.decryptLocal("clientId") === "874b6c6a-83ff-480b-b615-1972538813ba" ||
        this.decryptLocal("clientId") === "b76e7818-deb1-4526-93a7-b398df3ea357" ||
        this.decryptLocal("clientId") === "e08840c5-c7d0-48c7-9c24-124b4cd80735" || 
        this.decryptLocal("clientId") === "68a4d4cc-1e57-4ccf-9dd1-a5ae890d0f2e" ||
        this.decryptLocal("clientId") === "0bc2a383-9ae0-4e9e-9652-0fb762ba6119" ||
        this.decryptLocal("clientId") === "7bf99619-30a3-47a3-b1de-d72b4f7f99a7" ||
        this.decryptLocal("clientId") === "a4dda78e-7678-4aaf-9bef-60a229085fc8" ||
        this.decryptLocal("clientId") === "cf6144d2-bb68-43b6-9876-dbf620b57c21" ||
        this.decryptLocal("clientId") === "83da098f-2fc7-4b98-8455-c08f9aceb4ed" ||
        this.decryptLocal("clientId") === "37f97bea-f005-4be1-8e41-286ad79a7f3a" ||
        this.decryptLocal("clientId") === "ec5a162e-5e87-4819-93bd-70bbf3b5f096" ||
        this.decryptLocal("clientId") === "24ab940a-50d2-41fd-b3b2-c67ca6cb0304" ) &&
      (
        this.decryptLocal("activeChannel") === "d1606aea-0c0d-4fba-83e8-a124f414a953" ||
        this.decryptLocal("activeChannel") === "a8f39ffb-24c5-432a-9bcd-e5d0166a320e"
      )
    ) {
      selectedRule = selectedRule.replace(
        "ca.dim_lifecycle",
        "di.dim_lifecycle"
      );
      selectedRule = selectedRule.replace("ca.geo_id_fav", "di.geo_id");
      selectedRule = selectedRule.replace(
        "((ca.loyalty = false  AND di.geo_concept = '1'))",
        "(((ca.loyalty = false OR ca.loyalty is null) AND di.geo_concept = '1'))"
      );
    }

    // console.log("Model Decile Condition is : " + modelDecileSelectedRule);
    // console.log(
    //   "Non Model Decile Condition is : " + nonModelDecileSelectedRule
    // );

    let lastConditionProspect = modelDecileSelectedRule.slice(
      modelDecileSelectedRule.length - 4
    );
    if (lastConditionProspect.trim() == "AND") {
      modelDecileSelectedRule = modelDecileSelectedRule.slice(0, -4);
    }

    let lastConditionCustomer = nonModelDecileSelectedRule.slice(
      nonModelDecileSelectedRule.length - 4
    );
    if (lastConditionCustomer.trim() == "AND") {
      nonModelDecileSelectedRule = nonModelDecileSelectedRule.slice(0, -4);
      // nonModelDecileSelectedRule = nonModelDecileSelectedRule.slice(1);
    }

    let lastConditionSampling = samplingSelectedRule.slice(
      samplingSelectedRule.length - 4
    );
    if (lastConditionSampling.trim() == "AND") {
      samplingSelectedRule = samplingSelectedRule.slice(0, -4);
    }
    // console.log(
    //   "Model Decile After Removing Condition is : " + modelDecileSelectedRule
    // );
    // console.log(
    //   "Non Model Decile After Removing Condition is : " +
    //     nonModelDecileSelectedRule
    // );

    return [
      selectedRule,
      nonModelDecileSelectedRule,
      modelDecileSelectedRule,
      samplingSelectedRule,
    ];

    // return selectedRule;
  }
  displayQuery() {
    this.props.dispatch({
      type: "CUST_UPDATE_QUERY_COUNT_SEGMENT",
      segmentData: [],
    });
    this.props.dispatch({
      type: "CUST_SHOW_SPINNER_SEGMENT",
      payload: "",
    });

    let selectedRule = "";
    let selectedOptionValue = "";
    let selectedResult = [];
    let groupLeveltoggle = this.props.cust_groupLeveltoggleSegment;
    let ruleLeveltoggle = this.props.cust_ruleLeveltoggleSegment;
    let count = 0;
    let sqlAndOrOperator = "";
    let automationIdOrListId = "";
    let automationIdOrListIdExists = false;
    let menuItemsSelected = false;
    let menuSubCategorySelected = false;

    let prospectConditionExists = false;
    let modelDecileConditionExists = false;
    let modelDecileSelectedRule = "";
    let nonModelDecileSelectedRule = "";
    let samplingConditionExists = false;
    let samplingSelectedRule = "";

    let selectedCustomerType = this.decryptLocal("selectedCustomerType");

    this.props.cust_tillSqlSelectionArrSegment.map((resultData, index) => {
      let segment = "";
      if (this.props.cust_segmentName[index] != undefined) {
        segment = this.props.cust_segmentName[index];
      }
      selectedRule += `WHEN `;
      resultData.map((options, key) => {
        if (options.find((test) => test.value === "li.list_id") !== undefined) {
          automationIdOrListIdExists = true;
        } else {
          automationIdOrListIdExists = false;
        }
        if (options.find((test) => test.value.includes("hh.")) !== undefined) {
          prospectConditionExists = true;
        } else {
          prospectConditionExists = false;
        }
        if (
          options.find(
            (menuItem) =>
              menuItem.value ===
              "ca.cust_id in (select cust_id from fridays_refined.trans_pay where trans_id in (select trans_id from fridays_refined.trans_detail where item_id"
          ) !== undefined
        ) {
          menuItemsSelected = true;
        } else {
          menuItemsSelected = false;
        }

        if (
          options.find(
            (menuItemBajaFresh) =>
              menuItemBajaFresh.value ===
              "ca.cust_id in (select cust_id from bajafresh_refined.trans_pay where trans_id in (select trans_id from bajafresh_refined.trans_detail where item_id"
          ) !== undefined
        ) {
          menuItemsSelected = true;
        } else {
          menuItemsSelected = false;
        }

        if (
          options.find(
            (menuSubCategory) =>
              menuSubCategory.value ===
              "ca.cust_id in (select cust_id from fridays_refined.trans_pay where trans_id in (select trans_id from fridays_refined.trans_detail where item_id in (select item_id from fridays_refined.item where concat(item_hier_1, '-', item_hier_2)"
          ) !== undefined
        ) {
          menuSubCategorySelected = true;
        } else {
          menuSubCategorySelected = false;
        }

        if (
          options.find(
            (menuSubCategoryBajaFresh) =>
              menuSubCategoryBajaFresh.value ===
              "ca.cust_id in (select cust_id from bajafresh_refined.trans_pay where trans_id in (select trans_id from bajafresh_refined.trans_detail where item_id in (select item_id from bajafresh_refined.item where concat(item_hier_1, '-', item_hier_2)"
          ) !== undefined
        ) {
          menuSubCategorySelected = true;
        } else {
          menuSubCategorySelected = false;
        }

        if (
          options.find((test) => test.value.includes("model_decile")) !==
          undefined
        ) {
          modelDecileConditionExists = true;
        } else {
          modelDecileConditionExists = false;
        }

        if (
          options.find((rule) => rule.value.includes("Sampling")) !== undefined
        ) {
          samplingConditionExists = true;
        } else {
          samplingConditionExists = false;
        }

        let length = options.length;
        if (
          "value" in options[length - 2] &&
          options[length - 2].value.includes("+++")
        ) {
          options[length - 2].value = options[length - 2].value.split("+++")[0];
        }
        if (
          options[length - 1].value === "BETWEEN" ||
          options[length - 1].value === "NOT BETWEEN"
        ) {
          selectedRule += "(";
          if (modelDecileConditionExists) {
            modelDecileSelectedRule += "(";
          } else if (!modelDecileConditionExists && !samplingConditionExists) {
            nonModelDecileSelectedRule += "(";
          }

          if (samplingConditionExists) {
            samplingSelectedRule += "(";
          }
        }
        if (
          options[length - 1].value === "cardinality(array_intersect(" ||
          options[length - 1].value === "cardinality(array_except("
        ) {
          selectedRule +=
            "(" +
            options[length - 1].value +
            options[length - 2].value +
            ", array";
          if (modelDecileConditionExists) {
            modelDecileSelectedRule +=
              "(" +
              options[length - 1].value +
              options[length - 2].value +
              ", array";
          } else if (!modelDecileConditionExists && !samplingConditionExists) {
            nonModelDecileSelectedRule +=
              "(" +
              options[length - 1].value +
              options[length - 2].value +
              ", array";
          }

          if (samplingConditionExists) {
            samplingSelectedRule +=
              "(" +
              options[length - 1].value +
              options[length - 2].value +
              ", array";
          }
        } else {
          selectedRule +=
            "(" + options[length - 2].value + " " + options[length - 1].value;
          if (modelDecileConditionExists) {
            modelDecileSelectedRule +=
              "(" + options[length - 2].value + " " + options[length - 1].value;
          } else if (!modelDecileConditionExists && !samplingConditionExists) {
            nonModelDecileSelectedRule +=
              "(" + options[length - 2].value + " " + options[length - 1].value;
          }

          if (samplingConditionExists) {
            samplingSelectedRule +=
              "(" + options[length - 2].value + " " + options[length - 1].value;
          }
        }
        let data = this.props.cust_afterSqlSelectionArrSegment[index][key];
        if (data.length > 0) {
          data.map((result, resultKey) => {
            count = count + 1;
            sqlAndOrOperator = "";
            if (
              options[length - 1].value == "IN" ||
              options[length - 1].value == "NOT IN"
            ) {
              if (resultKey == 0) {
                selectedRule += `(`;
                if (modelDecileConditionExists) {
                  modelDecileSelectedRule += `(`;
                } else if (
                  !modelDecileConditionExists &&
                  !samplingConditionExists
                ) {
                  nonModelDecileSelectedRule += `(`;
                }

                if (samplingConditionExists) {
                  samplingSelectedRule += `(`;
                }
              }
              if (resultKey == data.length - 1) {
                let num = result.value;
                if (automationIdOrListIdExists) {
                  automationIdOrListId = num;
                }
                if (typeof num == "string") {
                  selectedRule += ` '${result.value}', `;
                  if (modelDecileConditionExists) {
                    modelDecileSelectedRule += ` '${result.value}', `;
                  } else if (
                    !modelDecileConditionExists &&
                    !samplingConditionExists
                  ) {
                    nonModelDecileSelectedRule += ` '${result.value}', `;
                  }

                  if (samplingConditionExists) {
                    samplingSelectedRule += ` '${result.value}', `;
                  }
                } else {
                  selectedRule += ` ${result.value}, `;
                  if (modelDecileConditionExists) {
                    modelDecileSelectedRule += ` ${result.value}, `;
                  } else if (
                    !modelDecileConditionExists &&
                    !samplingConditionExists
                  ) {
                    nonModelDecileSelectedRule += ` ${result.value}, `;
                  }

                  if (samplingConditionExists) {
                    samplingSelectedRule += ` ${result.value}, `;
                  }
                }
                selectedRule = selectedRule.replace(/,(\s+)?$/, "");
                if (modelDecileConditionExists) {
                  modelDecileSelectedRule = modelDecileSelectedRule.replace(
                    /,(\s+)?$/,
                    ""
                  );
                } else if (
                  !modelDecileConditionExists &&
                  !samplingConditionExists
                ) {
                  nonModelDecileSelectedRule = nonModelDecileSelectedRule.replace(
                    /,(\s+)?$/,
                    ""
                  );
                }

                if (samplingConditionExists) {
                  samplingSelectedRule = samplingSelectedRule.replace(
                    /,(\s+)?$/,
                    ""
                  );
                }
                // selectedRule += `))`;
                if (menuItemsSelected) {
                  selectedRule += `))))`;
                } else if (menuSubCategorySelected) {
                  selectedRule += `)))))`;
                } else {
                  selectedRule += `))`;
                  if (modelDecileConditionExists) {
                    modelDecileSelectedRule += `))`;
                  } else if (
                    !modelDecileConditionExists &&
                    !samplingConditionExists
                  ) {
                    nonModelDecileSelectedRule += `))`;
                  }

                  if (samplingConditionExists) {
                    samplingSelectedRule += `))`;
                  }
                }
                if (
                  ruleLeveltoggle.length > 0 &&
                  ruleLeveltoggle[index] !== null &&
                  ruleLeveltoggle[index] !== undefined &&
                  ruleLeveltoggle[index][key] !== undefined
                ) {
                  sqlAndOrOperator = ruleLeveltoggle[index][key];
                  selectedRule += ` ${sqlAndOrOperator} `;
                  if (modelDecileConditionExists) {
                    modelDecileSelectedRule += ` ${sqlAndOrOperator} `;
                  } else if (
                    !modelDecileConditionExists &&
                    !samplingConditionExists
                  ) {
                    nonModelDecileSelectedRule += ` ${sqlAndOrOperator} `;
                  }

                  if (samplingConditionExists) {
                    samplingSelectedRule += ` ${sqlAndOrOperator} `;
                  }
                }
              } else {
                let num = result.value;
                if (automationIdOrListIdExists) {
                  // alert("Value Exists Else Block");
                  automationIdOrListId = num;
                }
                if (typeof num == "string") {
                  selectedRule += ` '${result.value}', `;
                  if (modelDecileConditionExists) {
                    modelDecileSelectedRule += ` '${result.value}', `;
                  } else if (
                    !modelDecileConditionExists &&
                    !samplingConditionExists
                  ) {
                    nonModelDecileSelectedRule += ` '${result.value}', `;
                  }

                  if (samplingConditionExists) {
                    samplingSelectedRule += ` '${result.value}', `;
                  }
                } else {
                  selectedRule += ` ${result.value}, `;
                  if (modelDecileConditionExists) {
                    modelDecileSelectedRule += ` ${result.value}, `;
                  } else if (
                    !modelDecileConditionExists &&
                    !samplingConditionExists
                  ) {
                    nonModelDecileSelectedRule += ` ${result.value}, `;
                  }

                  if (samplingConditionExists) {
                    samplingSelectedRule += ` ${result.value}, `;
                  }
                }
              }
            } else if (
              options[length - 1].value == "cardinality(array_intersect("
            ) {
              if (resultKey == 0) {
                selectedRule += `[`;
                if (modelDecileConditionExists) {
                  modelDecileSelectedRule += `[`;
                } else if (
                  !modelDecileConditionExists &&
                  !samplingConditionExists
                ) {
                  nonModelDecileSelectedRule += `[`;
                }

                if (samplingConditionExists) {
                  samplingSelectedRule += `[`;
                }
              }
              if (resultKey == data.length - 1) {
                let num = result.value;
                let aggarray = [];
                selectedRule += ` '${result.value}', `;
                if (modelDecileConditionExists) {
                  modelDecileSelectedRule += ` '${result.value}', `;
                } else if (
                  !modelDecileConditionExists &&
                  !samplingConditionExists
                ) {
                  nonModelDecileSelectedRule += ` '${result.value}', `;
                }

                if (samplingConditionExists) {
                  samplingSelectedRule += ` '${result.value}', `;
                }

                selectedRule = selectedRule.replace(/,(\s+)?$/, "");
                if (modelDecileConditionExists) {
                  modelDecileSelectedRule = modelDecileSelectedRule.replace(
                    /,(\s+)?$/,
                    ""
                  );
                } else if (
                  !modelDecileConditionExists &&
                  !samplingConditionExists
                ) {
                  nonModelDecileSelectedRule = nonModelDecileSelectedRule.replace(
                    /,(\s+)?$/,
                    ""
                  );
                }

                if (samplingConditionExists) {
                  samplingSelectedRule = samplingSelectedRule.replace(
                    /,(\s+)?$/,
                    ""
                  );
                }

                if (selectedCustomerType === "Customer") {
                  selectedRule += `])) > 0 AND ${this.decryptLocal("globalFilter")})`;
                } else {
                  selectedRule += `])) > 0 )`;
                }

                if (modelDecileConditionExists) {
                  modelDecileSelectedRule += `])) > 0 ${
                    this.decryptLocal("selectedCustomerType") === "Acquistion" ||
                    (this.decryptLocal("selectedCustomerType") === "Combined" &&
                      prospectConditionExists)
                      ? ""
                      : "AND"
                  } ${
                    this.decryptLocal("selectedCustomerType") === "Acquistion" ||
                    (this.decryptLocal("selectedCustomerType") === "Combined" &&
                      prospectConditionExists)
                      ? ""
                      : this.decryptLocal("globalFilter")
                  })`;
                } else if (
                  !modelDecileConditionExists &&
                  !samplingConditionExists
                ) {
                  nonModelDecileSelectedRule += `])) > 0 ${
                    this.decryptLocal("selectedCustomerType") === "Acquistion" ||
                    (this.decryptLocal("selectedCustomerType") === "Combined" &&
                      prospectConditionExists)
                      ? ""
                      : "AND"
                  } ${
                    this.decryptLocal("selectedCustomerType") === "Acquistion" ||
                    (this.decryptLocal("selectedCustomerType") === "Combined" &&
                      prospectConditionExists)
                      ? ""
                      : this.decryptLocal("globalFilter")
                  })`;
                }

                if (samplingConditionExists) {
                  samplingSelectedRule += `])) > 0 ${
                    this.decryptLocal("selectedCustomerType") === "Acquistion" ||
                    (this.decryptLocal("selectedCustomerType") === "Combined" &&
                      prospectConditionExists)
                      ? ""
                      : "AND"
                  } ${
                    this.decryptLocal("selectedCustomerType") === "Acquistion" ||
                    (this.decryptLocal("selectedCustomerType") === "Combined" &&
                      prospectConditionExists)
                      ? ""
                      : this.decryptLocal("globalFilter")
                  })`;
                }

                if (
                  ruleLeveltoggle.length > 0 &&
                  ruleLeveltoggle[index] !== null &&
                  ruleLeveltoggle[index] !== undefined &&
                  ruleLeveltoggle[index][key] !== undefined
                ) {
                  sqlAndOrOperator = ruleLeveltoggle[index][key];
                  selectedRule += ` ${sqlAndOrOperator} `;
                  if (modelDecileConditionExists) {
                    modelDecileSelectedRule += ` ${sqlAndOrOperator} `;
                  } else if (
                    !modelDecileConditionExists &&
                    !samplingConditionExists
                  ) {
                    nonModelDecileSelectedRule += ` ${sqlAndOrOperator} `;
                  }

                  if (samplingConditionExists) {
                    samplingSelectedRule += ` ${sqlAndOrOperator} `;
                  }
                }
              } else {
                let num = result.value;
                selectedRule += ` '${result.value}', `;
                if (modelDecileConditionExists) {
                  modelDecileSelectedRule += ` '${result.value}', `;
                } else if (
                  !modelDecileConditionExists &&
                  !samplingConditionExists
                ) {
                  nonModelDecileSelectedRule += ` '${result.value}', `;
                }

                if (samplingConditionExists) {
                  samplingSelectedRule += ` '${result.value}', `;
                }
              }
            } else if (
              options[length - 1].value == "cardinality(array_except("
            ) {
              if (resultKey == 0) {
                selectedRule += `[`;
                if (modelDecileConditionExists) {
                  modelDecileSelectedRule += `[`;
                } else if (
                  !modelDecileConditionExists &&
                  !samplingConditionExists
                ) {
                  nonModelDecileSelectedRule += `[`;
                }

                if (samplingConditionExists) {
                  samplingSelectedRule += `[`;
                }
              }
              if (resultKey == data.length - 1) {
                let num = result.value;
                let aggarray = [];
                selectedRule += ` '${result.value}', `;
                if (modelDecileConditionExists) {
                  modelDecileSelectedRule += ` '${result.value}', `;
                } else if (
                  !modelDecileConditionExists &&
                  !samplingConditionExists
                ) {
                  nonModelDecileSelectedRule += ` '${result.value}', `;
                }

                if (samplingConditionExists) {
                  samplingSelectedRule += ` '${result.value}', `;
                }
                selectedRule = selectedRule.replace(/,(\s+)?$/, "");
                if (modelDecileConditionExists) {
                  modelDecileSelectedRule = modelDecileSelectedRule.replace(
                    /,(\s+)?$/,
                    ""
                  );
                } else if (
                  !modelDecileConditionExists &&
                  !samplingConditionExists
                ) {
                  nonModelDecileSelectedRule = nonModelDecileSelectedRule.replace(
                    /,(\s+)?$/,
                    ""
                  );
                }

                if (samplingConditionExists) {
                  samplingSelectedRule = samplingSelectedRule.replace(
                    /,(\s+)?$/,
                    ""
                  );
                }

                if (selectedCustomerType === "Customer") {
                  selectedRule += `])) > 0 AND ${this.decryptLocal("globalFilter")})`;
                } else {
                  selectedRule += `])) > 0)`;
                }

                if (modelDecileConditionExists) {
                  modelDecileSelectedRule += `])) > 0 ${
                    this.decryptLocal("selectedCustomerType") === "Acquistion" ||
                    (this.decryptLocal("selectedCustomerType") === "Combined" &&
                      prospectConditionExists)
                      ? ""
                      : "AND"
                  } ${
                    this.decryptLocal("selectedCustomerType") === "Acquistion" ||
                    (this.decryptLocal("selectedCustomerType") === "Combined" &&
                      prospectConditionExists)
                      ? ""
                      : this.decryptLocal("globalFilter")
                  })`;
                } else if (
                  !modelDecileConditionExists &&
                  !samplingConditionExists
                ) {
                  nonModelDecileSelectedRule += `])) > 0 ${
                    this.decryptLocal("selectedCustomerType") === "Acquistion" ||
                    (this.decryptLocal("selectedCustomerType") === "Combined" &&
                      prospectConditionExists)
                      ? ""
                      : "AND"
                  } ${
                    this.decryptLocal("selectedCustomerType") === "Acquistion" ||
                    (this.decryptLocal("selectedCustomerType") === "Combined" &&
                      prospectConditionExists)
                      ? ""
                      : this.decryptLocal("globalFilter")
                  })`;
                }

                if (samplingConditionExists) {
                  samplingSelectedRule += `])) > 0 ${
                    this.decryptLocal("selectedCustomerType") === "Acquistion" ||
                    (this.decryptLocal("selectedCustomerType") === "Combined" &&
                      prospectConditionExists)
                      ? ""
                      : "AND"
                  } ${
                    this.decryptLocal("selectedCustomerType") === "Acquistion" ||
                    (this.decryptLocal("selectedCustomerType") === "Combined" &&
                      prospectConditionExists)
                      ? ""
                      : this.decryptLocal("globalFilter")
                  })`;
                }

                if (
                  ruleLeveltoggle.length > 0 &&
                  ruleLeveltoggle[index] !== null &&
                  ruleLeveltoggle[index] !== undefined &&
                  ruleLeveltoggle[index][key] !== undefined
                ) {
                  sqlAndOrOperator = ruleLeveltoggle[index][key];
                  selectedRule += ` ${sqlAndOrOperator} `;
                  if (modelDecileConditionExists) {
                    modelDecileSelectedRule += ` ${sqlAndOrOperator} `;
                  } else if (
                    !modelDecileConditionExists &&
                    !samplingConditionExists
                  ) {
                    nonModelDecileSelectedRule += ` ${sqlAndOrOperator} `;
                  }

                  if (samplingConditionExists) {
                    samplingSelectedRule += ` ${sqlAndOrOperator} `;
                  }
                }
              } else {
                let num = result.value;
                selectedRule += ` '${result.value}', `;
                if (modelDecileConditionExists) {
                  modelDecileSelectedRule += ` '${result.value}', `;
                } else if (
                  !modelDecileConditionExists &&
                  !samplingConditionExists
                ) {
                  nonModelDecileSelectedRule += ` '${result.value}', `;
                }

                if (samplingConditionExists) {
                  samplingSelectedRule += ` '${result.value}', `;
                }
              }
            } else if (options[length - 1].value == "= ") {
              if (selectedCustomerType === "Customer") {
                selectedRule += ` ${result.value} AND ${this.decryptLocal("globalFilter")})`;
              } else {
                selectedRule += ` ${result.value})`;
              }

              if (modelDecileConditionExists) {
                modelDecileSelectedRule += ` ${result.value} ${
                  this.decryptLocal("selectedCustomerType") === "Acquistion" ||
                  this.decryptLocal("selectedCustomerType") === "Combined"
                    ? ""
                    : "AND"
                } ${
                  this.decryptLocal("selectedCustomerType") === "Acquistion" ||
                  this.decryptLocal("selectedCustomerType") === "Combined"
                    ? ""
                    : this.decryptLocal("globalFilter")
                })`;
              } else if (
                !modelDecileConditionExists &&
                !samplingConditionExists
              ) {
                nonModelDecileSelectedRule += ` ${result.value} ${
                  this.decryptLocal("selectedCustomerType") === "Acquistion" ||
                  this.decryptLocal("selectedCustomerType") === "Combined"
                    ? ""
                    : "AND"
                } ${
                  this.decryptLocal("selectedCustomerType") === "Acquistion" ||
                  this.decryptLocal("selectedCustomerType") === "Combined"
                    ? ""
                    : this.decryptLocal("globalFilter")
                })`;
              }

              if (samplingConditionExists) {
                samplingSelectedRule += ` ${result.value} ${
                  this.decryptLocal("selectedCustomerType") === "Acquistion" ||
                  this.decryptLocal("selectedCustomerType") === "Combined"
                    ? ""
                    : "AND"
                } ${
                  this.decryptLocal("selectedCustomerType") === "Acquistion" ||
                  this.decryptLocal("selectedCustomerType") === "Combined"
                    ? ""
                    : this.decryptLocal("globalFilter")
                })`;
              }
            } else {
              let num = result.value;
              if (
                options[length - 1].value === "BETWEEN" ||
                options[length - 1].value === "NOT BETWEEN"
              ) {
                if (selectedCustomerType === "Customer") {
                  selectedRule += ` ${result.value}) AND ${this.decryptLocal("globalFilter")}),`;
                } else {
                  selectedRule += ` ${result.value})),`;
                }

                if (modelDecileConditionExists) {
                  modelDecileSelectedRule += ` ${result.value}) ${
                    this.decryptLocal("selectedCustomerType") === "Acquistion" ||
                    (this.decryptLocal("selectedCustomerType") === "Combined" &&
                      prospectConditionExists)
                      ? ""
                      : "AND"
                  } ${
                    this.decryptLocal("selectedCustomerType") === "Acquistion" ||
                    (this.decryptLocal("selectedCustomerType") === "Combined" &&
                      prospectConditionExists)
                      ? ""
                      : this.decryptLocal("globalFilter")
                  }),`;
                } else if (
                  !modelDecileConditionExists &&
                  !samplingConditionExists
                ) {
                  nonModelDecileSelectedRule += ` ${result.value}) ${
                    this.decryptLocal("selectedCustomerType") === "Acquistion" ||
                    (this.decryptLocal("selectedCustomerType") === "Combined" &&
                      prospectConditionExists)
                      ? ""
                      : "AND"
                  } ${
                    this.decryptLocal("selectedCustomerType") === "Acquistion" ||
                    (this.decryptLocal("selectedCustomerType") === "Combined" &&
                      prospectConditionExists)
                      ? ""
                      : this.decryptLocal("globalFilter")
                  }),`;
                }

                if (samplingConditionExists) {
                  samplingSelectedRule += ` ${result.value}) ${
                    this.decryptLocal("selectedCustomerType") === "Acquistion" ||
                    (this.decryptLocal("selectedCustomerType") === "Combined" &&
                      prospectConditionExists)
                      ? ""
                      : "AND"
                  } ${
                    this.decryptLocal("selectedCustomerType") === "Acquistion" ||
                    (this.decryptLocal("selectedCustomerType") === "Combined" &&
                      prospectConditionExists)
                      ? ""
                      : this.decryptLocal("globalFilter")
                  }),`;
                }
              } else if (typeof num == "string") {
                selectedRule += ` '${result.value}'), `;
                if (modelDecileConditionExists) {
                  modelDecileSelectedRule += ` '${result.value}' ${
                    this.decryptLocal("selectedCustomerType") === "Acquistion" ||
                    (this.decryptLocal("selectedCustomerType") === "Combined" &&
                      prospectConditionExists)
                      ? ""
                      : "AND"
                  } ${
                    this.decryptLocal("selectedCustomerType") === "Acquistion" ||
                    (this.decryptLocal("selectedCustomerType") === "Combined" &&
                      prospectConditionExists)
                      ? ""
                      : this.decryptLocal("globalFilter")
                  }),`;
                } else if (
                  !modelDecileConditionExists &&
                  !samplingConditionExists
                ) {
                  nonModelDecileSelectedRule += ` '${result.value}' ${
                    this.decryptLocal("selectedCustomerType") === "Acquistion" ||
                    (this.decryptLocal("selectedCustomerType") === "Combined" &&
                      prospectConditionExists)
                      ? ""
                      : "AND"
                  } ${
                    this.decryptLocal("selectedCustomerType") === "Acquistion" ||
                    (this.decryptLocal("selectedCustomerType") === "Combined" &&
                      prospectConditionExists)
                      ? ""
                      : this.decryptLocal("globalFilter")
                  }),`;
                }

                if (samplingConditionExists) {
                  samplingSelectedRule += ` '${result.value}' ${
                    this.decryptLocal("selectedCustomerType") === "Acquistion" ||
                    (this.decryptLocal("selectedCustomerType") === "Combined" &&
                      prospectConditionExists)
                      ? ""
                      : "AND"
                  } ${
                    this.decryptLocal("selectedCustomerType") === "Acquistion" ||
                    (this.decryptLocal("selectedCustomerType") === "Combined" &&
                      prospectConditionExists)
                      ? ""
                      : this.decryptLocal("globalFilter")
                  }),`;
                }
              } else {
                selectedRule += ` ${result.value}), `;
                if (modelDecileConditionExists) {
                  modelDecileSelectedRule += ` ${result.value} ${
                    this.decryptLocal("selectedCustomerType") === "Acquistion" ||
                    (this.decryptLocal("selectedCustomerType") === "Combined" &&
                      prospectConditionExists)
                      ? ""
                      : "AND"
                  } ${
                    this.decryptLocal("selectedCustomerType") === "Acquistion" ||
                    (this.decryptLocal("selectedCustomerType") === "Combined" &&
                      prospectConditionExists)
                      ? ""
                      : this.decryptLocal("globalFilter")
                  }),`;
                } else if (
                  !modelDecileConditionExists &&
                  !samplingConditionExists
                ) {
                  nonModelDecileSelectedRule += ` ${result.value} ${
                    this.decryptLocal("selectedCustomerType") === "Acquistion" ||
                    (this.decryptLocal("selectedCustomerType") === "Combined" &&
                      prospectConditionExists)
                      ? ""
                      : "AND"
                  } ${
                    this.decryptLocal("selectedCustomerType") === "Acquistion" ||
                    (this.decryptLocal("selectedCustomerType") === "Combined" &&
                      prospectConditionExists)
                      ? ""
                      : this.decryptLocal("globalFilter")
                  }),`;
                }

                if (samplingConditionExists) {
                  samplingSelectedRule += ` ${result.value} ${
                    this.decryptLocal("selectedCustomerType") === "Acquistion" ||
                    (this.decryptLocal("selectedCustomerType") === "Combined" &&
                      prospectConditionExists)
                      ? ""
                      : "AND"
                  } ${
                    this.decryptLocal("selectedCustomerType") === "Acquistion" ||
                    (this.decryptLocal("selectedCustomerType") === "Combined" &&
                      prospectConditionExists)
                      ? ""
                      : this.decryptLocal("globalFilter")
                  }),`;
                }
              }
              selectedRule = selectedRule.replace(/,(\s+)?$/, "");
              if (modelDecileConditionExists) {
                modelDecileSelectedRule = modelDecileSelectedRule.replace(
                  /,(\s+)?$/,
                  ""
                );
              } else if (
                !modelDecileConditionExists &&
                !samplingConditionExists
              ) {
                nonModelDecileSelectedRule = nonModelDecileSelectedRule.replace(
                  /,(\s+)?$/,
                  ""
                );
              }

              if (samplingConditionExists) {
                samplingSelectedRule = samplingSelectedRule.replace(
                  /,(\s+)?$/,
                  ""
                );
              }
              if (
                ruleLeveltoggle.length > 0 &&
                key !== resultData.length - 1 &&
                ruleLeveltoggle[index] !== null &&
                ruleLeveltoggle[index] !== undefined &&
                ruleLeveltoggle[index][key] !== undefined
              ) {
                sqlAndOrOperator = ruleLeveltoggle[index][key];
                selectedRule += ` ${sqlAndOrOperator} `;
                if (modelDecileConditionExists) {
                  modelDecileSelectedRule += ` ${sqlAndOrOperator} `;
                } else if (
                  !modelDecileConditionExists &&
                  !samplingConditionExists
                ) {
                  nonModelDecileSelectedRule += ` ${sqlAndOrOperator} `;
                }

                if (samplingConditionExists) {
                  samplingSelectedRule += ` ${sqlAndOrOperator} `;
                }
              }
            }
          });
        }
      });
      selectedRule = selectedRule.replace(/,(\s+)?$/, "");
      selectedRule += ` THEN `;
      selectedRule += ` '${segment}' `;
      // selectedRule += `)`;
      // sqlAndOrOperator = "";
      // if (
      //   groupLeveltoggle.length > 0 &&
      //   this.props.cust_tillSqlSelectionArrSegment.length - 1 != index &&
      //   groupLeveltoggle[0] != undefined &&
      //   groupLeveltoggle[0][index] != undefined
      // ) {
      //   sqlAndOrOperator = groupLeveltoggle[0][index];
      //   selectedRule += ` ${sqlAndOrOperator} `;
      // }
      if (selectedCustomerType === "Acquistion") {
        sqlAndOrOperator = "";
        if (
          groupLeveltoggle.length > 0 &&
          this.props.cust_tillSqlSelectionArrSegment.length - 1 != index &&
          groupLeveltoggle[0] != undefined &&
          groupLeveltoggle[0][index] != undefined
        ) {
          sqlAndOrOperator = groupLeveltoggle[0][index];
          // selectedRule += ` ${sqlAndOrOperator} `;
          if (modelDecileConditionExists) {
            modelDecileSelectedRule += ` ${sqlAndOrOperator} `;
          } else if (!modelDecileConditionExists && !samplingConditionExists) {
            nonModelDecileSelectedRule += ` ${sqlAndOrOperator} `;
          }

          if (samplingConditionExists) {
            samplingSelectedRule += ` ${sqlAndOrOperator} `;
          }
        }
      }
      selectedRule = selectedRule.replace(/,(\s+)?$/, "");
      if (modelDecileConditionExists) {
        modelDecileSelectedRule = modelDecileSelectedRule.replace(
          /,(\s+)?$/,
          ""
        );
      } else if (!modelDecileConditionExists && !samplingConditionExists) {
        nonModelDecileSelectedRule = nonModelDecileSelectedRule.replace(
          /,(\s+)?$/,
          ""
        );
      }

      if (samplingConditionExists) {
        samplingSelectedRule = samplingSelectedRule.replace(/,(\s+)?$/, "");
      }
    });

    if (automationIdOrListId != null || automationIdOrListId !== "") {
      if (
        this.decryptLocal("model") === "restaurant_v3"
      ) {
        let currDb = this.decryptLocal("custDb")
        // IN
        let currRegex = /\( *li\.list_id +IN *\((.*?)\)/g;
        let currMatch = (' ' + selectedRule).slice(1).match(currRegex);
        let singleRegex, currAutomation
        if (currMatch) {
          let singleRegex = /\( *li\.list_id +IN *\((.*?)\)/;
          for(let idx in currMatch) {
            currAutomation = (' ' + currMatch[idx]).slice(1).match(singleRegex)
            selectedRule = selectedRule.replace(
              singleRegex,
              // Replace With
              "(ca.cust_id IN" +
                "(" + 
                  "SELECT cust_id from " +
                  currDb + ".deliveries where delivery_id IN " +
                  "(" +
                    "select delivery_id " +
                    "from " + currDb + ".cmp_deliveries " + 
                    "where automation_id in ("+currAutomation[1]+")" +
                  ")" + 
                ")"
            );
          }
        }
        
        // NOT IN
        currRegex = /\( *li\.list_id +NOT +IN *\((.*?)\)/g;
        currMatch = (' ' + selectedRule).slice(1).match(currRegex);
        if (currMatch) {
          singleRegex = /\( *li\.list_id +NOT +IN *\((.*?)\)/;
          for(let idx in currMatch) {
            currAutomation = (' ' + currMatch[idx]).slice(1).match(singleRegex)
            selectedRule = selectedRule.replace(
              singleRegex,
              // Replace With
              "(ca.cust_id NOT IN" +
                "(" + 
                  "SELECT cust_id from " +
                  currDb + ".deliveries where delivery_id IN " +
                  "(" +
                    "select delivery_id " +
                    "from " + currDb + ".cmp_deliveries " + 
                    "where automation_id in ("+currAutomation[1]+")" +
                  ")" + 
                ")"
            );
          }
        }
      }
    }

    let originaltext = selectedRule;
    let test = originaltext
      .split(
        "(ca.cust_id IN (select cust_id from goodwill_refined.loyalty where loyalty_id IN(select customer_id from goodwill_source.tb_coupon where coupon_id NOT IN (select coupon_id from goodwill_source.tb_coupon_used) AND date(date_parse(act_date, '%c/%e/%Y %r')) <= current_date AND date(date_parse(deact_time, '%c/%e/%Y %r')) = date_add('day',{daysFromExpiration},current_date) AND orig_template_id = '{offerCode}')) = "
      )
      .pop();
    let final = test.replace(")", "");
    let test1 = final
      .replaceAll("'", "")
      .split("THEN")[0]
      .split("AND")[0];
    let test2 = final
      .replaceAll("'", "")
      .split("THEN")[0]
      .split("AND")[1];

    if (test1 !== "" && test1 !== undefined) {
      test1 = test1.trim();
    }

    if (test2 !== "" && test2 !== undefined) {
      test2 = test2.trim();
    }

    if (test1 !== null && test2 !== null) {
      selectedRule = selectedRule.replace(
        `ca.cust_id IN (select cust_id from goodwill_refined.loyalty where loyalty_id IN(select customer_id from goodwill_source.tb_coupon where coupon_id NOT IN (select coupon_id from goodwill_source.tb_coupon_used) AND date(date_parse(act_date, '%c/%e/%Y %r')) <= current_date AND date(date_parse(deact_time, '%c/%e/%Y %r')) = date_add('day',{daysFromExpiration},current_date) AND orig_template_id = '{offerCode}')) = '${test1} AND ${test2}'`,
        `ca.cust_id IN (select cust_id from goodwill_refined.loyalty where loyalty_id IN(select customer_id from goodwill_source.tb_coupon where coupon_id NOT IN (select coupon_id from goodwill_source.tb_coupon_used) AND date(date_parse(act_date, '%c/%e/%Y %r')) <= current_date AND date(date_parse(deact_time, '%c/%e/%Y %r')) = date_add('day',${test2},current_date) AND orig_template_id = '${test1}'))`
      );
    }

    selectedRule = selectedRule.replace(
      "(menu_sub_category = 'item_hier_1 = '5' and item_hier_2 = '26'')",
      "((ca.cust_id in (select cust_id from fridays_refined.trans_pay where trans_id in (select trans_id from fridays_refined.trans_detail where item_id in (select item_id from fridays_refined.item where item_hier_1 = '5' and item_hier_2 = '26')))))"
    );

    selectedRule = selectedRule.replace(
      "(menu_sub_category = 'item_hier_1 = '13' and item_hier_2 = '1'')",
      "((ca.cust_id in (select cust_id from fridays_refined.trans_pay where trans_id in (select trans_id from fridays_refined.trans_detail where item_id in (select item_id from fridays_refined.item where item_hier_1 = '13' and item_hier_2 = '1')))))"
    );

    selectedRule = selectedRule.replace(
      "(menu_sub_category = 'item_hier_1 = '13' and item_hier_2 = '22'')",
      "((ca.cust_id in (select cust_id from fridays_refined.trans_pay where trans_id in (select trans_id from fridays_refined.trans_detail where item_id in (select item_id from fridays_refined.item where item_hier_1 = '13' and item_hier_2 = '22')))))"
    );

    selectedRule = selectedRule.replace(
      "(menu_sub_category = 'item_hier_1 = '18' and item_hier_2 = '265'')",
      "((ca.cust_id in (select cust_id from fridays_refined.trans_pay where trans_id in (select trans_id from fridays_refined.trans_detail where item_id in (select item_id from fridays_refined.item where item_hier_1 = '18' and item_hier_2 = '265')))))"
    );

    selectedRule = selectedRule.replace(
      "(menu_sub_category = 'item_hier_1 = '13' and item_hier_2 = '293'')",
      "((ca.cust_id in (select cust_id from fridays_refined.trans_pay where trans_id in (select trans_id from fridays_refined.trans_detail where item_id in (select item_id from fridays_refined.item where item_hier_1 = '13' and item_hier_2 = '293')))))"
    );

    selectedRule = selectedRule.replace(
      "(menu_sub_category = 'item_hier_1 = '5' and item_hier_2 = '6'')",
      "((ca.cust_id in (select cust_id from fridays_refined.trans_pay where trans_id in (select trans_id from fridays_refined.trans_detail where item_id in (select item_id from fridays_refined.item where item_hier_1 = '5' and item_hier_2 = '6')))))"
    );

    selectedRule = selectedRule.replace(
      "(menu_sub_category = 'item_hier_1 = '13' and item_hier_2 = '400'')",
      "((ca.cust_id in (select cust_id from fridays_refined.trans_pay where trans_id in (select trans_id from fridays_refined.trans_detail where item_id in (select item_id from fridays_refined.item where item_hier_1 = '13' and item_hier_2 = '400')))))"
    );

    selectedRule = selectedRule.replace(
      "(menu_sub_category = 'item_hier_1 = '5' and item_hier_2 = '32'')",
      "((ca.cust_id in (select cust_id from fridays_refined.trans_pay where trans_id in (select trans_id from fridays_refined.trans_detail where item_id in (select item_id from fridays_refined.item where item_hier_1 = '5' and item_hier_2 = '32')))))"
    );

    selectedRule = selectedRule.replace(
      "(menu_sub_category = 'item_hier_1 = '18' and item_hier_2 = '266'')",
      "((ca.cust_id in (select cust_id from fridays_refined.trans_pay where trans_id in (select trans_id from fridays_refined.trans_detail where item_id in (select item_id from fridays_refined.item where item_hier_1 = '18' and item_hier_2 = '266')))))"
    );

    selectedRule = selectedRule.replace(
      "(menu_sub_category = 'item_hier_1 = '13' and item_hier_2 = '20'')",
      "((ca.cust_id in (select cust_id from fridays_refined.trans_pay where trans_id in (select trans_id from fridays_refined.trans_detail where item_id in (select item_id from fridays_refined.item where item_hier_1 = '13' and item_hier_2 = '20')))))"
    );

    selectedRule = selectedRule.replace(
      "(menu_sub_category = 'item_hier_1 = '13' and item_hier_2 = '244'')",
      "((ca.cust_id in (select cust_id from fridays_refined.trans_pay where trans_id in (select trans_id from fridays_refined.trans_detail where item_id in (select item_id from fridays_refined.item where item_hier_1 = '13' and item_hier_2 = '244')))))"
    );

    selectedRule = selectedRule.replace(
      "(menu_sub_category = 'item_hier_1 = '18' and item_hier_2 = '251'')",
      "((ca.cust_id in (select cust_id from fridays_refined.trans_pay where trans_id in (select trans_id from fridays_refined.trans_detail where item_id in (select item_id from fridays_refined.item where item_hier_1 = '18' and item_hier_2 = '251')))))"
    );

    selectedRule = selectedRule.replace(
      "(menu_sub_category = 'item_hier_1 = '13' and item_hier_2 = '33'')",
      "((ca.cust_id in (select cust_id from fridays_refined.trans_pay where trans_id in (select trans_id from fridays_refined.trans_detail where item_id in (select item_id from fridays_refined.item where item_hier_1 = '13' and item_hier_2 = '33')))))"
    );

    selectedRule = selectedRule.replace(
      "(menu_sub_category = 'item_hier_1 = '18' and item_hier_2 = '312'')",
      "((ca.cust_id in (select cust_id from fridays_refined.trans_pay where trans_id in (select trans_id from fridays_refined.trans_detail where item_id in (select item_id from fridays_refined.item where item_hier_1 = '18' and item_hier_2 = '312')))))"
    );

    selectedRule = selectedRule.replace(
      "(menu_sub_category = 'item_hier_1 = '13' and item_hier_2 = '36'')",
      "((ca.cust_id in (select cust_id from fridays_refined.trans_pay where trans_id in (select trans_id from fridays_refined.trans_detail where item_id in (select item_id from fridays_refined.item where item_hier_1 = '13' and item_hier_2 = '36')))))"
    );

    selectedRule = selectedRule.replace(
      "(menu_sub_category = 'item_hier_1 = '13' and item_hier_2 = '35'')",
      "((ca.cust_id in (select cust_id from fridays_refined.trans_pay where trans_id in (select trans_id from fridays_refined.trans_detail where item_id in (select item_id from fridays_refined.item where item_hier_1 = '13' and item_hier_2 = '35')))))"
    );

    selectedRule = selectedRule.replace(
      "(menu_sub_category = 'item_hier_1 = '13' and item_hier_2 = '250'')",
      "((ca.cust_id in (select cust_id from fridays_refined.trans_pay where trans_id in (select trans_id from fridays_refined.trans_detail where item_id in (select item_id from fridays_refined.item where item_hier_1 = '13' and item_hier_2 = '250')))))"
    );

    selectedRule = selectedRule.replace(
      "(menu_sub_category = 'item_hier_1 = '13' and item_hier_2 = '277'')",
      "((ca.cust_id in (select cust_id from fridays_refined.trans_pay where trans_id in (select trans_id from fridays_refined.trans_detail where item_id in (select item_id from fridays_refined.item where item_hier_1 = '13' and item_hier_2 = '277')))))"
    );

    selectedRule = selectedRule.replace(
      "(menu_sub_category = 'item_hier_1 = '38' and item_hier_2 = '27'')",
      "((ca.cust_id in (select cust_id from fridays_refined.trans_pay where trans_id in (select trans_id from fridays_refined.trans_detail where item_id in (select item_id from fridays_refined.item where item_hier_1 = '38' and item_hier_2 = '27')))))"
    );

    selectedRule = selectedRule.replace(
      "(menu_sub_category = 'item_hier_1 = '18' and item_hier_2 = '268'')",
      "((ca.cust_id in (select cust_id from fridays_refined.trans_pay where trans_id in (select trans_id from fridays_refined.trans_detail where item_id in (select item_id from fridays_refined.item where item_hier_1 = '18' and item_hier_2 = '268')))))"
    );

    selectedRule = selectedRule.replace(
      "(menu_sub_category = 'item_hier_1 = '18' and item_hier_2 = '252'')",
      "((ca.cust_id in (select cust_id from fridays_refined.trans_pay where trans_id in (select trans_id from fridays_refined.trans_detail where item_id in (select item_id from fridays_refined.item where item_hier_1 = '18' and item_hier_2 = '252')))))"
    );

    selectedRule = selectedRule.replace(
      "(menu_sub_category = 'item_hier_1 = '38' and item_hier_2 = '16'')",
      "((ca.cust_id in (select cust_id from fridays_refined.trans_pay where trans_id in (select trans_id from fridays_refined.trans_detail where item_id in (select item_id from fridays_refined.item where item_hier_1 = '38' and item_hier_2 = '16')))))"
    );

    selectedRule = selectedRule.replace(
      "(menu_sub_category = 'item_hier_1 = '13' and item_hier_2 = '10'')",
      "((ca.cust_id in (select cust_id from fridays_refined.trans_pay where trans_id in (select trans_id from fridays_refined.trans_detail where item_id in (select item_id from fridays_refined.item where item_hier_1 = '13' and item_hier_2 = '10')))))"
    );

    selectedRule = selectedRule.replace(
      "(menu_sub_category = 'item_hier_1 = '13' and item_hier_2 = '285'')",
      "((ca.cust_id in (select cust_id from fridays_refined.trans_pay where trans_id in (select trans_id from fridays_refined.trans_detail where item_id in (select item_id from fridays_refined.item where item_hier_1 = '13' and item_hier_2 = '285')))))"
    );

    selectedRule = selectedRule.replace(
      "(menu_sub_category = 'item_hier_1 = '13' and item_hier_2 = '2'')",
      "((ca.cust_id in (select cust_id from fridays_refined.trans_pay where trans_id in (select trans_id from fridays_refined.trans_detail where item_id in (select item_id from fridays_refined.item where item_hier_1 = '13' and item_hier_2 = '2')))))"
    );

    selectedRule = selectedRule.replace(
      "(menu_sub_category = 'item_hier_1 = '13' and item_hier_2 = '248'')",
      "((ca.cust_id in (select cust_id from fridays_refined.trans_pay where trans_id in (select trans_id from fridays_refined.trans_detail where item_id in (select item_id from fridays_refined.item where item_hier_1 = '13' and item_hier_2 = '248')))))"
    );

    selectedRule = selectedRule.replace(
      "(menu_sub_category = 'item_hier_1 = '13' and item_hier_2 = '323'')",
      "((ca.cust_id in (select cust_id from fridays_refined.trans_pay where trans_id in (select trans_id from fridays_refined.trans_detail where item_id in (select item_id from fridays_refined.item where item_hier_1 = '13' and item_hier_2 = '323')))))"
    );
    selectedRule = selectedRule.replace(
      "(menu_sub_category = 'item_hier_1 = '13' and item_hier_2 = '888'')",
      "((ca.cust_id in (select cust_id from fridays_refined.trans_pay where trans_id in (select trans_id from fridays_refined.trans_detail where item_id in (select item_id from fridays_refined.item where item_hier_1 = '13' and item_hier_2 = '888')))))"
    );
    selectedRule = selectedRule.replace(
      "(menu_sub_category = 'item_hier_1 = '13' and item_hier_2 = '242'')",
      "((ca.cust_id in (select cust_id from fridays_refined.trans_pay where trans_id in (select trans_id from fridays_refined.trans_detail where item_id in (select item_id from fridays_refined.item where item_hier_1 = '13' and item_hier_2 = '242')))))"
    );
    selectedRule = selectedRule.replace(
      "(menu_sub_category = 'item_hier_1 = '13' and item_hier_2 = '245'')",
      "((ca.cust_id in (select cust_id from fridays_refined.trans_pay where trans_id in (select trans_id from fridays_refined.trans_detail where item_id in (select item_id from fridays_refined.item where item_hier_1 = '13' and item_hier_2 = '245')))))"
    );
    selectedRule = selectedRule.replace(
      "(menu_sub_category = 'item_hier_1 = '18' and item_hier_2 = '267'')",
      "((ca.cust_id in (select cust_id from fridays_refined.trans_pay where trans_id in (select trans_id from fridays_refined.trans_detail where item_id in (select item_id from fridays_refined.item where item_hier_1 = '18' and item_hier_2 = '267')))))"
    );
    selectedRule = selectedRule.replace(
      "(menu_sub_category = 'item_hier_1 = '13' and item_hier_2 = '249'')",
      "((ca.cust_id in (select cust_id from fridays_refined.trans_pay where trans_id in (select trans_id from fridays_refined.trans_detail where item_id in (select item_id from fridays_refined.item where item_hier_1 = '13' and item_hier_2 = '249')))))"
    );
    selectedRule = selectedRule.replace(
      "(menu_sub_category = 'item_hier_1 = '27' and item_hier_2 = '23'')",
      "((ca.cust_id in (select cust_id from fridays_refined.trans_pay where trans_id in (select trans_id from fridays_refined.trans_detail where item_id in (select item_id from fridays_refined.item where item_hier_1 = '27' and item_hier_2 = '23')))))"
    );
    selectedRule = selectedRule.replace(
      "(menu_sub_category = 'item_hier_1 = '13' and item_hier_2 = '278'')",
      "((ca.cust_id in (select cust_id from fridays_refined.trans_pay where trans_id in (select trans_id from fridays_refined.trans_detail where item_id in (select item_id from fridays_refined.item where item_hier_1 = '13' and item_hier_2 = '278')))))"
    );
    selectedRule = selectedRule.replace(
      "(menu_sub_category = 'item_hier_1 = '13' and item_hier_2 = '19'')",
      "((ca.cust_id in (select cust_id from fridays_refined.trans_pay where trans_id in (select trans_id from fridays_refined.trans_detail where item_id in (select item_id from fridays_refined.item where item_hier_1 = '13' and item_hier_2 = '19')))))"
    );
    selectedRule = selectedRule.replace(
      "(menu_sub_category = 'item_hier_1 = '38' and item_hier_2 = '16'')",
      "((ca.cust_id in (select cust_id from fridays_refined.trans_pay where trans_id in (select trans_id from fridays_refined.trans_detail where item_id in (select item_id from fridays_refined.item where item_hier_1 = '38' and item_hier_2 = '16')))))"
    );
    selectedRule = selectedRule.replace(
      "(menu_sub_category = 'item_hier_1 = '5' and item_hier_2 = '348'')",
      "((ca.cust_id in (select cust_id from fridays_refined.trans_pay where trans_id in (select trans_id from fridays_refined.trans_detail where item_id in (select item_id from fridays_refined.item where item_hier_1 = '5' and item_hier_2 = '348')))))"
    );
    selectedRule = selectedRule.replace(
      "(menu_sub_category = 'item_hier_1 = '13' and item_hier_2 = '1'')",
      "((ca.cust_id in (select cust_id from fridays_refined.trans_pay where trans_id in (select trans_id from fridays_refined.trans_detail where item_id in (select item_id from fridays_refined.item where item_hier_1 = '13' and item_hier_2 = '1')))))"
    );
    selectedRule = selectedRule.replace(
      "(menu_sub_category = 'item_hier_1 = '13' and item_hier_2 = '31'')",
      "((ca.cust_id in (select cust_id from fridays_refined.trans_pay where trans_id in (select trans_id from fridays_refined.trans_detail where item_id in (select item_id from fridays_refined.item where item_hier_1 = '13' and item_hier_2 = '31')))))"
    );
    selectedRule = selectedRule.replace(
      "(menu_sub_category = 'item_hier_1 = '5' and item_hier_2 = '269'')",
      "((ca.cust_id in (select cust_id from fridays_refined.trans_pay where trans_id in (select trans_id from fridays_refined.trans_detail where item_id in (select item_id from fridays_refined.item where item_hier_1 = '5' and item_hier_2 = '269')))))"
    );

    // Friday's Redemption Filter changes

    selectedRule = selectedRule.replace(
      "(ca.cust_id in (select distinct cust_id from fridays_refined.loyalty_checkins where points_spent > 0 and trans_dt >= current_date - interval '30' day) = false)",
      "(ca.cust_id in (select distinct cust_id from fridays_refined.loyalty_checkins where points_spent = 0 and trans_dt >= current_date - interval '30' day))"
    );

    selectedRule = selectedRule.replace(
      "(ca.cust_id in (select distinct cust_id from fridays_refined.loyalty_checkins where points_spent > 0 and trans_dt >= current_date - interval '30' day) = true)",
      "(ca.cust_id in (select distinct cust_id from fridays_refined.loyalty_checkins where points_spent > 0 and trans_dt >= current_date - interval '30' day))"
    );

    selectedRule = selectedRule.replace(
      "(ca.cust_id in (select distinct cust_id from fridays_refined.loyalty_checkins where points_spent > 0 and trans_dt >= current_date - interval '60' day) = false)",
      "(ca.cust_id in (select distinct cust_id from fridays_refined.loyalty_checkins where points_spent = 0 and trans_dt >= current_date - interval '60' day))"
    );

    selectedRule = selectedRule.replace(
      "(ca.cust_id in (select distinct cust_id from fridays_refined.loyalty_checkins where points_spent > 0 and trans_dt >= current_date - interval '60' day) = true)",
      "(ca.cust_id in (select distinct cust_id from fridays_refined.loyalty_checkins where points_spent > 0 and trans_dt >= current_date - interval '60' day))"
    );

    selectedRule = selectedRule.replace(
      "(ca.cust_id in (select distinct cust_id from fridays_refined.loyalty_checkins where points_spent > 0 and trans_dt >= current_date - interval '90' day) = false)",
      "(ca.cust_id in (select distinct cust_id from fridays_refined.loyalty_checkins where points_spent = 0 and trans_dt >= current_date - interval '90' day))"
    );

    selectedRule = selectedRule.replace(
      "(ca.cust_id in (select distinct cust_id from fridays_refined.loyalty_checkins where points_spent > 0 and trans_dt >= current_date - interval '90' day) = true)",
      "(ca.cust_id in (select distinct cust_id from fridays_refined.loyalty_checkins where points_spent > 0 and trans_dt >= current_date - interval '90' day))"
    );

    selectedRule = selectedRule.replace(
      "(ca.cust_id in (select distinct cust_id from fridays_refined.loyalty_checkins where points_spent > 0 and trans_dt >= current_date - interval '180' day) = false)",
      "(ca.cust_id in (select distinct cust_id from fridays_refined.loyalty_checkins where points_spent = 0 and trans_dt >= current_date - interval '180' day))"
    );

    selectedRule = selectedRule.replace(
      "(ca.cust_id in (select distinct cust_id from fridays_refined.loyalty_checkins where points_spent > 0 and trans_dt >= current_date - interval '180' day) = true)",
      "(ca.cust_id in (select distinct cust_id from fridays_refined.loyalty_checkins where points_spent > 0 and trans_dt >= current_date - interval '180' day))"
    );

    selectedRule = selectedRule.replace(
      "(ca.cust_id in (select distinct cust_id from fridays_refined.loyalty_checkins where points_spent > 0 and trans_dt >= current_date - interval '365' day) = false)",
      "(ca.cust_id in (select distinct cust_id from fridays_refined.loyalty_checkins where points_spent = 0 and trans_dt >= current_date - interval '365' day))"
    );

    selectedRule = selectedRule.replace(
      "(ca.cust_id in (select distinct cust_id from fridays_refined.loyalty_checkins where points_spent > 0 and trans_dt >= current_date - interval '365' day) = true)",
      "(ca.cust_id in (select distinct cust_id from fridays_refined.loyalty_checkins where points_spent > 0 and trans_dt >= current_date - interval '365' day))"
    );

    // Friday's Discount Sales Filter changes

    selectedRule = selectedRule.replace(
      "(ca.cust_id in (select distinct cust_id from fridays_refined.trans_pay where pay_disc_amt > 0 and cust_id is not null and trans_dt >= current_date - interval '30' day) = false)",
      "(ca.cust_id in (select distinct cust_id from fridays_refined.trans_pay where pay_disc_amt = 0 and cust_id is not null and trans_dt >= current_date - interval '30' day))"
    );

    selectedRule = selectedRule.replace(
      "(ca.cust_id in (select distinct cust_id from fridays_refined.trans_pay where pay_disc_amt > 0 and cust_id is not null and trans_dt >= current_date - interval '30' day) = true)",
      "(ca.cust_id in (select distinct cust_id from fridays_refined.trans_pay where pay_disc_amt > 0 and cust_id is not null and trans_dt >= current_date - interval '30' day))"
    );

    selectedRule = selectedRule.replace(
      "(ca.cust_id in (select distinct cust_id from fridays_refined.trans_pay where pay_disc_amt > 0 and cust_id is not null and trans_dt >= current_date - interval '60' day) = false)",
      "(ca.cust_id in (select distinct cust_id from fridays_refined.trans_pay where pay_disc_amt = 0 and cust_id is not null and trans_dt >= current_date - interval '60' day))"
    );

    selectedRule = selectedRule.replace(
      "(ca.cust_id in (select distinct cust_id from fridays_refined.trans_pay where pay_disc_amt > 0 and cust_id is not null and trans_dt >= current_date - interval '60' day) = true)",
      "(ca.cust_id in (select distinct cust_id from fridays_refined.trans_pay where pay_disc_amt > 0 and cust_id is not null and trans_dt >= current_date - interval '60' day))"
    );

    selectedRule = selectedRule.replace(
      "(ca.cust_id in (select distinct cust_id from fridays_refined.trans_pay where pay_disc_amt > 0 and cust_id is not null and trans_dt >= current_date - interval '90' day) = false)",
      "(ca.cust_id in (select distinct cust_id from fridays_refined.trans_pay where pay_disc_amt = 0 and cust_id is not null and trans_dt >= current_date - interval '90' day))"
    );

    selectedRule = selectedRule.replace(
      "(ca.cust_id in (select distinct cust_id from fridays_refined.trans_pay where pay_disc_amt > 0 and cust_id is not null and trans_dt >= current_date - interval '90' day) = true)",
      "(ca.cust_id in (select distinct cust_id from fridays_refined.trans_pay where pay_disc_amt > 0 and cust_id is not null and trans_dt >= current_date - interval '90' day))"
    );

    selectedRule = selectedRule.replace(
      "(ca.cust_id in (select distinct cust_id from fridays_refined.trans_pay where pay_disc_amt > 0 and cust_id is not null and trans_dt >= current_date - interval '180' day) = false)",
      "(ca.cust_id in (select distinct cust_id from fridays_refined.trans_pay where pay_disc_amt = 0 and cust_id is not null and trans_dt >= current_date - interval '180' day))"
    );

    selectedRule = selectedRule.replace(
      "(ca.cust_id in (select distinct cust_id from fridays_refined.trans_pay where pay_disc_amt > 0 and cust_id is not null and trans_dt >= current_date - interval '180' day) = true)",
      "(ca.cust_id in (select distinct cust_id from fridays_refined.trans_pay where pay_disc_amt > 0 and cust_id is not null and trans_dt >= current_date - interval '180' day))"
    );

    selectedRule = selectedRule.replace(
      "(ca.cust_id in (select distinct cust_id from fridays_refined.trans_pay where pay_disc_amt > 0 and cust_id is not null and trans_dt >= current_date - interval '365' day) = false)",
      "(ca.cust_id in (select distinct cust_id from fridays_refined.trans_pay where pay_disc_amt = 0 and cust_id is not null and trans_dt >= current_date - interval '365' day))"
    );

    selectedRule = selectedRule.replace(
      "(ca.cust_id in (select distinct cust_id from fridays_refined.trans_pay where pay_disc_amt > 0 and cust_id is not null and trans_dt >= current_date - interval '365' day) = true)",
      "(ca.cust_id in (select distinct cust_id from fridays_refined.trans_pay where pay_disc_amt > 0 and cust_id is not null and trans_dt >= current_date - interval '365' day))"
    );

    // console.log("Model Decile Condition is : " + modelDecileSelectedRule);
    // console.log(
    //   "Non Model Decile Condition is : " + nonModelDecileSelectedRule
    // );

    let lastConditionProspect = modelDecileSelectedRule.slice(
      modelDecileSelectedRule.length - 4
    );
    if (lastConditionProspect.trim() == "AND") {
      modelDecileSelectedRule = modelDecileSelectedRule.slice(0, -4);
    }

    let lastConditionCustomer = nonModelDecileSelectedRule.slice(
      nonModelDecileSelectedRule.length - 4
    );
    if (lastConditionCustomer.trim() == "AND") {
      nonModelDecileSelectedRule = nonModelDecileSelectedRule.slice(0, -4);
      // nonModelDecileSelectedRule = nonModelDecileSelectedRule.slice(1);
    }
    // console.log(
    //   "Model Decile After Removing Condition is : " + modelDecileSelectedRule
    // );
    // console.log(
    //   "Non Model Decile After Removing Condition is : " +
    //     nonModelDecileSelectedRule
    // );

    // let where = this.getWhereCondition();
    let whereArray = this.getWhereCondition();
    // console.log("The Where Array iS: " + whereArray);
    let where = whereArray[0];
    // console.log("The Where iS: " + where);
    // console.log(where);
    let locationConditionForAcquisitionQuery = whereArray[1];

    let filtersSamplingSelectedRule = whereArray[3];
    let filtersModelDecileSelectedRule = whereArray[2];
    let filtersNonModelDecileSelectedRule = whereArray[1];
    let fQS = ";";

    // let goodwillDoNotContactListCondition =
    //   " AND lo.email_address NOT IN (select email_address from goodwill_refined.dnc_list)";

    // schemaName variable represents the database name (eg: {client_name.refined})
    let schemaName = this.decryptLocal("custDb");

    let globalFilter = this.decryptLocal("globalFilter");

    let channelIdentity = "oe.email_address";
    let selectedProgram = "preclub";
    let selectedChannel = this.decryptLocal("activeChannel");

    let selectedClientId = this.decryptLocal("clientId");

    if (
      selectedChannel === "d1606aea-0c0d-4fba-83e8-a124f414a953" ||
      selectedChannel === "a8f39ffb-24c5-432a-9bcd-e5d0166a320e" ||
      selectedChannel === "79b91604-9f03-428a-9026-9be77ca9a687"
    ) {
      // Display Channel
      channelIdentity = "di.name_addr_key";
      selectedProgram = "display";
    } else if (selectedChannel === "0905c46e-6f48-4ed8-b2a9-35dbbf3bae91") {
      // Preclub Channel
      channelIdentity = "oe.email_address";
      selectedProgram = "preclub";
    } else if (
      selectedChannel === "g786cb0f-eecc-4b87-adef-34eb20f3f766" ||
      selectedChannel === "f786cb0f-eecc-4b87-adef-34eb20f3f766" ||
      selectedChannel === "1d337d2d-e23a-445a-bda6-2405dbb79dcc" ||
      selectedChannel === "88adbfaa-0fc0-49af-a745-d97cb1b4bda7" ||
      selectedChannel === "33bc71b1-4495-43f0-ab64-17ed38270e04"
    ) {
      // Loyalty Channel
      channelIdentity = "lo.loyalty_id";
      selectedProgram = "loyalty";
    } else if (
      selectedChannel === "3b3e90db-f06b-4ba4-9fbb-769637647ab0" ||
      selectedChannel === "25c7cb9a-a192-46f5-b32d-49e8d52afea8" ||
      selectedChannel === "92ec41c7-6724-4891-bc17-24981a3261dd" ||
      selectedChannel === "c2a842ba-36cc-46b7-8fa4-3a361708b34b"
    ) {
      // Eclub Channel
      channelIdentity = "ec.email_address";
      selectedProgram = "eclub";
    } else if (selectedChannel === "8905c46e-6f48-4ed8-b2a9-35dbbf3bae91") {
      // OLO Channel
      channelIdentity = "oc.email_address";
      selectedProgram = "olo";
    }

    // suppressionListCondition variable for suppressions functionality

    let suppressionListCondition = "";
    if (
      selectedChannel !== "d1606aea-0c0d-4fba-83e8-a124f414a953" &&
      selectedChannel !== "a8f39ffb-24c5-432a-9bcd-e5d0166a320e"
    ) {
      suppressionListCondition = ` AND LOWER(${channelIdentity}) NOT IN (
        SELECT channel_identity
        FROM ${schemaName}.suppressions
        WHERE program = '${selectedProgram}') `;
    } else {
      suppressionListCondition = ` AND (LOWER(${channelIdentity}) NOT IN (
        SELECT channel_identity
        FROM ${schemaName}.suppressions) OR ${channelIdentity} is null)
       AND (LOWER(di.email) NOT IN (
        SELECT channel_identity
        FROM ${schemaName}.suppressions WHERE channel_identity is not null) OR di.email is null
      ) `;
    }

    let clientIdArrayWithoutSuppressionCondition = [
      "f0d3b19b-a564-43e9-85dd-bd95f8b13f97",
      "52b86a20-91ae-457b-a6c7-f7708431b645",
      "19357b26-ddae-4b3a-9e95-b5879f1e9572",
      "74d71e90-46e0-45b8-9b6e-a96883e85d54",
      "c566b59a-7y94-4ag0-96cf-88av8084d1s3",
      "d680b646-86d8-4d6c-b268-1ed505dc9de0",
      "2bdbd6af-6cd3-4358-a1a0-437226a20ee9",
    ];

    let custIdToBeSuppressed = "";
    if (selectedClientId === "dc0df8ce-c87e-4746-a00e-d2c9ee4d7534") {
      custIdToBeSuppressed = this.decryptLocal("suppressionCustId");
    }

    if (selectedCustomerType === "Customer") {
      if (
        selectedClientId === "8c001fde-3728-48dc-9950-b8480ca9fbee" ||
        selectedClientId === "3fe7e557-16f5-406c-bbc8-887fdec7ba8b" ||
        selectedClientId === "d1522630-2b9d-424e-a399-7ab3f7be274f" ||
        selectedClientId === "7203dd51-f88b-4a4b-877c-92326d027915" ||
        selectedClientId === "f1fbce23-e2ef-463c-bc97-6cde3c4cc4ac" ||
        selectedClientId === "874b6c6a-83ff-480b-b615-1972538813ba" ||
        selectedClientId === "b76e7818-deb1-4526-93a7-b398df3ea357" ||
        selectedClientId === "e08840c5-c7d0-48c7-9c24-124b4cd80735" || 
        selectedClientId === "68a4d4cc-1e57-4ccf-9dd1-a5ae890d0f2e" ||
        selectedClientId === "0bc2a383-9ae0-4e9e-9652-0fb762ba6119" ||
        selectedClientId === "7bf99619-30a3-47a3-b1de-d72b4f7f99a7" ||
        selectedClientId === "a4dda78e-7678-4aaf-9bef-60a229085fc8" ||
        selectedClientId === "83da098f-2fc7-4b98-8455-c08f9aceb4ed" ||
        selectedClientId === "cf6144d2-bb68-43b6-9876-dbf620b57c21" ||
        selectedClientId === "37f97bea-f005-4be1-8e41-286ad79a7f3a" ||
        selectedClientId === "ec5a162e-5e87-4819-93bd-70bbf3b5f096" ||
        selectedClientId === "24ab940a-50d2-41fd-b3b2-c67ca6cb0304" ||
        selectedClientId === "535a90f3-b463-4d5a-9a83-39c522589a6c"
      ) {
        // ("KAHALA CLIENT");
        if (
          selectedChannel === "d1606aea-0c0d-4fba-83e8-a124f414a953" ||
          selectedChannel === "a8f39ffb-24c5-432a-9bcd-e5d0166a320e"
        ) {
          if (where == "") {
            // fQS =
            //   "select CASE " +
            //   selectedRule +
            //   " ELSE 'Remainder' END segment, count(distinct(ca.cust_id)) count FROM " +
            //   JSON.parse(
            //     CryptoJS.AES.decrypt(
            //       localStorage.getItem("custDb"),
            //       process.env.REACT_APP_PASS
            //     ).toString(CryptoJS.enc.Utf8)
            //   ) +
            //   ".cust_analytic ca LEFT JOIN " +
            //   JSON.parse(
            //     CryptoJS.AES.decrypt(
            //       localStorage.getItem("custDb"),
            //       process.env.REACT_APP_PASS
            //     ).toString(CryptoJS.enc.Utf8)
            //   ) +
            //   ".client_intellibase ci ON ci.cust_id = ca.cust_id LEFT JOIN (SELECT * FROM (SELECT rank() OVER (partition by email_address, geo_concept ORDER BY em_match_level, cust_id) rank, * FROM " +
            //   JSON.parse(
            //     CryptoJS.AES.decrypt(
            //       localStorage.getItem("custDb"),
            //       process.env.REACT_APP_PASS
            //     ).toString(CryptoJS.enc.Utf8)
            //   ) +
            //   ".owned_email ) WHERE rank = 1 ) oe ON oe.cust_id = ca.cust_id AND oe.geo_concept = ca.geo_concept LEFT JOIN " +
            //   // JSON.parse(
            //   //   CryptoJS.AES.decrypt(
            //   //     localStorage.getItem("custDb"),
            //   //     process.env.REACT_APP_PASS
            //   //   ).toString(CryptoJS.enc.Utf8)
            //   // ) +
            //   // ".eclub ec ON ec.cust_id = ca.cust_id AND ec.eclub_geo_concept = ca.geo_concept LEFT JOIN " +
            //   JSON.parse(
            //     CryptoJS.AES.decrypt(
            //       localStorage.getItem("custDb"),
            //       process.env.REACT_APP_PASS
            //     ).toString(CryptoJS.enc.Utf8)
            //   ) +
            //   ".geo geo ON geo.geo_id = ca.geo_id_fav AND geo.geo_concept = ca.geo_concept LEFT JOIN " +
            //   // JSON.parse(
            //   //   CryptoJS.AES.decrypt(
            //   //     localStorage.getItem("custDb"),
            //   //     process.env.REACT_APP_PASS
            //   //   ).toString(CryptoJS.enc.Utf8)
            //   // ) +
            //   // // ".loyalty lo ON lo.cust_id = ca.cust_id AND lo.geo_concept = ca.geo_concept WHERE " +
            //   // ".loyalty lo ON lo.cust_id = ca.cust_id AND lo.geo_concept = ca.geo_concept LEFT JOIN " +
            //   JSON.parse(
            //     CryptoJS.AES.decrypt(
            //       localStorage.getItem("custDb"),
            //       process.env.REACT_APP_PASS
            //     ).toString(CryptoJS.enc.Utf8)
            //   ) +
            //   ".display di ON di.cust_id = ca.cust_id WHERE " +
            //   JSON.parse(
            //     CryptoJS.AES.decrypt(
            //       localStorage.getItem("globalFilter"),
            //       process.env.REACT_APP_PASS
            //     ).toString(CryptoJS.enc.Utf8)
            //   ) +
            //   " AND di.audience_type = 'Customer'" +
            //   " GROUP BY 1";

            fQS =
              "select CASE " +
              selectedRule +
              " ELSE 'Remainder' END segment, count(distinct(di.cust_id)) count FROM " +
              this.decryptLocal("custDb") +
              ".display_customers di LEFT JOIN " +
              this.decryptLocal("custDb") +
              ".cust_analytic ca ON di.cust_id = ca.cust_id LEFT JOIN " +
              this.decryptLocal("custDb") +
              ".client_intellibase ci ON ci.cust_id = di.cust_id LEFT JOIN (SELECT * FROM (SELECT rank() OVER (partition by email_address, geo_concept ORDER BY em_match_level, cust_id) rank, * FROM " +
              this.decryptLocal("custDb") +
              ".owned_email ) WHERE rank = 1 ) oe ON oe.cust_id = di.cust_id AND oe.geo_concept = di.geo_concept LEFT JOIN " +
              this.decryptLocal("custDb") +
              ".geo geo ON geo.geo_id = di.geo_id AND geo.geo_concept = di.geo_concept WHERE " +
              globalFilter +
              " AND di.audience_type = 'Customer'" +
              ((selectedChannel === 'a8f39ffb-24c5-432a-9bcd-e5d0166a320e')? " AND ((control_flag = true) or (NULLIF(di.address, '') IS NOT NULL AND NULLIF(di.city, '') IS NOT NULL AND NULLIF(di.state, '') IS NOT NULL AND NULLIF(di.zip, '') IS NOT NULL)) ": "")+
              // suppressionListCondition +
              " GROUP BY 1";
          } else {
            if (where.includes("li.")) {
              // fQS =
              //   "select CASE " +
              //   selectedRule +
              //   " ELSE 'Remainder' END segment, count(distinct(ca.cust_id)) count FROM " +
              //   JSON.parse(
              //     CryptoJS.AES.decrypt(
              //       localStorage.getItem("custDb"),
              //       process.env.REACT_APP_PASS
              //     ).toString(CryptoJS.enc.Utf8)
              //   ) +
              //   ".cust_analytic ca LEFT JOIN " +
              //   JSON.parse(
              //     CryptoJS.AES.decrypt(
              //       localStorage.getItem("custDb"),
              //       process.env.REACT_APP_PASS
              //     ).toString(CryptoJS.enc.Utf8)
              //   ) +
              //   ".client_intellibase ci ON ci.cust_id = ca.cust_id LEFT JOIN (SELECT * FROM (SELECT rank() OVER (partition by email_address, geo_concept ORDER BY em_match_level, cust_id) rank, * FROM " +
              //   JSON.parse(
              //     CryptoJS.AES.decrypt(
              //       localStorage.getItem("custDb"),
              //       process.env.REACT_APP_PASS
              //     ).toString(CryptoJS.enc.Utf8)
              //   ) +
              //   ".owned_email ) WHERE rank = 1 ) oe ON oe.cust_id = ca.cust_id AND oe.geo_concept = ca.geo_concept LEFT JOIN " +
              //   // JSON.parse(
              //   //   CryptoJS.AES.decrypt(
              //   //     localStorage.getItem("custDb"),
              //   //     process.env.REACT_APP_PASS
              //   //   ).toString(CryptoJS.enc.Utf8)
              //   // ) +
              //   // ".eclub ec ON ec.cust_id = ca.cust_id AND ec.eclub_geo_concept = ca.geo_concept LEFT JOIN " +
              //   JSON.parse(
              //     CryptoJS.AES.decrypt(
              //       localStorage.getItem("custDb"),
              //       process.env.REACT_APP_PASS
              //     ).toString(CryptoJS.enc.Utf8)
              //   ) +
              //   ".geo geo ON geo.geo_id = ca.geo_id_fav AND geo.geo_concept = ca.geo_concept LEFT JOIN " +
              //   // JSON.parse(
              //   //   CryptoJS.AES.decrypt(
              //   //     localStorage.getItem("custDb"),
              //   //     process.env.REACT_APP_PASS
              //   //   ).toString(CryptoJS.enc.Utf8)
              //   // ) +
              //   // ".loyalty lo ON lo.cust_id = ca.cust_id AND lo.geo_concept = ca.geo_concept LEFT JOIN " +
              //   // JSON.parse(
              //   //   CryptoJS.AES.decrypt(
              //   //     localStorage.getItem("custDb"),
              //   //     process.env.REACT_APP_PASS
              //   //   ).toString(CryptoJS.enc.Utf8)
              //   // ).split("_")[0] +
              //   // "_raw.lists_preclub li ON li.cust_id = ca.cust_id WHERE " +
              //   JSON.parse(
              //     CryptoJS.AES.decrypt(
              //       localStorage.getItem("custDb"),
              //       process.env.REACT_APP_PASS
              //     ).toString(CryptoJS.enc.Utf8)
              //   ) +
              //   ".display di ON di.cust_id = ca.cust_id WHERE " +
              //   JSON.parse(
              //     CryptoJS.AES.decrypt(
              //       localStorage.getItem("globalFilter"),
              //       process.env.REACT_APP_PASS
              //     ).toString(CryptoJS.enc.Utf8)
              //   ) +
              //   " AND " +
              //   where +
              //   (this.state.localStorageClientId ===
              //   "2bdbd6af-6cd3-4358-a1a0-437226a20ee9"
              //     ? goodwillDoNotContactListCondition
              //     : "") +
              //   " AND di.audience_type = 'Customer'" +
              //   " GROUP BY 1";

              fQS =
                "select CASE " +
                selectedRule +
                " ELSE 'Remainder' END segment, count(distinct(di.cust_id)) count FROM " +
                this.decryptLocal("custDb") +
                ".display_customers di LEFT JOIN " +
                this.decryptLocal("custDb") +
                ".cust_analytic ca ON di.cust_id = ca.cust_id LEFT JOIN " +
                this.decryptLocal("custDb") +
                ".client_intellibase ci ON ci.cust_id = di.cust_id LEFT JOIN (SELECT * FROM (SELECT rank() OVER (partition by email_address, geo_concept ORDER BY em_match_level, cust_id) rank, * FROM " +
                this.decryptLocal("custDb") +
                ".owned_email ) WHERE rank = 1 ) oe ON oe.cust_id = di.cust_id AND oe.geo_concept = di.geo_concept LEFT JOIN " +
                this.decryptLocal("custDb") +
                ".geo geo ON geo.geo_id = di.geo_id AND geo.geo_concept = di.geo_concept WHERE " +
                globalFilter +
                " AND " +
                where +
                " AND di.audience_type = 'Customer'" +
                // suppressionListCondition +
                " GROUP BY 1";
            } else {
              // fQS =
              //   "select CASE " +
              //   selectedRule +
              //   " ELSE 'Remainder' END segment, count(distinct(ca.cust_id)) count FROM " +
              //   JSON.parse(
              //     CryptoJS.AES.decrypt(
              //       localStorage.getItem("custDb"),
              //       process.env.REACT_APP_PASS
              //     ).toString(CryptoJS.enc.Utf8)
              //   ) +
              //   ".cust_analytic ca LEFT JOIN " +
              //   JSON.parse(
              //     CryptoJS.AES.decrypt(
              //       localStorage.getItem("custDb"),
              //       process.env.REACT_APP_PASS
              //     ).toString(CryptoJS.enc.Utf8)
              //   ) +
              //   ".client_intellibase ci ON ci.cust_id = ca.cust_id LEFT JOIN (SELECT * FROM (SELECT rank() OVER (partition by email_address, geo_concept ORDER BY em_match_level, cust_id) rank, * FROM " +
              //   JSON.parse(
              //     CryptoJS.AES.decrypt(
              //       localStorage.getItem("custDb"),
              //       process.env.REACT_APP_PASS
              //     ).toString(CryptoJS.enc.Utf8)
              //   ) +
              //   ".owned_email ) WHERE rank = 1 ) oe ON oe.cust_id = ca.cust_id AND oe.geo_concept = ca.geo_concept LEFT JOIN " +
              //   // JSON.parse(
              //   //   CryptoJS.AES.decrypt(
              //   //     localStorage.getItem("custDb"),
              //   //     process.env.REACT_APP_PASS
              //   //   ).toString(CryptoJS.enc.Utf8)
              //   // ) +
              //   // ".eclub ec ON ec.cust_id = ca.cust_id AND ec.eclub_geo_concept = ca.geo_concept LEFT JOIN " +
              //   JSON.parse(
              //     CryptoJS.AES.decrypt(
              //       localStorage.getItem("custDb"),
              //       process.env.REACT_APP_PASS
              //     ).toString(CryptoJS.enc.Utf8)
              //   ) +
              //   ".geo geo ON geo.geo_id = ca.geo_id_fav AND geo.geo_concept = ca.geo_concept LEFT JOIN " +
              //   // JSON.parse(
              //   //   CryptoJS.AES.decrypt(
              //   //     localStorage.getItem("custDb"),
              //   //     process.env.REACT_APP_PASS
              //   //   ).toString(CryptoJS.enc.Utf8)
              //   // ) +
              //   // // ".loyalty lo ON lo.cust_id = ca.cust_id AND lo.geo_concept = ca.geo_concept WHERE " +
              //   // ".loyalty lo ON lo.cust_id = ca.cust_id AND lo.geo_concept = ca.geo_concept LEFT JOIN " +
              //   JSON.parse(
              //     CryptoJS.AES.decrypt(
              //       localStorage.getItem("custDb"),
              //       process.env.REACT_APP_PASS
              //     ).toString(CryptoJS.enc.Utf8)
              //   ) +
              //   ".display di ON di.cust_id = ca.cust_id WHERE " +
              //   JSON.parse(
              //     CryptoJS.AES.decrypt(
              //       localStorage.getItem("globalFilter"),
              //       process.env.REACT_APP_PASS
              //     ).toString(CryptoJS.enc.Utf8)
              //   ) +
              //   " AND " +
              //   where +
              //   " AND di.audience_type = 'Customer'" +
              //   " GROUP BY 1";

              fQS =
                "select CASE " +
                selectedRule +
                " ELSE 'Remainder' END segment, count(distinct(di.cust_id)) count FROM " +
                this.decryptLocal("custDb") +
                ".display_customers di LEFT JOIN " +
                this.decryptLocal("custDb") +
                ".cust_analytic ca ON di.cust_id = ca.cust_id LEFT JOIN " +
                this.decryptLocal("custDb") +
                ".client_intellibase ci ON ci.cust_id = di.cust_id LEFT JOIN (SELECT * FROM (SELECT rank() OVER (partition by email_address, geo_concept ORDER BY em_match_level, cust_id) rank, * FROM " +
                this.decryptLocal("custDb") +
                ".owned_email ) WHERE rank = 1 ) oe ON oe.cust_id = di.cust_id AND oe.geo_concept = di.geo_concept LEFT JOIN " +
                this.decryptLocal("custDb") +
                ".geo geo ON geo.geo_id = di.geo_id AND geo.geo_concept = di.geo_concept WHERE " +
                globalFilter +
                " AND " +
                where +
                " AND di.audience_type = 'Customer'" +
                // suppressionListCondition +
                " GROUP BY 1";
            }
          }
        }
        else if (
          selectedChannel === "33bc71b1-4495-43f0-ab64-17ed38270e04"
        ) {
          // Kahala Loyalty Channel - SMS
          if (where == "") {
            fQS =
              "select CASE " +
              selectedRule +
              " ELSE 'Remainder' END segment, count(distinct(ca.cust_id)) count FROM " +
              this.decryptLocal("custDb") +
              ".cust_analytic ca LEFT JOIN " +
              this.decryptLocal("custDb") +
              ".client_intellibase ci ON ci.cust_id = ca.cust_id LEFT JOIN (SELECT * FROM (SELECT rank() OVER (partition by email_address, geo_concept ORDER BY em_match_level, cust_id) rank, * FROM " +
              this.decryptLocal("custDb") +
              ".owned_email ) WHERE rank = 1 ) oe ON oe.cust_id = ca.cust_id AND oe.geo_concept = ca.geo_concept LEFT JOIN " +
              this.decryptLocal("custDb") +
              ".geo geo ON geo.geo_id = ca.geo_id_fav AND geo.geo_concept = ca.geo_concept LEFT JOIN " +
              this.decryptLocal("custDb") +
              ".loyalty lo ON lo.cust_id = ca.cust_id AND lo.geo_concept = ca.geo_concept WHERE " +
              this.decryptLocal("globalFilter") +
              "AND (lo.loyalty_opt_out = false AND lo.sms_marketable = true) AND " +
              suppressionListCondition +
              " GROUP BY 1";

          } else {
            if (where.includes("li.")) {
              fQS =
                "select CASE " +
                selectedRule +
                " ELSE 'Remainder' END segment, count(distinct(ca.cust_id)) count FROM " +
                this.decryptLocal("custDb") +
                ".cust_analytic ca LEFT JOIN " +
                this.decryptLocal("custDb") +
                ".client_intellibase ci ON ci.cust_id = ca.cust_id LEFT JOIN (SELECT * FROM (SELECT rank() OVER (partition by email_address, geo_concept ORDER BY em_match_level, cust_id) rank, * FROM " +
                this.decryptLocal("custDb") +
                ".owned_email ) WHERE rank = 1 ) oe ON oe.cust_id = ca.cust_id AND oe.geo_concept = ca.geo_concept LEFT JOIN " +
                this.decryptLocal("custDb") +
                ".geo geo ON geo.geo_id = ca.geo_id_fav AND geo.geo_concept = ca.geo_concept LEFT JOIN " +
                this.decryptLocal("custDb") +
                ".loyalty lo ON lo.cust_id = ca.cust_id AND lo.geo_concept = ca.geo_concept WHERE " +
                this.decryptLocal("globalFilter") +
                "AND (lo.loyalty_opt_out = false AND lo.sms_marketable = true) AND " +
                where +
                suppressionListCondition +
                " GROUP BY 1";

            } else {
              fQS =
                "select CASE " +
                selectedRule +
                " ELSE 'Remainder' END segment, count(distinct(ca.cust_id)) count FROM " +
                this.decryptLocal("custDb") +
                ".cust_analytic ca LEFT JOIN " +
                this.decryptLocal("custDb") +
                ".client_intellibase ci ON ci.cust_id = ca.cust_id LEFT JOIN (SELECT * FROM (SELECT rank() OVER (partition by email_address, geo_concept ORDER BY em_match_level, cust_id) rank, * FROM " +
                this.decryptLocal("custDb") +
                ".owned_email ) WHERE rank = 1 ) oe ON oe.cust_id = ca.cust_id AND oe.geo_concept = ca.geo_concept LEFT JOIN " +
                this.decryptLocal("custDb") +
                ".geo geo ON geo.geo_id = ca.geo_id_fav AND geo.geo_concept = ca.geo_concept LEFT JOIN " +
                this.decryptLocal("custDb") +
                ".loyalty lo ON lo.cust_id = ca.cust_id AND lo.geo_concept = ca.geo_concept WHERE " +
                this.decryptLocal("globalFilter") +
                "AND (lo.loyalty_opt_out = false AND lo.sms_marketable = true) AND " +
                where +
                suppressionListCondition +
                " GROUP BY 1";

            }
          }
        }
        else if (
          selectedChannel === "3c8a9cf7-a0b2-4845-8436-d598181e6d78"
        ) {
          // Kahala Loyalty Channel - CORDIAL
          if (where == "") {
            fQS =
              "select CASE " +
              selectedRule +
              " ELSE 'Remainder' END segment, count(distinct(ca.cust_id)) count FROM " +
              this.decryptLocal("custDb") +
              ".cust_analytic ca LEFT JOIN " +
              this.decryptLocal("custDb") +
              ".client_intellibase ci ON ci.cust_id = ca.cust_id LEFT JOIN (SELECT * FROM (SELECT rank() OVER (partition by email_address, geo_concept ORDER BY em_match_level, cust_id) rank, * FROM " +
              this.decryptLocal("custDb") +
              ".owned_email ) WHERE rank = 1 ) oe ON oe.cust_id = ca.cust_id AND oe.geo_concept = ca.geo_concept LEFT JOIN " +
              (selectedClientId !== "3fe7e557-16f5-406c-bbc8-887fdec7ba8b"
                ? schemaName +
                  ".eclub ec ON ec.cust_id = ca.cust_id AND ec.eclub_geo_concept = ca.geo_concept LEFT JOIN "
                : ` (SELECT cust_id,eclub_geo_concept, max(email_marketable) AS email_marketable FROM ${schemaName}.eclub WHERE email_marketable IS NOT NULL GROUP BY 1,2) ec ON ec.cust_id = ca.cust_id AND ec.eclub_geo_concept = ca.geo_concept LEFT JOIN `) +
              this.decryptLocal("custDb") +
              ".geo geo ON geo.geo_id = ca.geo_id_fav AND geo.geo_concept = ca.geo_concept LEFT JOIN " +
              this.decryptLocal("custDb") +
              ".loyalty lo ON lo.cust_id = ca.cust_id AND lo.geo_concept = ca.geo_concept WHERE " +
              this.decryptLocal("globalFilter") +
              "AND lo.email_address is not null AND " +
              suppressionListCondition +
              " GROUP BY 1";

          } else {
            if (where.includes("li.")) {
              fQS =
                "select CASE " +
                selectedRule +
                " ELSE 'Remainder' END segment, count(distinct(ca.cust_id)) count FROM " +
                this.decryptLocal("custDb") +
                ".cust_analytic ca LEFT JOIN " +
                this.decryptLocal("custDb") +
                ".client_intellibase ci ON ci.cust_id = ca.cust_id LEFT JOIN (SELECT * FROM (SELECT rank() OVER (partition by email_address, geo_concept ORDER BY em_match_level, cust_id) rank, * FROM " +
                this.decryptLocal("custDb") +
                ".owned_email ) WHERE rank = 1 ) oe ON oe.cust_id = ca.cust_id AND oe.geo_concept = ca.geo_concept LEFT JOIN " +
                (selectedClientId !== "3fe7e557-16f5-406c-bbc8-887fdec7ba8b"
                  ? schemaName +
                    ".eclub ec ON ec.cust_id = ca.cust_id AND ec.eclub_geo_concept = ca.geo_concept LEFT JOIN "
                  : ` (SELECT cust_id,eclub_geo_concept, max(email_marketable) AS email_marketable FROM ${schemaName}.eclub WHERE email_marketable IS NOT NULL GROUP BY 1,2) ec ON ec.cust_id = ca.cust_id AND ec.eclub_geo_concept = ca.geo_concept LEFT JOIN `) +
                this.decryptLocal("custDb") +
                ".geo geo ON geo.geo_id = ca.geo_id_fav AND geo.geo_concept = ca.geo_concept LEFT JOIN " +
                this.decryptLocal("custDb") +
                ".loyalty lo ON lo.cust_id = ca.cust_id AND lo.geo_concept = ca.geo_concept WHERE " +
                this.decryptLocal("globalFilter") +
                "AND lo.email_address is not null AND " +
                where +
                suppressionListCondition +
                " GROUP BY 1";

            } else {
              fQS =
                "select CASE " +
                selectedRule +
                " ELSE 'Remainder' END segment, count(distinct(ca.cust_id)) count FROM " +
                this.decryptLocal("custDb") +
                ".cust_analytic ca LEFT JOIN " +
                this.decryptLocal("custDb") +
                ".client_intellibase ci ON ci.cust_id = ca.cust_id LEFT JOIN (SELECT * FROM (SELECT rank() OVER (partition by email_address, geo_concept ORDER BY em_match_level, cust_id) rank, * FROM " +
                this.decryptLocal("custDb") +
                ".owned_email ) WHERE rank = 1 ) oe ON oe.cust_id = ca.cust_id AND oe.geo_concept = ca.geo_concept LEFT JOIN " +
                (selectedClientId !== "3fe7e557-16f5-406c-bbc8-887fdec7ba8b"
                  ? schemaName +
                    ".eclub ec ON ec.cust_id = ca.cust_id AND ec.eclub_geo_concept = ca.geo_concept LEFT JOIN "
                  : ` (SELECT cust_id,eclub_geo_concept, max(email_marketable) AS email_marketable FROM ${schemaName}.eclub WHERE email_marketable IS NOT NULL GROUP BY 1,2) ec ON ec.cust_id = ca.cust_id AND ec.eclub_geo_concept = ca.geo_concept LEFT JOIN `) +
                this.decryptLocal("custDb") +
                ".geo geo ON geo.geo_id = ca.geo_id_fav AND geo.geo_concept = ca.geo_concept LEFT JOIN " +
                this.decryptLocal("custDb") +
                ".loyalty lo ON lo.cust_id = ca.cust_id AND lo.geo_concept = ca.geo_concept WHERE " +
                this.decryptLocal("globalFilter") +
                "AND lo.email_address is not null AND " +
                where +
                suppressionListCondition +
                " GROUP BY 1";

            }
          }
        }
        else if(
          selectedChannel === "c2a842ba-36cc-46b7-8fa4-3a361708b34b"
        ) {
            // Kahala Eclub Channel - CORDIAL
            if (where == "") {
              fQS =
                "select CASE " +
                selectedRule +
                " ELSE 'Remainder' END segment, count(distinct(ca.cust_id)) count FROM " +
                this.decryptLocal("custDb") +
                ".cust_analytic ca LEFT JOIN " +
                this.decryptLocal("custDb") +
                ".client_intellibase ci ON ci.cust_id = ca.cust_id LEFT JOIN (SELECT * FROM (SELECT rank() OVER (partition by email_address, geo_concept ORDER BY em_match_level, cust_id) rank, * FROM " +
                this.decryptLocal("custDb") +
                ".owned_email ) WHERE rank = 1 ) oe ON oe.cust_id = ca.cust_id AND oe.geo_concept = ca.geo_concept LEFT JOIN " +
                this.decryptLocal("custDb") +
                ".eclub ec ON ec.cust_id = ca.cust_id AND ec.eclub_geo_concept = ca.geo_concept LEFT JOIN " +
                this.decryptLocal("custDb") +
                ".geo geo ON geo.geo_id = ca.geo_id_fav AND geo.geo_concept = ca.geo_concept LEFT JOIN " +
                (selectedClientId !== "3fe7e557-16f5-406c-bbc8-887fdec7ba8b"
                  ? schemaName +
                    ".loyalty lo ON lo.cust_id = ca.cust_id AND lo.geo_concept = ca.geo_concept WHERE "
                  : ` (SELECT cust_id,geo_concept, max(email_marketable) AS email_marketable FROM ${schemaName}.loyalty WHERE email_marketable IS NOT NULL GROUP BY 1,2) lo ON lo.cust_id = ca.cust_id AND lo.geo_concept = ca.geo_concept WHERE `) +
                this.decryptLocal("globalFilter") +
                suppressionListCondition +
                " GROUP BY 1";
            } else {
              if (where.includes("li.")) {
                fQS =
                  "select CASE " +
                  selectedRule +
                  " ELSE 'Remainder' END segment, count(distinct(ca.cust_id)) count FROM " +
                  this.decryptLocal("custDb") +
                  ".cust_analytic ca LEFT JOIN " +
                  this.decryptLocal("custDb") +
                  ".client_intellibase ci ON ci.cust_id = ca.cust_id LEFT JOIN (SELECT * FROM (SELECT rank() OVER (partition by email_address, geo_concept ORDER BY em_match_level, cust_id) rank, * FROM " +
                  this.decryptLocal("custDb") +
                  ".owned_email ) WHERE rank = 1 ) oe ON oe.cust_id = ca.cust_id AND oe.geo_concept = ca.geo_concept LEFT JOIN " +
                  this.decryptLocal("custDb") +
                  ".eclub ec ON ec.cust_id = ca.cust_id AND ec.eclub_geo_concept = ca.geo_concept LEFT JOIN " +
                  this.decryptLocal("custDb") +
                  ".geo geo ON geo.geo_id = ca.geo_id_fav AND geo.geo_concept = ca.geo_concept LEFT JOIN " +
                  (selectedClientId !== "3fe7e557-16f5-406c-bbc8-887fdec7ba8b"
                    ? schemaName +
                      ".loyalty lo ON lo.cust_id = ca.cust_id AND lo.geo_concept = ca.geo_concept WHERE "
                    : ` (SELECT cust_id,geo_concept, max(email_marketable) AS email_marketable FROM ${schemaName}.loyalty WHERE email_marketable IS NOT NULL GROUP BY 1,2) lo ON lo.cust_id = ca.cust_id AND lo.geo_concept = ca.geo_concept WHERE `) +
                  this.decryptLocal("globalFilter") +
                  " AND " +
                  where +
                  suppressionListCondition +
                  " GROUP BY 1";
              } else {
                fQS =
                  "select CASE " +
                  selectedRule +
                  " ELSE 'Remainder' END segment, count(distinct(ca.cust_id)) count FROM " +
                  this.decryptLocal("custDb") +
                  ".cust_analytic ca LEFT JOIN " +
                  this.decryptLocal("custDb") +
                  ".client_intellibase ci ON ci.cust_id = ca.cust_id LEFT JOIN (SELECT * FROM (SELECT rank() OVER (partition by email_address, geo_concept ORDER BY em_match_level, cust_id) rank, * FROM " +
                  this.decryptLocal("custDb") +
                  ".owned_email ) WHERE rank = 1 ) oe ON oe.cust_id = ca.cust_id AND oe.geo_concept = ca.geo_concept LEFT JOIN " +
                  this.decryptLocal("custDb") +
                  ".eclub ec ON ec.cust_id = ca.cust_id AND ec.eclub_geo_concept = ca.geo_concept LEFT JOIN " +
                  this.decryptLocal("custDb") +
                  ".geo geo ON geo.geo_id = ca.geo_id_fav AND geo.geo_concept = ca.geo_concept LEFT JOIN " +
                  (selectedClientId !== "3fe7e557-16f5-406c-bbc8-887fdec7ba8b"
                    ? schemaName +
                      ".loyalty lo ON lo.cust_id = ca.cust_id AND lo.geo_concept = ca.geo_concept WHERE "
                    : ` (SELECT cust_id,geo_concept, max(email_marketable) AS email_marketable FROM ${schemaName}.loyalty WHERE email_marketable IS NOT NULL GROUP BY 1,2) lo ON lo.cust_id = ca.cust_id AND lo.geo_concept = ca.geo_concept WHERE `) +
                  this.decryptLocal("globalFilter") +
                  " AND " +
                  where +
                  suppressionListCondition +
                  " GROUP BY 1";
              }
            }
        }
        else if (
          selectedChannel === "f786cb0f-eecc-4b87-adef-34eb20f3f766" ||
          selectedChannel === "88adbfaa-0fc0-49af-a745-d97cb1b4bda7"
        ) {
          // Kahala Loyalty Channel
          if (where == "") {
            fQS =
              "select CASE " +
              selectedRule +
              " ELSE 'Remainder' END segment, count(distinct(ca.cust_id)) count FROM " +
              this.decryptLocal("custDb") +
              ".cust_analytic ca LEFT JOIN " +
              this.decryptLocal("custDb") +
              ".client_intellibase ci ON ci.cust_id = ca.cust_id LEFT JOIN (SELECT * FROM (SELECT rank() OVER (partition by email_address, geo_concept ORDER BY em_match_level, cust_id) rank, * FROM " +
              this.decryptLocal("custDb") +
              ".owned_email ) WHERE rank = 1 ) oe ON oe.cust_id = ca.cust_id AND oe.geo_concept = ca.geo_concept LEFT JOIN " +
              // JSON.parse(
              //   CryptoJS.AES.decrypt(
              //     localStorage.getItem("custDb"),
              //     process.env.REACT_APP_PASS
              //   ).toString(CryptoJS.enc.Utf8)
              // ) +
              // ".eclub ec ON ec.cust_id = ca.cust_id AND ec.eclub_geo_concept = ca.geo_concept LEFT JOIN " +
              (selectedClientId !== "3fe7e557-16f5-406c-bbc8-887fdec7ba8b"
                ? schemaName +
                  ".eclub ec ON ec.cust_id = ca.cust_id AND ec.eclub_geo_concept = ca.geo_concept LEFT JOIN "
                : ` (SELECT cust_id,eclub_geo_concept, max(email_marketable) AS email_marketable FROM ${schemaName}.eclub WHERE email_marketable IS NOT NULL GROUP BY 1,2) ec ON ec.cust_id = ca.cust_id AND ec.eclub_geo_concept = ca.geo_concept LEFT JOIN `) +
              this.decryptLocal("custDb") +
              ".geo geo ON geo.geo_id = ca.geo_id_fav AND geo.geo_concept = ca.geo_concept LEFT JOIN " +
              this.decryptLocal("custDb") +
              ".loyalty lo ON lo.cust_id = ca.cust_id AND lo.geo_concept = ca.geo_concept WHERE " +
              this.decryptLocal("globalFilter") +
              suppressionListCondition +
              " GROUP BY 1";

            // fQS =
            //   "select CASE " +
            //   selectedRule +
            //   " ELSE 'Remainder' END segment, count(distinct(di.cust_id)) count FROM " +
            //   JSON.parse(
            //     CryptoJS.AES.decrypt(
            //       localStorage.getItem("custDb"),
            //       process.env.REACT_APP_PASS
            //     ).toString(CryptoJS.enc.Utf8)
            //   ) +
            //   ".display_customers di LEFT JOIN " +
            //   JSON.parse(
            //     CryptoJS.AES.decrypt(
            //       localStorage.getItem("custDb"),
            //       process.env.REACT_APP_PASS
            //     ).toString(CryptoJS.enc.Utf8)
            //   ) +
            //   ".cust_analytic ca ON di.cust_id = ca.cust_id LEFT JOIN " +
            //   JSON.parse(
            //     CryptoJS.AES.decrypt(
            //       localStorage.getItem("custDb"),
            //       process.env.REACT_APP_PASS
            //     ).toString(CryptoJS.enc.Utf8)
            //   ) +
            //   ".client_intellibase ci ON ci.cust_id = di.cust_id LEFT JOIN (SELECT * FROM (SELECT rank() OVER (partition by email_address, geo_concept ORDER BY em_match_level, cust_id) rank, * FROM " +
            //   JSON.parse(
            //     CryptoJS.AES.decrypt(
            //       localStorage.getItem("custDb"),
            //       process.env.REACT_APP_PASS
            //     ).toString(CryptoJS.enc.Utf8)
            //   ) +
            //   ".owned_email ) WHERE rank = 1 ) oe ON oe.cust_id = di.cust_id AND oe.geo_concept = di.geo_concept LEFT JOIN " +
            //   JSON.parse(
            //     CryptoJS.AES.decrypt(
            //       localStorage.getItem("custDb"),
            //       process.env.REACT_APP_PASS
            //     ).toString(CryptoJS.enc.Utf8)
            //   ) +
            //   ".eclub ec ON ec.cust_id = di.cust_id AND ec.eclub_geo_concept = di.geo_concept LEFT JOIN " +
            //   JSON.parse(
            //     CryptoJS.AES.decrypt(
            //       localStorage.getItem("custDb"),
            //       process.env.REACT_APP_PASS
            //     ).toString(CryptoJS.enc.Utf8)
            //   ) +
            //   ".geo geo ON geo.geo_id = di.geo_id AND geo.geo_concept = di.geo_concept LEFT JOIN " +
            //   JSON.parse(
            //     CryptoJS.AES.decrypt(
            //       localStorage.getItem("custDb"),
            //       process.env.REACT_APP_PASS
            //     ).toString(CryptoJS.enc.Utf8)
            //   ) +
            //   ".loyalty lo ON lo.cust_id = di.cust_id AND lo.geo_concept = di.geo_concept WHERE " +
            //   JSON.parse(
            //     CryptoJS.AES.decrypt(
            //       localStorage.getItem("globalFilter"),
            //       process.env.REACT_APP_PASS
            //     ).toString(CryptoJS.enc.Utf8)
            //   ) +
            //   " AND di.distance " +
            //   configuredDistanceValue +
            //   " GROUP BY 1";
          } else {
            if (where.includes("li.")) {
              fQS =
                "select CASE " +
                selectedRule +
                " ELSE 'Remainder' END segment, count(distinct(ca.cust_id)) count FROM " +
                this.decryptLocal("custDb") +
                ".cust_analytic ca LEFT JOIN " +
                this.decryptLocal("custDb") +
                ".client_intellibase ci ON ci.cust_id = ca.cust_id LEFT JOIN (SELECT * FROM (SELECT rank() OVER (partition by email_address, geo_concept ORDER BY em_match_level, cust_id) rank, * FROM " +
                this.decryptLocal("custDb") +
                ".owned_email ) WHERE rank = 1 ) oe ON oe.cust_id = ca.cust_id AND oe.geo_concept = ca.geo_concept LEFT JOIN " +
                // JSON.parse(
                //   CryptoJS.AES.decrypt(
                //     localStorage.getItem("custDb"),
                //     process.env.REACT_APP_PASS
                //   ).toString(CryptoJS.enc.Utf8)
                // ) +
                // ".eclub ec ON ec.cust_id = ca.cust_id AND ec.eclub_geo_concept = ca.geo_concept LEFT JOIN " +
                (selectedClientId !== "3fe7e557-16f5-406c-bbc8-887fdec7ba8b"
                  ? schemaName +
                    ".eclub ec ON ec.cust_id = ca.cust_id AND ec.eclub_geo_concept = ca.geo_concept LEFT JOIN "
                  : ` (SELECT cust_id,eclub_geo_concept, max(email_marketable) AS email_marketable FROM ${schemaName}.eclub WHERE email_marketable IS NOT NULL GROUP BY 1,2) ec ON ec.cust_id = ca.cust_id AND ec.eclub_geo_concept = ca.geo_concept LEFT JOIN `) +
                this.decryptLocal("custDb") +
                ".geo geo ON geo.geo_id = ca.geo_id_fav AND geo.geo_concept = ca.geo_concept LEFT JOIN " +
                this.decryptLocal("custDb") +
                ".loyalty lo ON lo.cust_id = ca.cust_id AND lo.geo_concept = ca.geo_concept WHERE " +
                // JSON.parse(
                //   CryptoJS.AES.decrypt(
                //     localStorage.getItem("custDb"),
                //     process.env.REACT_APP_PASS
                //   ).toString(CryptoJS.enc.Utf8)
                // ).split("_")[0] +
                // "_raw.lists_preclub li ON li.cust_id = ca.cust_id WHERE " +
                // JSON.parse(
                //   CryptoJS.AES.decrypt(
                //     localStorage.getItem("custDb"),
                //     process.env.REACT_APP_PASS
                //   ).toString(CryptoJS.enc.Utf8)
                // ) +
                // ".display di ON di.cust_id = ca.cust_id WHERE " +
                this.decryptLocal("globalFilter") +
                " AND " +
                where +
                suppressionListCondition +
                " GROUP BY 1";

              // fQS =
              //   "select CASE " +
              //   selectedRule +
              //   " ELSE 'Remainder' END segment, count(distinct(di.cust_id)) count FROM " +
              //   JSON.parse(
              //     CryptoJS.AES.decrypt(
              //       localStorage.getItem("custDb"),
              //       process.env.REACT_APP_PASS
              //     ).toString(CryptoJS.enc.Utf8)
              //   ) +
              //   ".display_customers di LEFT JOIN " +
              //   JSON.parse(
              //     CryptoJS.AES.decrypt(
              //       localStorage.getItem("custDb"),
              //       process.env.REACT_APP_PASS
              //     ).toString(CryptoJS.enc.Utf8)
              //   ) +
              //   ".cust_analytic ca ON di.cust_id = ca.cust_id LEFT JOIN " +
              //   JSON.parse(
              //     CryptoJS.AES.decrypt(
              //       localStorage.getItem("custDb"),
              //       process.env.REACT_APP_PASS
              //     ).toString(CryptoJS.enc.Utf8)
              //   ) +
              //   ".client_intellibase ci ON ci.cust_id = di.cust_id LEFT JOIN (SELECT * FROM (SELECT rank() OVER (partition by email_address, geo_concept ORDER BY em_match_level, cust_id) rank, * FROM " +
              //   JSON.parse(
              //     CryptoJS.AES.decrypt(
              //       localStorage.getItem("custDb"),
              //       process.env.REACT_APP_PASS
              //     ).toString(CryptoJS.enc.Utf8)
              //   ) +
              //   ".owned_email ) WHERE rank = 1 ) oe ON oe.cust_id = di.cust_id AND oe.geo_concept = di.geo_concept LEFT JOIN " +
              //   JSON.parse(
              //     CryptoJS.AES.decrypt(
              //       localStorage.getItem("custDb"),
              //       process.env.REACT_APP_PASS
              //     ).toString(CryptoJS.enc.Utf8)
              //   ) +
              //   ".eclub ec ON ec.cust_id = di.cust_id AND ec.eclub_geo_concept = di.geo_concept LEFT JOIN " +
              //   JSON.parse(
              //     CryptoJS.AES.decrypt(
              //       localStorage.getItem("custDb"),
              //       process.env.REACT_APP_PASS
              //     ).toString(CryptoJS.enc.Utf8)
              //   ) +
              //   ".geo geo ON geo.geo_id = di.geo_id AND geo.geo_concept = di.geo_concept LEFT JOIN " +
              //   JSON.parse(
              //     CryptoJS.AES.decrypt(
              //       localStorage.getItem("custDb"),
              //       process.env.REACT_APP_PASS
              //     ).toString(CryptoJS.enc.Utf8)
              //   ) +
              //   ".loyalty lo ON lo.cust_id = di.cust_id AND lo.geo_concept = di.geo_concept WHERE " +
              //   // JSON.parse(
              //   //   CryptoJS.AES.decrypt(
              //   //     localStorage.getItem("custDb"),
              //   //     process.env.REACT_APP_PASS
              //   //   ).toString(CryptoJS.enc.Utf8)
              //   // ).split("_")[0] +
              //   // "_raw.lists_preclub li ON li.cust_id = ca.cust_id WHERE " +
              //   // JSON.parse(
              //   //   CryptoJS.AES.decrypt(
              //   //     localStorage.getItem("custDb"),
              //   //     process.env.REACT_APP_PASS
              //   //   ).toString(CryptoJS.enc.Utf8)
              //   // ) +
              //   // ".display di ON di.cust_id = ca.cust_id WHERE " +
              //   JSON.parse(
              //     CryptoJS.AES.decrypt(
              //       localStorage.getItem("globalFilter"),
              //       process.env.REACT_APP_PASS
              //     ).toString(CryptoJS.enc.Utf8)
              //   ) +
              //   " AND " +
              //   where +
              //   " AND di.distance " +
              //   configuredDistanceValue +
              //   " GROUP BY 1";
            } else {
              fQS =
                "select CASE " +
                selectedRule +
                " ELSE 'Remainder' END segment, count(distinct(ca.cust_id)) count FROM " +
                this.decryptLocal("custDb") +
                ".cust_analytic ca LEFT JOIN " +
                this.decryptLocal("custDb") +
                ".client_intellibase ci ON ci.cust_id = ca.cust_id LEFT JOIN (SELECT * FROM (SELECT rank() OVER (partition by email_address, geo_concept ORDER BY em_match_level, cust_id) rank, * FROM " +
                this.decryptLocal("custDb") +
                ".owned_email ) WHERE rank = 1 ) oe ON oe.cust_id = ca.cust_id AND oe.geo_concept = ca.geo_concept LEFT JOIN " +
                // JSON.parse(
                //   CryptoJS.AES.decrypt(
                //     localStorage.getItem("custDb"),
                //     process.env.REACT_APP_PASS
                //   ).toString(CryptoJS.enc.Utf8)
                // ) +
                // ".eclub ec ON ec.cust_id = ca.cust_id AND ec.eclub_geo_concept = ca.geo_concept LEFT JOIN " +
                (selectedClientId !== "3fe7e557-16f5-406c-bbc8-887fdec7ba8b"
                  ? schemaName +
                    ".eclub ec ON ec.cust_id = ca.cust_id AND ec.eclub_geo_concept = ca.geo_concept LEFT JOIN "
                  : ` (SELECT cust_id,eclub_geo_concept, max(email_marketable) AS email_marketable FROM ${schemaName}.eclub WHERE email_marketable IS NOT NULL GROUP BY 1,2) ec ON ec.cust_id = ca.cust_id AND ec.eclub_geo_concept = ca.geo_concept LEFT JOIN `) +
                this.decryptLocal("custDb") +
                ".geo geo ON geo.geo_id = ca.geo_id_fav AND geo.geo_concept = ca.geo_concept LEFT JOIN " +
                this.decryptLocal("custDb") +
                ".loyalty lo ON lo.cust_id = ca.cust_id AND lo.geo_concept = ca.geo_concept WHERE " +
                // ".loyalty lo ON lo.cust_id = ca.cust_id AND lo.geo_concept = ca.geo_concept LEFT JOIN " +
                // JSON.parse(
                //   CryptoJS.AES.decrypt(
                //     localStorage.getItem("custDb"),
                //     process.env.REACT_APP_PASS
                //   ).toString(CryptoJS.enc.Utf8)
                // ) +
                // ".display di ON di.cust_id = ca.cust_id WHERE " +
                this.decryptLocal("globalFilter") +
                " AND " +
                where +
                suppressionListCondition +
                " GROUP BY 1";

              // fQS =
              //   "select CASE " +
              //   selectedRule +
              //   " ELSE 'Remainder' END segment, count(distinct(di.cust_id)) count FROM " +
              //   JSON.parse(
              //     CryptoJS.AES.decrypt(
              //       localStorage.getItem("custDb"),
              //       process.env.REACT_APP_PASS
              //     ).toString(CryptoJS.enc.Utf8)
              //   ) +
              //   ".display_customers di LEFT JOIN " +
              //   JSON.parse(
              //     CryptoJS.AES.decrypt(
              //       localStorage.getItem("custDb"),
              //       process.env.REACT_APP_PASS
              //     ).toString(CryptoJS.enc.Utf8)
              //   ) +
              //   ".cust_analytic ca ON di.cust_id = ca.cust_id LEFT JOIN " +
              //   JSON.parse(
              //     CryptoJS.AES.decrypt(
              //       localStorage.getItem("custDb"),
              //       process.env.REACT_APP_PASS
              //     ).toString(CryptoJS.enc.Utf8)
              //   ) +
              //   ".client_intellibase ci ON ci.cust_id = di.cust_id LEFT JOIN (SELECT * FROM (SELECT rank() OVER (partition by email_address, geo_concept ORDER BY em_match_level, cust_id) rank, * FROM " +
              //   JSON.parse(
              //     CryptoJS.AES.decrypt(
              //       localStorage.getItem("custDb"),
              //       process.env.REACT_APP_PASS
              //     ).toString(CryptoJS.enc.Utf8)
              //   ) +
              //   ".owned_email ) WHERE rank = 1 ) oe ON oe.cust_id = di.cust_id AND oe.geo_concept = di.geo_concept LEFT JOIN " +
              //   JSON.parse(
              //     CryptoJS.AES.decrypt(
              //       localStorage.getItem("custDb"),
              //       process.env.REACT_APP_PASS
              //     ).toString(CryptoJS.enc.Utf8)
              //   ) +
              //   ".eclub ec ON ec.cust_id = di.cust_id AND ec.eclub_geo_concept = di.geo_concept LEFT JOIN " +
              //   JSON.parse(
              //     CryptoJS.AES.decrypt(
              //       localStorage.getItem("custDb"),
              //       process.env.REACT_APP_PASS
              //     ).toString(CryptoJS.enc.Utf8)
              //   ) +
              //   ".geo geo ON geo.geo_id = di.geo_id AND geo.geo_concept = di.geo_concept LEFT JOIN " +
              //   JSON.parse(
              //     CryptoJS.AES.decrypt(
              //       localStorage.getItem("custDb"),
              //       process.env.REACT_APP_PASS
              //     ).toString(CryptoJS.enc.Utf8)
              //   ) +
              //   ".loyalty lo ON lo.cust_id = di.cust_id AND lo.geo_concept = di.geo_concept WHERE " +
              //   // ".loyalty lo ON lo.cust_id = ca.cust_id AND lo.geo_concept = ca.geo_concept LEFT JOIN " +
              //   // JSON.parse(
              //   //   CryptoJS.AES.decrypt(
              //   //     localStorage.getItem("custDb"),
              //   //     process.env.REACT_APP_PASS
              //   //   ).toString(CryptoJS.enc.Utf8)
              //   // ) +
              //   // ".display di ON di.cust_id = ca.cust_id WHERE " +
              //   JSON.parse(
              //     CryptoJS.AES.decrypt(
              //       localStorage.getItem("globalFilter"),
              //       process.env.REACT_APP_PASS
              //     ).toString(CryptoJS.enc.Utf8)
              //   ) +
              //   " AND " +
              //   where +
              //   " AND di.distance " +
              //   configuredDistanceValue +
              //   " GROUP BY 1";
            }
          }
        } else {
          if (selectedChannel === "0905c46e-6f48-4ed8-b2a9-35dbbf3bae91") {
            // Preclub query
            if (
              selectedClientId === "8c001fde-3728-48dc-9950-b8480ca9fbee" || 
              selectedClientId === "7203dd51-f88b-4a4b-877c-92326d027915" ||
              selectedClientId === "f1fbce23-e2ef-463c-bc97-6cde3c4cc4ac" ||
              selectedClientId === "874b6c6a-83ff-480b-b615-1972538813ba" ||
              selectedClientId === "b76e7818-deb1-4526-93a7-b398df3ea357" ||
              selectedClientId === "e08840c5-c7d0-48c7-9c24-124b4cd80735" || 
              selectedClientId === "68a4d4cc-1e57-4ccf-9dd1-a5ae890d0f2e" ||
              selectedClientId === "0bc2a383-9ae0-4e9e-9652-0fb762ba6119" ||
              selectedClientId === "7bf99619-30a3-47a3-b1de-d72b4f7f99a7" ||
              selectedClientId === "a4dda78e-7678-4aaf-9bef-60a229085fc8" ||
              selectedClientId === "83da098f-2fc7-4b98-8455-c08f9aceb4ed" ||
              selectedClientId === "cf6144d2-bb68-43b6-9876-dbf620b57c21" ||
              selectedClientId === "37f97bea-f005-4be1-8e41-286ad79a7f3a" ||
              selectedClientId === "ec5a162e-5e87-4819-93bd-70bbf3b5f096" ||
              selectedClientId === "24ab940a-50d2-41fd-b3b2-c67ca6cb0304" ||
              selectedClientId === "535a90f3-b463-4d5a-9a83-39c522589a6c"
            ) {
              if (where == "") {
                fQS =
                  "select CASE " +
                  selectedRule +
                  " ELSE 'Remainder' END segment, count(distinct(ca.cust_id)) count FROM " +
                  this.decryptLocal("custDb") +
                  ".cust_analytic ca LEFT JOIN " +
                  this.decryptLocal("custDb") +
                  ".client_intellibase ci ON ci.cust_id = ca.cust_id LEFT JOIN (SELECT * FROM (SELECT rank() OVER (partition by email_address, geo_concept ORDER BY em_match_level, cust_id) rank, * FROM " +
                  this.decryptLocal("custDb") +
                  ".owned_email ) WHERE rank = 1 ) oe ON oe.cust_id = ca.cust_id AND oe.geo_concept = ca.geo_concept LEFT JOIN " +
                  this.decryptLocal("custDb") +
                  ".eclub ec ON ec.cust_id = ca.cust_id AND ec.eclub_geo_concept = ca.geo_concept LEFT JOIN " +
                  this.decryptLocal("custDb") +
                  ".geo geo ON geo.geo_id = ca.geo_id_fav AND geo.geo_concept = ca.geo_concept LEFT JOIN " +
                  this.decryptLocal("custDb") +
                  ".loyalty lo ON lo.cust_id = ca.cust_id AND lo.geo_concept = ca.geo_concept LEFT JOIN " +
                  ` cog_messages_curated.email_master_status ms ON oe.email_address = ms.email_address where (ca.global_control_flag = true or (final_reason['status'] = '1' and ca.global_control_flag = false and (if(contains(client_unsubscribes, '${
                    cmpClientIdObject[
                      this.decryptLocal("clientId")
                    ]
                  }'),False ,True) or client_unsubscribes is null) and (if(contains(client_complaints, '${
                    cmpClientIdObject[
                      this.decryptLocal("clientId")
                    ]
                  }'),false ,true) or client_complaints is null))) AND ` +
                  this.decryptLocal("globalFilter") +
                  suppressionListCondition +
                  " GROUP BY 1";
              } else {
                // Todo: Code test for the below code block to check whether they are required or not
                if (where.includes("li.")) {
                  fQS =
                    "select CASE " +
                    selectedRule +
                    " ELSE 'Remainder' END segment, count(distinct(ca.cust_id)) count FROM " +
                    this.decryptLocal("custDb") +
                    ".cust_analytic ca LEFT JOIN " +
                    this.decryptLocal("custDb") +
                    ".client_intellibase ci ON ci.cust_id = ca.cust_id LEFT JOIN (SELECT * FROM (SELECT rank() OVER (partition by email_address, geo_concept ORDER BY em_match_level, cust_id) rank, * FROM " +
                    this.decryptLocal("custDb") +
                    ".owned_email ) WHERE rank = 1 ) oe ON oe.cust_id = ca.cust_id AND oe.geo_concept = ca.geo_concept LEFT JOIN " +
                    this.decryptLocal("custDb") +
                    ".eclub ec ON ec.cust_id = ca.cust_id AND ec.eclub_geo_concept = ca.geo_concept LEFT JOIN " +
                    this.decryptLocal("custDb") +
                    ".geo geo ON geo.geo_id = ca.geo_id_fav AND geo.geo_concept = ca.geo_concept LEFT JOIN " +
                    this.decryptLocal("custDb") +
                    ".loyalty lo ON lo.cust_id = ca.cust_id AND lo.geo_concept = ca.geo_concept LEFT JOIN " +
                    ` cog_messages_curated.email_master_status ms ON oe.email_address = ms.email_address where (ca.global_control_flag = true or (final_reason['status'] = '1' and ca.global_control_flag = false and (if(contains(client_unsubscribes, '${
                      cmpClientIdObject[
                        this.decryptLocal("clientId")
                      ]
                    }'),False ,True) or client_unsubscribes is null) and (if(contains(client_complaints, '${
                      cmpClientIdObject[
                        this.decryptLocal("clientId")
                      ]
                    }'),false ,true) or client_complaints is null))) AND ` +
                    this.decryptLocal("globalFilter") +
                    " AND " +
                    where +
                    suppressionListCondition +
                    " GROUP BY 1";
                } else {
                  fQS =
                    "select CASE " +
                    selectedRule +
                    " ELSE 'Remainder' END segment, count(distinct(ca.cust_id)) count FROM " +
                    this.decryptLocal("custDb") +
                    ".cust_analytic ca LEFT JOIN " +
                    this.decryptLocal("custDb") +
                    ".client_intellibase ci ON ci.cust_id = ca.cust_id LEFT JOIN (SELECT * FROM (SELECT rank() OVER (partition by email_address, geo_concept ORDER BY em_match_level, cust_id) rank, * FROM " +
                    this.decryptLocal("custDb") +
                    ".owned_email ) WHERE rank = 1 ) oe ON oe.cust_id = ca.cust_id AND oe.geo_concept = ca.geo_concept LEFT JOIN " +
                    this.decryptLocal("custDb") +
                    ".eclub ec ON ec.cust_id = ca.cust_id AND ec.eclub_geo_concept = ca.geo_concept LEFT JOIN " +
                    this.decryptLocal("custDb") +
                    ".geo geo ON geo.geo_id = ca.geo_id_fav AND geo.geo_concept = ca.geo_concept LEFT JOIN " +
                    this.decryptLocal("custDb") +
                    ".loyalty lo ON lo.cust_id = ca.cust_id AND lo.geo_concept = ca.geo_concept LEFT JOIN " +
                    ` cog_messages_curated.email_master_status ms ON oe.email_address = ms.email_address where (ca.global_control_flag = true or (final_reason['status'] = '1' and ca.global_control_flag = false and (if(contains(client_unsubscribes, '${
                      cmpClientIdObject[
                        this.decryptLocal("clientId")
                      ]
                    }'),False ,True) or client_unsubscribes is null) and (if(contains(client_complaints, '${
                      cmpClientIdObject[
                        this.decryptLocal("clientId")
                      ]
                    }'),false ,true) or client_complaints is null))) AND ` +
                    this.decryptLocal("globalFilter") +
                    " AND " +
                    where +
                    suppressionListCondition +
                    " GROUP BY 1";
                }
              }
            } else {
              if (where == "") {
                fQS =
                  "select CASE " +
                  selectedRule +
                  " ELSE 'Remainder' END segment, count(distinct(ca.cust_id)) count FROM " +
                  this.decryptLocal("custDb") +
                  ".cust_analytic ca LEFT JOIN " +
                  this.decryptLocal("custDb") +
                  ".client_intellibase ci ON ci.cust_id = ca.cust_id LEFT JOIN (SELECT * FROM (SELECT rank() OVER (partition by email_address, geo_concept ORDER BY em_match_level, cust_id) rank, * FROM " +
                  this.decryptLocal("custDb") +
                  ".owned_email ) WHERE rank = 1 ) oe ON oe.cust_id = ca.cust_id AND oe.geo_concept = ca.geo_concept LEFT JOIN " +
                  this.decryptLocal("custDb") +
                  ".eclub ec ON ec.cust_id = ca.cust_id AND ec.eclub_geo_concept = ca.geo_concept LEFT JOIN " +
                  this.decryptLocal("custDb") +
                  ".geo geo ON geo.geo_id = ca.geo_id_fav AND geo.geo_concept = ca.geo_concept LEFT JOIN " +
                  // JSON.parse(
                  //   CryptoJS.AES.decrypt(
                  //     localStorage.getItem("custDb"),
                  //     process.env.REACT_APP_PASS
                  //   ).toString(CryptoJS.enc.Utf8)
                  // ) +
                  // ".loyalty lo ON lo.cust_id = ca.cust_id AND lo.geo_concept = ca.geo_concept WHERE " +
                  ` (SELECT cust_id,geo_concept, max(email_marketable) AS email_marketable FROM ${schemaName}.loyalty WHERE email_marketable IS NOT NULL GROUP BY 1,2) lo ON lo.cust_id = ca.cust_id AND lo.geo_concept = ca.geo_concept WHERE ` +
                  this.decryptLocal("globalFilter") +
                  suppressionListCondition +
                  " GROUP BY 1";
              } else {
                // Todo: Code test for the below code block to check whether they are required or not
                if (where.includes("li.")) {
                  fQS =
                    "select CASE " +
                    selectedRule +
                    " ELSE 'Remainder' END segment, count(distinct(ca.cust_id)) count FROM " +
                    this.decryptLocal("custDb") +
                    ".cust_analytic ca LEFT JOIN " +
                    this.decryptLocal("custDb") +
                    ".client_intellibase ci ON ci.cust_id = ca.cust_id LEFT JOIN (SELECT * FROM (SELECT rank() OVER (partition by email_address, geo_concept ORDER BY em_match_level, cust_id) rank, * FROM " +
                    this.decryptLocal("custDb") +
                    ".owned_email ) WHERE rank = 1 ) oe ON oe.cust_id = ca.cust_id AND oe.geo_concept = ca.geo_concept LEFT JOIN " +
                    this.decryptLocal("custDb") +
                    ".eclub ec ON ec.cust_id = ca.cust_id AND ec.eclub_geo_concept = ca.geo_concept LEFT JOIN " +
                    this.decryptLocal("custDb") +
                    ".geo geo ON geo.geo_id = ca.geo_id_fav AND geo.geo_concept = ca.geo_concept LEFT JOIN " +
                    // JSON.parse(
                    //   CryptoJS.AES.decrypt(
                    //     localStorage.getItem("custDb"),
                    //     process.env.REACT_APP_PASS
                    //   ).toString(CryptoJS.enc.Utf8)
                    // ) +
                    // ".loyalty lo ON lo.cust_id = ca.cust_id AND lo.geo_concept = ca.geo_concept WHERE " +
                    ` (SELECT cust_id,geo_concept, max(email_marketable) AS email_marketable FROM ${schemaName}.loyalty WHERE email_marketable IS NOT NULL GROUP BY 1,2) lo ON lo.cust_id = ca.cust_id AND lo.geo_concept = ca.geo_concept WHERE ` +
                    this.decryptLocal("globalFilter") +
                    " AND " +
                    where +
                    suppressionListCondition +
                    " GROUP BY 1";
                } else {
                  fQS =
                    "select CASE " +
                    selectedRule +
                    " ELSE 'Remainder' END segment, count(distinct(ca.cust_id)) count FROM " +
                    this.decryptLocal("custDb") +
                    ".cust_analytic ca LEFT JOIN " +
                    this.decryptLocal("custDb") +
                    ".client_intellibase ci ON ci.cust_id = ca.cust_id LEFT JOIN (SELECT * FROM (SELECT rank() OVER (partition by email_address, geo_concept ORDER BY em_match_level, cust_id) rank, * FROM " +
                    this.decryptLocal("custDb") +
                    ".owned_email ) WHERE rank = 1 ) oe ON oe.cust_id = ca.cust_id AND oe.geo_concept = ca.geo_concept LEFT JOIN " +
                    this.decryptLocal("custDb") +
                    ".eclub ec ON ec.cust_id = ca.cust_id AND ec.eclub_geo_concept = ca.geo_concept LEFT JOIN " +
                    this.decryptLocal("custDb") +
                    ".geo geo ON geo.geo_id = ca.geo_id_fav AND geo.geo_concept = ca.geo_concept LEFT JOIN " +
                    // JSON.parse(
                    //   CryptoJS.AES.decrypt(
                    //     localStorage.getItem("custDb"),
                    //     process.env.REACT_APP_PASS
                    //   ).toString(CryptoJS.enc.Utf8)
                    // ) +
                    // ".loyalty lo ON lo.cust_id = ca.cust_id AND lo.geo_concept = ca.geo_concept WHERE " +
                    ` (SELECT cust_id,geo_concept, max(email_marketable) AS email_marketable FROM ${schemaName}.loyalty WHERE email_marketable IS NOT NULL GROUP BY 1,2) lo ON lo.cust_id = ca.cust_id AND lo.geo_concept = ca.geo_concept WHERE ` +
                    this.decryptLocal("globalFilter") +
                    " AND " +
                    where +
                    suppressionListCondition +
                    " GROUP BY 1";
                }
              }
            }
          } else {
            // Kahala Eclub Channel
            if (where == "") {
              fQS =
                "select CASE " +
                selectedRule +
                " ELSE 'Remainder' END segment, count(distinct(ca.cust_id)) count FROM " +
                this.decryptLocal("custDb") +
                ".cust_analytic ca LEFT JOIN " +
                this.decryptLocal("custDb") +
                ".client_intellibase ci ON ci.cust_id = ca.cust_id LEFT JOIN (SELECT * FROM (SELECT rank() OVER (partition by email_address, geo_concept ORDER BY em_match_level, cust_id) rank, * FROM " +
                this.decryptLocal("custDb") +
                ".owned_email ) WHERE rank = 1 ) oe ON oe.cust_id = ca.cust_id AND oe.geo_concept = ca.geo_concept LEFT JOIN " +
                this.decryptLocal("custDb") +
                ".eclub ec ON ec.cust_id = ca.cust_id AND ec.eclub_geo_concept = ca.geo_concept LEFT JOIN " +
                this.decryptLocal("custDb") +
                ".geo geo ON geo.geo_id = ca.geo_id_fav AND geo.geo_concept = ca.geo_concept LEFT JOIN " +
                // JSON.parse(
                //   CryptoJS.AES.decrypt(
                //     localStorage.getItem("custDb"),
                //     process.env.REACT_APP_PASS
                //   ).toString(CryptoJS.enc.Utf8)
                // ) +
                // ".loyalty lo ON lo.cust_id = ca.cust_id AND lo.geo_concept = ca.geo_concept WHERE " +
                (selectedClientId !== "3fe7e557-16f5-406c-bbc8-887fdec7ba8b"
                  ? schemaName +
                    ".loyalty lo ON lo.cust_id = ca.cust_id AND lo.geo_concept = ca.geo_concept WHERE "
                  : ` (SELECT cust_id,geo_concept, max(email_marketable) AS email_marketable FROM ${schemaName}.loyalty WHERE email_marketable IS NOT NULL GROUP BY 1,2) lo ON lo.cust_id = ca.cust_id AND lo.geo_concept = ca.geo_concept WHERE `) +
                this.decryptLocal("globalFilter") +
                suppressionListCondition +
                " GROUP BY 1";
            } else {
              if (where.includes("li.")) {
                fQS =
                  "select CASE " +
                  selectedRule +
                  " ELSE 'Remainder' END segment, count(distinct(ca.cust_id)) count FROM " +
                  this.decryptLocal("custDb") +
                  ".cust_analytic ca LEFT JOIN " +
                  this.decryptLocal("custDb") +
                  ".client_intellibase ci ON ci.cust_id = ca.cust_id LEFT JOIN (SELECT * FROM (SELECT rank() OVER (partition by email_address, geo_concept ORDER BY em_match_level, cust_id) rank, * FROM " +
                  this.decryptLocal("custDb") +
                  ".owned_email ) WHERE rank = 1 ) oe ON oe.cust_id = ca.cust_id AND oe.geo_concept = ca.geo_concept LEFT JOIN " +
                  this.decryptLocal("custDb") +
                  ".eclub ec ON ec.cust_id = ca.cust_id AND ec.eclub_geo_concept = ca.geo_concept LEFT JOIN " +
                  this.decryptLocal("custDb") +
                  ".geo geo ON geo.geo_id = ca.geo_id_fav AND geo.geo_concept = ca.geo_concept LEFT JOIN " +
                  // JSON.parse(
                  //   CryptoJS.AES.decrypt(
                  //     localStorage.getItem("custDb"),
                  //     process.env.REACT_APP_PASS
                  //   ).toString(CryptoJS.enc.Utf8)
                  // ) +
                  // ".loyalty lo ON lo.cust_id = ca.cust_id AND lo.geo_concept = ca.geo_concept WHERE " +
                  (selectedClientId !== "3fe7e557-16f5-406c-bbc8-887fdec7ba8b"
                    ? schemaName +
                      ".loyalty lo ON lo.cust_id = ca.cust_id AND lo.geo_concept = ca.geo_concept WHERE "
                    : ` (SELECT cust_id,geo_concept, max(email_marketable) AS email_marketable FROM ${schemaName}.loyalty WHERE email_marketable IS NOT NULL GROUP BY 1,2) lo ON lo.cust_id = ca.cust_id AND lo.geo_concept = ca.geo_concept WHERE `) +
                  // JSON.parse(
                  //   CryptoJS.AES.decrypt(
                  //     localStorage.getItem("custDb"),
                  //     process.env.REACT_APP_PASS
                  //   ).toString(CryptoJS.enc.Utf8)
                  // ).split("_")[0] +
                  // "_raw.lists_preclub li ON li.cust_id = ca.cust_id WHERE " +
                  // JSON.parse(
                  //   CryptoJS.AES.decrypt(
                  //     localStorage.getItem("custDb"),
                  //     process.env.REACT_APP_PASS
                  //   ).toString(CryptoJS.enc.Utf8)
                  // ) +
                  // ".display di ON di.cust_id = ca.cust_id WHERE " +
                  this.decryptLocal("globalFilter") +
                  " AND " +
                  where +
                  suppressionListCondition +
                  " GROUP BY 1";
              } else {
                fQS =
                  "select CASE " +
                  selectedRule +
                  " ELSE 'Remainder' END segment, count(distinct(ca.cust_id)) count FROM " +
                  this.decryptLocal("custDb") +
                  ".cust_analytic ca LEFT JOIN " +
                  this.decryptLocal("custDb") +
                  ".client_intellibase ci ON ci.cust_id = ca.cust_id LEFT JOIN (SELECT * FROM (SELECT rank() OVER (partition by email_address, geo_concept ORDER BY em_match_level, cust_id) rank, * FROM " +
                  this.decryptLocal("custDb") +
                  ".owned_email ) WHERE rank = 1 ) oe ON oe.cust_id = ca.cust_id AND oe.geo_concept = ca.geo_concept LEFT JOIN " +
                  this.decryptLocal("custDb") +
                  ".eclub ec ON ec.cust_id = ca.cust_id AND ec.eclub_geo_concept = ca.geo_concept LEFT JOIN " +
                  this.decryptLocal("custDb") +
                  ".geo geo ON geo.geo_id = ca.geo_id_fav AND geo.geo_concept = ca.geo_concept LEFT JOIN " +
                  // JSON.parse(
                  //   CryptoJS.AES.decrypt(
                  //     localStorage.getItem("custDb"),
                  //     process.env.REACT_APP_PASS
                  //   ).toString(CryptoJS.enc.Utf8)
                  // ) +
                  // ".loyalty lo ON lo.cust_id = ca.cust_id AND lo.geo_concept = ca.geo_concept WHERE " +
                  (selectedClientId !== "3fe7e557-16f5-406c-bbc8-887fdec7ba8b"
                    ? schemaName +
                      ".loyalty lo ON lo.cust_id = ca.cust_id AND lo.geo_concept = ca.geo_concept WHERE "
                    : ` (SELECT cust_id,geo_concept, max(email_marketable) AS email_marketable FROM ${schemaName}.loyalty WHERE email_marketable IS NOT NULL GROUP BY 1,2) lo ON lo.cust_id = ca.cust_id AND lo.geo_concept = ca.geo_concept WHERE `) +
                  // ".loyalty lo ON lo.cust_id = ca.cust_id AND lo.geo_concept = ca.geo_concept LEFT JOIN " +
                  // JSON.parse(
                  //   CryptoJS.AES.decrypt(
                  //     localStorage.getItem("custDb"),
                  //     process.env.REACT_APP_PASS
                  //   ).toString(CryptoJS.enc.Utf8)
                  // ) +
                  // ".display di ON di.cust_id = ca.cust_id WHERE " +
                  this.decryptLocal("globalFilter") +
                  " AND " +
                  where +
                  suppressionListCondition +
                  " GROUP BY 1";
              }
              //fQS = "select case " + selectedRule + "else 'remainder' end segment, count_if(ca.eclub) eclub_count, count_if(ca.preclub) preclub_count, count_if(if(ca.eclub or ca.preclub,true,false)) email_count, count(distinct(ci.cust_id)) dm_count from " + JSON.parse(CryptoJS.AES.decrypt(localStorage.getItem('custDb'), 'secretpass').toString(CryptoJS.enc.Utf8)) + " .cust_analytic ca left join " + JSON.parse(CryptoJS.AES.decrypt(localStorage.getItem('custDb'), 'secretpass').toString(CryptoJS.enc.Utf8)) + " .client_intellibase ci on ca.cust_id = ci.cust_id where " + JSON.parse(CryptoJS.AES.decrypt(localStorage.getItem('globalFilter'), 'secretpass').toString(CryptoJS.enc.Utf8)) + " group by 1";
              /*fQS =
                "SELECT segment, count(*) as count from (SELECT CASE " +
                selectedRule +
                "ELSE 'Remainder' END AS segment FROM " + process.env.REACT_APP_ATHENA_TABLE + " WHERE " +
                where +
                ") GROUP BY segment";*/
            }
          }
        }
      } else if (selectedClientId === "9501c9a1-6d0c-4285-a44f-64b1db4b3f91") {
        // "Charley's Cient"
        if (
          selectedChannel === "d1606aea-0c0d-4fba-83e8-a124f414a953" ||
          selectedChannel === "a8f39ffb-24c5-432a-9bcd-e5d0166a320e"
        ) {
          // Display Channel
          if (where == "") {
            fQS =
              "select CASE " +
              selectedRule +
              " ELSE 'Remainder' END segment, count(distinct(di.cust_id)) count FROM " +
              schemaName +
              ".display_customers di LEFT JOIN " +
              schemaName +
              ".cust_analytic ca ON di.cust_id = ca.cust_id LEFT JOIN " +
              schemaName +
              ".client_intellibase ci ON ci.cust_id = di.cust_id LEFT JOIN (SELECT * FROM (SELECT rank() OVER (partition by email_address, geo_concept ORDER BY em_match_level, cust_id) rank, * FROM " +
              schemaName +
              ".owned_email ) WHERE rank = 1 ) oe ON oe.cust_id = di.cust_id AND oe.geo_concept = di.geo_concept LEFT JOIN " +
              schemaName +
              ".loyalty lo ON lo.cust_id = di.cust_id AND lo.geo_concept = di.geo_concept LEFT JOIN " +
              schemaName +
              ".geo geo ON geo.geo_id = di.geo_id AND geo.geo_concept = di.geo_concept WHERE " +
              globalFilter +
              " AND di.audience_type = 'Customer'" +
              ((selectedChannel === 'a8f39ffb-24c5-432a-9bcd-e5d0166a320e')? " AND ((control_flag = true) or (NULLIF(di.address, '') IS NOT NULL AND NULLIF(di.city, '') IS NOT NULL AND NULLIF(di.state, '') IS NOT NULL AND NULLIF(di.zip, '') IS NOT NULL)) ": "")+
              // suppressionListCondition +
              " GROUP BY 1";
          } else {
            if (where.includes("li.")) {
              fQS =
                "select CASE " +
                selectedRule +
                " ELSE 'Remainder' END segment, count(distinct(di.cust_id)) count FROM " +
                schemaName +
                ".display_customers di LEFT JOIN " +
                schemaName +
                ".cust_analytic ca ON di.cust_id = ca.cust_id LEFT JOIN " +
                schemaName +
                ".client_intellibase ci ON ci.cust_id = di.cust_id LEFT JOIN (SELECT * FROM (SELECT rank() OVER (partition by email_address, geo_concept ORDER BY em_match_level, cust_id) rank, * FROM " +
                schemaName +
                ".owned_email ) WHERE rank = 1 ) oe ON oe.cust_id = di.cust_id AND oe.geo_concept = di.geo_concept LEFT JOIN " +
                schemaName +
                ".loyalty lo ON lo.cust_id = di.cust_id AND lo.geo_concept = di.geo_concept LEFT JOIN " +
                schemaName +
                ".geo geo ON geo.geo_id = di.geo_id AND geo.geo_concept = di.geo_concept WHERE " +
                globalFilter +
                " AND " +
                where +
                " AND di.audience_type = 'Customer'" +
                // suppressionListCondition +
                " GROUP BY 1";
            } else {
              fQS =
                "select CASE " +
                selectedRule +
                " ELSE 'Remainder' END segment, count(distinct(di.cust_id)) count FROM " +
                this.decryptLocal("custDb") +
                ".display_customers di LEFT JOIN " +
                schemaName +
                ".cust_analytic ca ON di.cust_id = ca.cust_id LEFT JOIN " +
                schemaName +
                ".client_intellibase ci ON ci.cust_id = di.cust_id LEFT JOIN (SELECT * FROM (SELECT rank() OVER (partition by email_address, geo_concept ORDER BY em_match_level, cust_id) rank, * FROM " +
                schemaName +
                ".owned_email ) WHERE rank = 1 ) oe ON oe.cust_id = di.cust_id AND oe.geo_concept = di.geo_concept LEFT JOIN " +
                schemaName +
                ".loyalty lo ON lo.cust_id = di.cust_id AND lo.geo_concept = di.geo_concept LEFT JOIN " +
                schemaName +
                ".geo geo ON geo.geo_id = di.geo_id AND geo.geo_concept = di.geo_concept WHERE " +
                globalFilter +
                " AND " +
                where +
                " AND di.audience_type = 'Customer'" +
                // suppressionListCondition +
                " GROUP BY 1";
            }
          }
        } else if (selectedChannel === "0905c46e-6f48-4ed8-b2a9-35dbbf3bae91") {
          // Preclub
          if (where == "") {
            fQS =
              "select CASE " +
              selectedRule +
              " ELSE 'Remainder' END segment, count(distinct(ca.cust_id)) count FROM " +
              schemaName +
              ".cust_analytic ca LEFT JOIN " +
              schemaName +
              ".client_intellibase ci ON ci.cust_id = ca.cust_id LEFT JOIN (SELECT * FROM (SELECT rank() OVER (partition by email_address, geo_concept ORDER BY em_match_level, cust_id) rank, * FROM " +
              schemaName +
              ".owned_email ) WHERE rank = 1 ) oe ON oe.cust_id = ca.cust_id AND oe.geo_concept = ca.geo_concept LEFT JOIN " +
              schemaName +
              ".eclub ec ON ec.cust_id = ca.cust_id AND ec.eclub_geo_concept = ca.geo_concept LEFT JOIN " +
              schemaName +
              ".geo geo ON geo.geo_id = ca.geo_id_fav AND geo.geo_concept = ca.geo_concept LEFT JOIN " +
              schemaName +
              ".loyalty lo ON lo.cust_id = ca.cust_id AND lo.geo_concept = ca.geo_concept WHERE " +
              globalFilter +
              suppressionListCondition +
              " GROUP BY 1";
          } else {
            if (where.includes("li.")) {
              fQS =
                "select CASE " +
                selectedRule +
                " ELSE 'Remainder' END segment, count(distinct(ca.cust_id)) count FROM " +
                schemaName +
                ".cust_analytic ca LEFT JOIN " +
                schemaName +
                ".client_intellibase ci ON ci.cust_id = ca.cust_id LEFT JOIN (SELECT * FROM (SELECT rank() OVER (partition by email_address, geo_concept ORDER BY em_match_level, cust_id) rank, * FROM " +
                schemaName +
                ".owned_email ) WHERE rank = 1 ) oe ON oe.cust_id = ca.cust_id AND oe.geo_concept = ca.geo_concept LEFT JOIN " +
                schemaName +
                ".eclub ec ON ec.cust_id = ca.cust_id AND ec.eclub_geo_concept = ca.geo_concept LEFT JOIN " +
                schemaName +
                ".geo geo ON geo.geo_id = ca.geo_id_fav AND geo.geo_concept = ca.geo_concept LEFT JOIN " +
                schemaName +
                ".loyalty lo ON lo.cust_id = ca.cust_id AND lo.geo_concept = ca.geo_concept WHERE " +
                // JSON.parse(
                //   CryptoJS.AES.decrypt(
                //     localStorage.getItem("custDb"),
                //     process.env.REACT_APP_PASS
                //   ).toString(CryptoJS.enc.Utf8)
                // ).split("_")[0] +
                // "_raw.lists_preclub li ON li.cust_id = ca.cust_id WHERE " +
                // JSON.parse(
                //   CryptoJS.AES.decrypt(
                //     localStorage.getItem("custDb"),
                //     process.env.REACT_APP_PASS
                //   ).toString(CryptoJS.enc.Utf8)
                // ) +
                // ".display di ON di.cust_id = ca.cust_id WHERE " +
                globalFilter +
                " AND " +
                where +
                suppressionListCondition +
                " GROUP BY 1";
            } else {
              fQS =
                "select CASE " +
                selectedRule +
                " ELSE 'Remainder' END segment, count(distinct(ca.cust_id)) count FROM " +
                schemaName +
                ".cust_analytic ca LEFT JOIN " +
                schemaName +
                ".client_intellibase ci ON ci.cust_id = ca.cust_id LEFT JOIN (SELECT * FROM (SELECT rank() OVER (partition by email_address, geo_concept ORDER BY em_match_level, cust_id) rank, * FROM " +
                schemaName +
                ".owned_email ) WHERE rank = 1 ) oe ON oe.cust_id = ca.cust_id AND oe.geo_concept = ca.geo_concept LEFT JOIN " +
                schemaName +
                ".eclub ec ON ec.cust_id = ca.cust_id AND ec.eclub_geo_concept = ca.geo_concept LEFT JOIN " +
                schemaName +
                ".geo geo ON geo.geo_id = ca.geo_id_fav AND geo.geo_concept = ca.geo_concept LEFT JOIN " +
                schemaName +
                ".loyalty lo ON lo.cust_id = ca.cust_id AND lo.geo_concept = ca.geo_concept WHERE " +
                // JSON.parse(
                //   CryptoJS.AES.decrypt(
                //     localStorage.getItem("custDb"),
                //     process.env.REACT_APP_PASS
                //   ).toString(CryptoJS.enc.Utf8)
                // ) +
                // ".display di ON di.cust_id = ca.cust_id WHERE " +
                globalFilter +
                " AND " +
                where +
                suppressionListCondition +
                " GROUP BY 1";
            }
          }
        }
      } else if (selectedClientId === "acf275e9-3f68-4250-9f8a-e80672b133f3") {
        // PJ Whelihan's Client
        if (
          selectedChannel === "d1606aea-0c0d-4fba-83e8-a124f414a953" ||
          selectedChannel === "a8f39ffb-24c5-432a-9bcd-e5d0166a320e"  
        ) {
          // Display Channel
          if (where == "") {
            fQS =
              "select CASE " +
              selectedRule +
              " ELSE 'Remainder' END segment, count(distinct(di.cust_id)) count FROM " +
              schemaName +
              ".display_customers di LEFT JOIN " +
              schemaName +
              ".cust_analytic ca ON di.cust_id = ca.cust_id LEFT JOIN " +
              schemaName +
              ".client_intellibase ci ON ci.cust_id = di.cust_id LEFT JOIN (SELECT * FROM (SELECT rank() OVER (partition by email_address, geo_concept ORDER BY em_match_level, cust_id) rank, * FROM " +
              schemaName +
              ".owned_email ) WHERE rank = 1 ) oe ON oe.cust_id = di.cust_id AND oe.geo_concept = di.geo_concept LEFT JOIN " +
              schemaName +
              ".loyalty lo ON lo.cust_id = di.cust_id AND lo.geo_concept = di.geo_concept LEFT JOIN " +
              schemaName +
              ".geo geo ON geo.geo_id = di.geo_id AND geo.geo_concept = di.geo_concept WHERE " +
              globalFilter +
              " AND di.audience_type = 'Customer'" +
              ((selectedChannel === 'a8f39ffb-24c5-432a-9bcd-e5d0166a320e')? " AND ((control_flag = true) or (NULLIF(di.address, '') IS NOT NULL AND NULLIF(di.city, '') IS NOT NULL AND NULLIF(di.state, '') IS NOT NULL AND NULLIF(di.zip, '') IS NOT NULL)) ": "")+
              // suppressionListCondition +
              " GROUP BY 1";
          } else {
            if (where.includes("li.")) {
              fQS =
                "select CASE " +
                selectedRule +
                " ELSE 'Remainder' END segment, count(distinct(di.cust_id)) count FROM " +
                schemaName +
                ".display_customers di LEFT JOIN " +
                schemaName +
                ".cust_analytic ca ON di.cust_id = ca.cust_id LEFT JOIN " +
                schemaName +
                ".client_intellibase ci ON ci.cust_id = di.cust_id LEFT JOIN (SELECT * FROM (SELECT rank() OVER (partition by email_address, geo_concept ORDER BY em_match_level, cust_id) rank, * FROM " +
                schemaName +
                ".owned_email ) WHERE rank = 1 ) oe ON oe.cust_id = di.cust_id AND oe.geo_concept = di.geo_concept LEFT JOIN " +
                schemaName +
                ".loyalty lo ON lo.cust_id = di.cust_id AND lo.geo_concept = di.geo_concept LEFT JOIN " +
                schemaName +
                ".geo geo ON geo.geo_id = di.geo_id AND geo.geo_concept = di.geo_concept WHERE " +
                globalFilter +
                " AND " +
                where +
                " AND di.audience_type = 'Customer'" +
                // suppressionListCondition +
                " GROUP BY 1";
            } else {
              fQS =
                "select CASE " +
                selectedRule +
                " ELSE 'Remainder' END segment, count(distinct(di.cust_id)) count FROM " +
                this.decryptLocal("custDb") +
                ".display_customers di LEFT JOIN " +
                schemaName +
                ".cust_analytic ca ON di.cust_id = ca.cust_id LEFT JOIN " +
                schemaName +
                ".client_intellibase ci ON ci.cust_id = di.cust_id LEFT JOIN (SELECT * FROM (SELECT rank() OVER (partition by email_address, geo_concept ORDER BY em_match_level, cust_id) rank, * FROM " +
                schemaName +
                ".owned_email ) WHERE rank = 1 ) oe ON oe.cust_id = di.cust_id AND oe.geo_concept = di.geo_concept LEFT JOIN " +
                schemaName +
                ".loyalty lo ON lo.cust_id = di.cust_id AND lo.geo_concept = di.geo_concept LEFT JOIN " +
                schemaName +
                ".geo geo ON geo.geo_id = di.geo_id AND geo.geo_concept = di.geo_concept WHERE " +
                globalFilter +
                " AND " +
                where +
                " AND di.audience_type = 'Customer'" +
                // suppressionListCondition +
                " GROUP BY 1";
            }
          }
        } else if (selectedChannel === "0905c46e-6f48-4ed8-b2a9-35dbbf3bae91") {
          // Preclub
          if (where == "") {
            fQS =
              "select CASE " +
              selectedRule +
              " ELSE 'Remainder' END segment, count(distinct(ca.cust_id)) count FROM " +
              schemaName +
              ".cust_analytic ca LEFT JOIN " +
              schemaName +
              ".client_intellibase ci ON ci.cust_id = ca.cust_id LEFT JOIN (SELECT * FROM (SELECT rank() OVER (partition by email_address, geo_concept ORDER BY em_match_level, cust_id) rank, * FROM " +
              schemaName +
              ".owned_email ) WHERE rank = 1 ) oe ON oe.cust_id = ca.cust_id AND oe.geo_concept = ca.geo_concept LEFT JOIN " +
              schemaName +
              ".eclub ec ON ec.cust_id = ca.cust_id AND ec.eclub_geo_concept = ca.geo_concept LEFT JOIN " +
              schemaName +
              ".geo geo ON geo.geo_id = ca.geo_id_fav AND geo.geo_concept = ca.geo_concept LEFT JOIN " +
              schemaName +
              ".loyalty lo ON lo.cust_id = ca.cust_id AND lo.geo_concept = ca.geo_concept WHERE " +
              globalFilter +
              suppressionListCondition +
              " GROUP BY 1";
          } else {
            if (where.includes("li.")) {
              fQS =
                "select CASE " +
                selectedRule +
                " ELSE 'Remainder' END segment, count(distinct(ca.cust_id)) count FROM " +
                schemaName +
                ".cust_analytic ca LEFT JOIN " +
                schemaName +
                ".client_intellibase ci ON ci.cust_id = ca.cust_id LEFT JOIN (SELECT * FROM (SELECT rank() OVER (partition by email_address, geo_concept ORDER BY em_match_level, cust_id) rank, * FROM " +
                schemaName +
                ".owned_email ) WHERE rank = 1 ) oe ON oe.cust_id = ca.cust_id AND oe.geo_concept = ca.geo_concept LEFT JOIN " +
                schemaName +
                ".eclub ec ON ec.cust_id = ca.cust_id AND ec.eclub_geo_concept = ca.geo_concept LEFT JOIN " +
                schemaName +
                ".geo geo ON geo.geo_id = ca.geo_id_fav AND geo.geo_concept = ca.geo_concept LEFT JOIN " +
                schemaName +
                ".loyalty lo ON lo.cust_id = ca.cust_id AND lo.geo_concept = ca.geo_concept WHERE " +
                // JSON.parse(
                //   CryptoJS.AES.decrypt(
                //     localStorage.getItem("custDb"),
                //     process.env.REACT_APP_PASS
                //   ).toString(CryptoJS.enc.Utf8)
                // ).split("_")[0] +
                // "_raw.lists_preclub li ON li.cust_id = ca.cust_id WHERE " +
                // JSON.parse(
                //   CryptoJS.AES.decrypt(
                //     localStorage.getItem("custDb"),
                //     process.env.REACT_APP_PASS
                //   ).toString(CryptoJS.enc.Utf8)
                // ) +
                // ".display di ON di.cust_id = ca.cust_id WHERE " +
                globalFilter +
                " AND " +
                where +
                suppressionListCondition +
                " GROUP BY 1";
            } else {
              fQS =
                "select CASE " +
                selectedRule +
                " ELSE 'Remainder' END segment, count(distinct(ca.cust_id)) count FROM " +
                schemaName +
                ".cust_analytic ca LEFT JOIN " +
                schemaName +
                ".client_intellibase ci ON ci.cust_id = ca.cust_id LEFT JOIN (SELECT * FROM (SELECT rank() OVER (partition by email_address, geo_concept ORDER BY em_match_level, cust_id) rank, * FROM " +
                schemaName +
                ".owned_email ) WHERE rank = 1 ) oe ON oe.cust_id = ca.cust_id AND oe.geo_concept = ca.geo_concept LEFT JOIN " +
                schemaName +
                ".eclub ec ON ec.cust_id = ca.cust_id AND ec.eclub_geo_concept = ca.geo_concept LEFT JOIN " +
                schemaName +
                ".geo geo ON geo.geo_id = ca.geo_id_fav AND geo.geo_concept = ca.geo_concept LEFT JOIN " +
                schemaName +
                ".loyalty lo ON lo.cust_id = ca.cust_id AND lo.geo_concept = ca.geo_concept WHERE " +
                // JSON.parse(
                //   CryptoJS.AES.decrypt(
                //     localStorage.getItem("custDb"),
                //     process.env.REACT_APP_PASS
                //   ).toString(CryptoJS.enc.Utf8)
                // ) +
                // ".display di ON di.cust_id = ca.cust_id WHERE " +
                globalFilter +
                " AND " +
                where +
                suppressionListCondition +
                " GROUP BY 1";
            }
          }
        }
      } else if (
        selectedClientId === "ccbdbd3c-f00d-477b-8f8e-7b0b10ae91f9" ||
        selectedClientId === "7abec586-17b8-4174-993d-e3d86648ed60" ||
        selectedClientId === "5dbdaf6e-01fc-40c3-acd9-3e1b08d8e406" ||
        selectedClientId === "2b7ed789-e2d0-45c0-a45f-49e27d736a7b"
      ) {
        // Houlihan's Brands
        if (selectedChannel === "0905c46e-6f48-4ed8-b2a9-35dbbf3bae91") {
          // Preclub query
          if (where == "") {
            fQS =
              "select CASE " +
              selectedRule +
              " ELSE 'Remainder' END segment, count(distinct(ca.cust_id)) count FROM " +
              this.decryptLocal("custDb") +
              ".cust_analytic ca LEFT JOIN " +
              this.decryptLocal("custDb") +
              ".client_intellibase ci ON ci.cust_id = ca.cust_id LEFT JOIN (SELECT * FROM (SELECT rank() OVER (partition by email_address, geo_concept ORDER BY em_match_level, cust_id) rank, * FROM " +
              this.decryptLocal("custDb") +
              ".owned_email ) WHERE rank = 1 ) oe ON oe.cust_id = ca.cust_id AND oe.geo_concept = ca.geo_concept LEFT JOIN " +
              this.decryptLocal("custDb") +
              ".eclub ec ON ec.cust_id = ca.cust_id AND ec.eclub_geo_concept = ca.geo_concept LEFT JOIN " +
              this.decryptLocal("custDb") +
              ".geo geo ON geo.geo_id = ca.geo_id_fav AND geo.geo_concept = ca.geo_concept LEFT JOIN " +
              this.decryptLocal("custDb") +
              ".loyalty lo ON lo.cust_id = ca.cust_id AND lo.geo_concept = ca.geo_concept LEFT JOIN " +
              ` cog_messages_curated.email_master_status ms ON oe.email_address = ms.email_address where (ca.global_control_flag = true or (final_reason['status'] = '1' and ca.global_control_flag = false and (if(contains(client_unsubscribes, '${
                cmpClientIdObject[
                  this.decryptLocal("clientId")
                ]
              }'),False ,True) or client_unsubscribes is null) and (if(contains(client_complaints, '${
                cmpClientIdObject[
                  this.decryptLocal("clientId")
                ]
              }'),false ,true) or client_complaints is null))) AND ` +
              this.decryptLocal("globalFilter") +
              suppressionListCondition +
              " GROUP BY 1";
          } else {
            // Todo: Code test for the below code block to check whether they are required or not
            if (where.includes("li.")) {
              fQS =
                "select CASE " +
                selectedRule +
                " ELSE 'Remainder' END segment, count(distinct(ca.cust_id)) count FROM " +
                this.decryptLocal("custDb") +
                ".cust_analytic ca LEFT JOIN " +
                this.decryptLocal("custDb") +
                ".client_intellibase ci ON ci.cust_id = ca.cust_id LEFT JOIN (SELECT * FROM (SELECT rank() OVER (partition by email_address, geo_concept ORDER BY em_match_level, cust_id) rank, * FROM " +
                this.decryptLocal("custDb") +
                ".owned_email ) WHERE rank = 1 ) oe ON oe.cust_id = ca.cust_id AND oe.geo_concept = ca.geo_concept LEFT JOIN " +
                this.decryptLocal("custDb") +
                ".eclub ec ON ec.cust_id = ca.cust_id AND ec.eclub_geo_concept = ca.geo_concept LEFT JOIN " +
                this.decryptLocal("custDb") +
                ".geo geo ON geo.geo_id = ca.geo_id_fav AND geo.geo_concept = ca.geo_concept LEFT JOIN " +
                this.decryptLocal("custDb") +
                ".loyalty lo ON lo.cust_id = ca.cust_id AND lo.geo_concept = ca.geo_concept LEFT JOIN " +
                ` cog_messages_curated.email_master_status ms ON oe.email_address = ms.email_address where (ca.global_control_flag = true or (final_reason['status'] = '1' and ca.global_control_flag = false and (if(contains(client_unsubscribes, '${
                  cmpClientIdObject[
                    this.decryptLocal("clientId")
                  ]
                }'),False ,True) or client_unsubscribes is null) and (if(contains(client_complaints, '${
                  cmpClientIdObject[
                    this.decryptLocal("clientId")
                  ]
                }'),false ,true) or client_complaints is null))) AND ` +
                this.decryptLocal("globalFilter") +
                " AND " +
                where +
                suppressionListCondition +
                " GROUP BY 1";
            } else {
              fQS =
                "select CASE " +
                selectedRule +
                " ELSE 'Remainder' END segment, count(distinct(ca.cust_id)) count FROM " +
                this.decryptLocal("custDb") +
                ".cust_analytic ca LEFT JOIN " +
                this.decryptLocal("custDb") +
                ".client_intellibase ci ON ci.cust_id = ca.cust_id LEFT JOIN (SELECT * FROM (SELECT rank() OVER (partition by email_address, geo_concept ORDER BY em_match_level, cust_id) rank, * FROM " +
                this.decryptLocal("custDb") +
                ".owned_email ) WHERE rank = 1 ) oe ON oe.cust_id = ca.cust_id AND oe.geo_concept = ca.geo_concept LEFT JOIN " +
                this.decryptLocal("custDb") +
                ".eclub ec ON ec.cust_id = ca.cust_id AND ec.eclub_geo_concept = ca.geo_concept LEFT JOIN " +
                this.decryptLocal("custDb") +
                ".geo geo ON geo.geo_id = ca.geo_id_fav AND geo.geo_concept = ca.geo_concept LEFT JOIN " +
                this.decryptLocal("custDb") +
                ".loyalty lo ON lo.cust_id = ca.cust_id AND lo.geo_concept = ca.geo_concept LEFT JOIN " +
                ` cog_messages_curated.email_master_status ms ON oe.email_address = ms.email_address where (ca.global_control_flag = true or (final_reason['status'] = '1' and ca.global_control_flag = false and (if(contains(client_unsubscribes, '${
                  cmpClientIdObject[
                    this.decryptLocal("clientId")
                  ]
                }'),False ,True) or client_unsubscribes is null) and (if(contains(client_complaints, '${
                  cmpClientIdObject[
                    this.decryptLocal("clientId")
                  ]
                }'),false ,true) or client_complaints is null))) AND ` +
                this.decryptLocal("globalFilter") +
                " AND " +
                where +
                suppressionListCondition +
                " GROUP BY 1";
            }
          }
        }
        else if(selectedChannel === "d1606aea-0c0d-4fba-83e8-a124f414a953" ||
          selectedChannel === "d977fc2b-2352-473b-9a54-b80765f0400c" ||
          selectedChannel === "79b91604-9f03-428a-9026-9be77ca9a687" ||
          selectedChannel === "a8f39ffb-24c5-432a-9bcd-e5d0166a320e"
        ) {
          if (where == "") {
            fQS =
              "select CASE " +
              selectedRule +
              " ELSE 'Remainder' END segment, count(distinct(di.cust_id)) count FROM " +
              this.decryptLocal("custDb") +
              ".display_customers di LEFT JOIN " +
              this.decryptLocal("custDb") +
              ".cust_analytic ca ON di.cust_id = ca.cust_id LEFT JOIN " +
              this.decryptLocal("custDb") +
              ".client_intellibase ci ON ci.cust_id = di.cust_id LEFT JOIN (SELECT * FROM (SELECT rank() OVER (partition by email_address, geo_concept ORDER BY em_match_level, cust_id) rank, * FROM " +
              this.decryptLocal("custDb") +
              ".owned_email ) WHERE rank = 1 ) oe ON oe.cust_id = di.cust_id AND oe.geo_concept = di.geo_concept LEFT JOIN " +
              this.decryptLocal("custDb") +
              ".geo geo ON geo.geo_id = di.geo_id AND geo.geo_concept = di.geo_concept WHERE " +
              globalFilter +
              " AND di.audience_type = 'Customer'" +
              ((selectedChannel === 'a8f39ffb-24c5-432a-9bcd-e5d0166a320e')? " AND ((control_flag = true) or (NULLIF(di.address, '') IS NOT NULL AND NULLIF(di.city, '') IS NOT NULL AND NULLIF(di.state, '') IS NOT NULL AND NULLIF(di.zip, '') IS NOT NULL)) ": "")+
              // suppressionListCondition +
              " GROUP BY 1";
          } else {
            fQS =
              "select CASE " +
              selectedRule +
              " ELSE 'Remainder' END segment, count(distinct(di.cust_id)) count FROM " +
              this.decryptLocal("custDb") +
              ".display_customers di LEFT JOIN " +
              this.decryptLocal("custDb") +
              ".cust_analytic ca ON di.cust_id = ca.cust_id LEFT JOIN " +
              this.decryptLocal("custDb") +
              ".client_intellibase ci ON ci.cust_id = di.cust_id LEFT JOIN (SELECT * FROM (SELECT rank() OVER (partition by email_address, geo_concept ORDER BY em_match_level, cust_id) rank, * FROM " +
              this.decryptLocal("custDb") +
              ".owned_email ) WHERE rank = 1 ) oe ON oe.cust_id = di.cust_id AND oe.geo_concept = di.geo_concept LEFT JOIN " +
              this.decryptLocal("custDb") +
              ".geo geo ON geo.geo_id = di.geo_id AND geo.geo_concept = di.geo_concept WHERE " +
              globalFilter +
              " AND " +
              where +
              " AND di.audience_type = 'Customer'" +
              ((selectedChannel === 'a8f39ffb-24c5-432a-9bcd-e5d0166a320e')? " AND ((control_flag = true) or (NULLIF(di.address, '') IS NOT NULL AND NULLIF(di.city, '') IS NOT NULL AND NULLIF(di.state, '') IS NOT NULL AND NULLIF(di.zip, '') IS NOT NULL)) ": "")+
              // suppressionListCondition +
              " GROUP BY 1";
          }
          }
      } 
       else if (selectedClientId === "2bdbd6af-6cd3-4358-a1a0-437226a20ee9") {
        if (
          selectedChannel === "d1606aea-0c0d-4fba-83e8-a124f414a953" ||
          selectedChannel === "a8f39ffb-24c5-432a-9bcd-e5d0166a320e"  
        ) {
          if (where == "") {
            fQS =
              "select CASE " +
              selectedRule +
              " ELSE 'Remainder' END segment, count(distinct(di.cust_id)) count FROM " +
              this.decryptLocal("custDb") +
              ".display_customers di LEFT JOIN " +
              this.decryptLocal("custDb") +
              ".cust_analytic ca ON di.cust_id = ca.cust_id LEFT JOIN " +
              this.decryptLocal("custDb") +
              ".client_intellibase ci ON ci.cust_id = di.cust_id LEFT JOIN (SELECT * FROM (SELECT rank() OVER (partition by email_address, geo_concept ORDER BY em_match_level, cust_id) rank, * FROM " +
              this.decryptLocal("custDb") +
              ".owned_email ) WHERE rank = 1 ) oe ON oe.cust_id = di.cust_id AND oe.geo_concept = di.geo_concept LEFT JOIN " +
              this.decryptLocal("custDb") +
              ".geo geo ON geo.geo_id = di.geo_id AND geo.geo_concept = di.geo_concept WHERE " +
              globalFilter +
              " AND di.audience_type = 'Customer'" +
              ((selectedChannel === 'a8f39ffb-24c5-432a-9bcd-e5d0166a320e')? " AND ((control_flag = true) or (NULLIF(di.address, '') IS NOT NULL AND NULLIF(di.city, '') IS NOT NULL AND NULLIF(di.state, '') IS NOT NULL AND NULLIF(di.zip, '') IS NOT NULL)) ": "")+
              // suppressionListCondition +
              " GROUP BY 1";
          } else {
            fQS =
              "select CASE " +
              selectedRule +
              " ELSE 'Remainder' END segment, count(distinct(di.cust_id)) count FROM " +
              this.decryptLocal("custDb") +
              ".display_customers di LEFT JOIN " +
              this.decryptLocal("custDb") +
              ".cust_analytic ca ON di.cust_id = ca.cust_id LEFT JOIN " +
              this.decryptLocal("custDb") +
              ".client_intellibase ci ON ci.cust_id = di.cust_id LEFT JOIN (SELECT * FROM (SELECT rank() OVER (partition by email_address, geo_concept ORDER BY em_match_level, cust_id) rank, * FROM " +
              this.decryptLocal("custDb") +
              ".owned_email ) WHERE rank = 1 ) oe ON oe.cust_id = di.cust_id AND oe.geo_concept = di.geo_concept LEFT JOIN " +
              this.decryptLocal("custDb") +
              ".geo geo ON geo.geo_id = di.geo_id AND geo.geo_concept = di.geo_concept WHERE " +
              globalFilter +
              " AND " +
              where +
              " AND di.audience_type = 'Customer'" +
              ((selectedChannel === 'a8f39ffb-24c5-432a-9bcd-e5d0166a320e')? " AND ((control_flag = true) or (NULLIF(di.address, '') IS NOT NULL AND NULLIF(di.city, '') IS NOT NULL AND NULLIF(di.state, '') IS NOT NULL AND NULLIF(di.zip, '') IS NOT NULL)) ": "")+
              // suppressionListCondition +
              " GROUP BY 1";
          }
        } else {
          if (where == "") {
            fQS =
              "select CASE " +
              selectedRule +
              " ELSE 'Remainder' END segment, count(distinct(ca.cust_id)) count FROM " +
              this.decryptLocal("custDb") +
              ".cust_analytic ca LEFT JOIN " +
              this.decryptLocal("custDb") +
              ".client_intellibase ci ON ci.cust_id = ca.cust_id LEFT JOIN (SELECT * FROM (SELECT rank() OVER (partition by email_address, geo_concept ORDER BY em_match_level, cust_id) rank, * FROM " +
              this.decryptLocal("custDb") +
              ".owned_email ) WHERE rank = 1 ) oe ON oe.cust_id = ca.cust_id AND oe.geo_concept = ca.geo_concept LEFT JOIN " +
              this.decryptLocal("custDb") +
              ".eclub ec ON ec.cust_id = ca.cust_id AND ec.eclub_geo_concept = ca.geo_concept LEFT JOIN " +
              this.decryptLocal("custDb") +
              ".geo geo ON geo.geo_id = ca.geo_id_fav AND geo.geo_concept = ca.geo_concept LEFT JOIN " +
              this.decryptLocal("custDb") +
              ".loyalty lo ON lo.cust_id = ca.cust_id AND lo.geo_concept = ca.geo_concept WHERE " +
              this.decryptLocal("globalFilter") +
              " AND lo.email_address NOT IN (select email_address from goodwill_refined.dnc_list)" +
              suppressionListCondition +
              " GROUP BY 1";
          } else {
            fQS =
              "select CASE " +
              selectedRule +
              " ELSE 'Remainder' END segment, count(distinct(ca.cust_id)) count FROM " +
              this.decryptLocal("custDb") +
              ".cust_analytic ca LEFT JOIN " +
              this.decryptLocal("custDb") +
              ".client_intellibase ci ON ci.cust_id = ca.cust_id LEFT JOIN (SELECT * FROM (SELECT rank() OVER (partition by email_address, geo_concept ORDER BY em_match_level, cust_id) rank, * FROM " +
              this.decryptLocal("custDb") +
              ".owned_email ) WHERE rank = 1 ) oe ON oe.cust_id = ca.cust_id AND oe.geo_concept = ca.geo_concept LEFT JOIN " +
              this.decryptLocal("custDb") +
              ".eclub ec ON ec.cust_id = ca.cust_id AND ec.eclub_geo_concept = ca.geo_concept LEFT JOIN " +
              this.decryptLocal("custDb") +
              ".geo geo ON geo.geo_id = ca.geo_id_fav AND geo.geo_concept = ca.geo_concept LEFT JOIN " +
              this.decryptLocal("custDb") +
              ".loyalty lo ON lo.cust_id = ca.cust_id AND lo.geo_concept = ca.geo_concept WHERE " +
              this.decryptLocal("globalFilter") +
              " AND " +
              where +
              " AND lo.email_address NOT IN (select email_address from goodwill_refined.dnc_list)" +
              suppressionListCondition +
              " GROUP BY 1";
          }
        }
      } else if (selectedClientId === "712cc8e9-3a79-4900-b122-ec9812e0f0ca") {
        if (selectedChannel === "8905c46e-6f48-4ed8-b2a9-35dbbf3bae91") {
          // Friday's OLO
          if (where == "") {
            fQS =
              "select CASE " +
              selectedRule +
              " ELSE 'Remainder' END segment, count(distinct(ca.cust_id)) count FROM " +
              this.decryptLocal("custDb") +
              ".cust_analytic ca LEFT JOIN " +
              this.decryptLocal("custDb") +
              ".client_intellibase ci ON ci.cust_id = ca.cust_id LEFT JOIN (SELECT * FROM (SELECT rank() OVER (partition by email_address, geo_concept ORDER BY em_match_level, cust_id) rank, * FROM " +
              this.decryptLocal("custDb") +
              ".owned_email ) WHERE rank = 1 ) oe ON oe.cust_id = ca.cust_id AND oe.geo_concept = ca.geo_concept LEFT JOIN " +
              this.decryptLocal("custDb") +
              ".eclub ec ON ec.cust_id = ca.cust_id AND ec.eclub_geo_concept = ca.geo_concept LEFT JOIN " +
              this.decryptLocal("custDb") +
              ".geo geo ON geo.geo_id = ca.geo_id_fav AND geo.geo_concept = ca.geo_concept LEFT JOIN " +
              this.decryptLocal("custDb") +
              ".olo_customer oc on oc.cust_id = ca.cust_id LEFT JOIN " +
              this.decryptLocal("custDb") +
              ".loyalty lo ON lo.cust_id = ca.cust_id AND lo.geo_concept = ca.geo_concept WHERE " +
              this.decryptLocal("globalFilter") +
              " AND (oc.email_address not in (select distinct email from fridays_refined.cheetah_events where event_type = 'unsubscribe'))" +
              suppressionListCondition +
              // " AND ca.olo = true AND ca.loyalty = false " +
              " GROUP BY 1";
          } else {
            fQS =
              "select CASE " +
              selectedRule +
              " ELSE 'Remainder' END segment, count(distinct(ca.cust_id)) count FROM " +
              this.decryptLocal("custDb") +
              ".cust_analytic ca LEFT JOIN " +
              this.decryptLocal("custDb") +
              ".client_intellibase ci ON ci.cust_id = ca.cust_id LEFT JOIN (SELECT * FROM (SELECT rank() OVER (partition by email_address, geo_concept ORDER BY em_match_level, cust_id) rank, * FROM " +
              this.decryptLocal("custDb") +
              ".owned_email ) WHERE rank = 1 ) oe ON oe.cust_id = ca.cust_id AND oe.geo_concept = ca.geo_concept LEFT JOIN " +
              this.decryptLocal("custDb") +
              ".eclub ec ON ec.cust_id = ca.cust_id AND ec.eclub_geo_concept = ca.geo_concept LEFT JOIN " +
              this.decryptLocal("custDb") +
              ".geo geo ON geo.geo_id = ca.geo_id_fav AND geo.geo_concept = ca.geo_concept LEFT JOIN " +
              this.decryptLocal("custDb") +
              ".olo_customer oc on oc.cust_id = ca.cust_id LEFT JOIN " +
              this.decryptLocal("custDb") +
              ".loyalty lo ON lo.cust_id = ca.cust_id AND lo.geo_concept = ca.geo_concept WHERE " +
              this.decryptLocal("globalFilter") +
              " AND " +
              where +
              " AND (oc.email_address not in (select distinct email from fridays_refined.cheetah_events where event_type = 'unsubscribe'))" +
              suppressionListCondition +
              // " AND ca.olo = true AND ca.loyalty = false" +
              " GROUP BY 1";
          }
        } else if (selectedChannel === "g786cb0f-eecc-4b87-adef-34eb20f3f766") {
          if (where == "") {
            fQS =
              "select CASE " +
              selectedRule +
              " ELSE 'Remainder' END segment, count(distinct(ca.cust_id)) count FROM " +
              this.decryptLocal("custDb") +
              ".cust_analytic ca LEFT JOIN " +
              this.decryptLocal("custDb") +
              ".client_intellibase ci ON ci.cust_id = ca.cust_id LEFT JOIN (SELECT * FROM (SELECT rank() OVER (partition by email_address, geo_concept ORDER BY em_match_level, cust_id) rank, * FROM " +
              this.decryptLocal("custDb") +
              ".owned_email ) WHERE rank = 1 ) oe ON oe.cust_id = ca.cust_id AND oe.geo_concept = ca.geo_concept LEFT JOIN " +
              this.decryptLocal("custDb") +
              ".eclub ec ON ec.cust_id = ca.cust_id AND ec.eclub_geo_concept = ca.geo_concept LEFT JOIN " +
              this.decryptLocal("custDb") +
              ".geo geo ON geo.geo_id = ca.geo_id_fav AND geo.geo_concept = ca.geo_concept LEFT JOIN " +
              this.decryptLocal("custDb") +
              ".olo_customer oc on oc.cust_id = ca.cust_id LEFT JOIN " +
              this.decryptLocal("custDb") +
              ".loyalty lo ON lo.cust_id = ca.cust_id AND lo.geo_concept = ca.geo_concept WHERE " +
              this.decryptLocal("globalFilter") +
              " AND (lo.email_address not in (select distinct email from fridays_refined.cheetah_events where event_type = 'unsubscribe'))" +
              suppressionListCondition +
              // " AND ca.olo = true AND ca.loyalty = false " +
              " GROUP BY 1";
          } else {
            fQS =
              "select CASE " +
              selectedRule +
              " ELSE 'Remainder' END segment, count(distinct(ca.cust_id)) count FROM " +
              this.decryptLocal("custDb") +
              ".cust_analytic ca LEFT JOIN " +
              this.decryptLocal("custDb") +
              ".client_intellibase ci ON ci.cust_id = ca.cust_id LEFT JOIN (SELECT * FROM (SELECT rank() OVER (partition by email_address, geo_concept ORDER BY em_match_level, cust_id) rank, * FROM " +
              this.decryptLocal("custDb") +
              ".owned_email ) WHERE rank = 1 ) oe ON oe.cust_id = ca.cust_id AND oe.geo_concept = ca.geo_concept LEFT JOIN " +
              this.decryptLocal("custDb") +
              ".eclub ec ON ec.cust_id = ca.cust_id AND ec.eclub_geo_concept = ca.geo_concept LEFT JOIN " +
              this.decryptLocal("custDb") +
              ".geo geo ON geo.geo_id = ca.geo_id_fav AND geo.geo_concept = ca.geo_concept LEFT JOIN " +
              this.decryptLocal("custDb") +
              ".olo_customer oc on oc.cust_id = ca.cust_id LEFT JOIN " +
              this.decryptLocal("custDb") +
              ".loyalty lo ON lo.cust_id = ca.cust_id AND lo.geo_concept = ca.geo_concept WHERE " +
              this.decryptLocal("globalFilter") +
              " AND " +
              where +
              " AND (lo.email_address not in (select distinct email from fridays_refined.cheetah_events where event_type = 'unsubscribe'))" +
              suppressionListCondition +
              " GROUP BY 1";
          }
        } else if (
          selectedChannel === "d1606aea-0c0d-4fba-83e8-a124f414a953" ||
          selectedChannel === "a8f39ffb-24c5-432a-9bcd-e5d0166a320e"
        ) {
          // Friday's Display Channel

          if (where == "") {
            fQS =
              "select CASE " +
              selectedRule +
              " ELSE 'Remainder' END segment, count(distinct(di.cust_id)) count FROM " +
              this.decryptLocal("custDb") +
              ".display_customers di LEFT JOIN " +
              this.decryptLocal("custDb") +
              ".cust_analytic ca ON di.cust_id = ca.cust_id LEFT JOIN " +
              this.decryptLocal("custDb") +
              ".client_intellibase ci ON ci.cust_id = di.cust_id LEFT JOIN (SELECT * FROM (SELECT rank() OVER (partition by email_address, geo_concept ORDER BY em_match_level, cust_id) rank, * FROM " +
              this.decryptLocal("custDb") +
              ".owned_email ) WHERE rank = 1 ) oe ON oe.cust_id = di.cust_id AND oe.geo_concept = di.geo_concept LEFT JOIN " +
              this.decryptLocal("custDb") +
              ".geo geo ON geo.geo_id = di.geo_id AND geo.geo_concept = di.geo_concept WHERE " +
              globalFilter +
              " AND di.audience_type = 'Customer'" +
              ((selectedChannel === 'a8f39ffb-24c5-432a-9bcd-e5d0166a320e')? " AND ((control_flag = true) or (NULLIF(di.address, '') IS NOT NULL AND NULLIF(di.city, '') IS NOT NULL AND NULLIF(di.state, '') IS NOT NULL AND NULLIF(di.zip, '') IS NOT NULL)) ": "")+
              // suppressionListCondition +
              " GROUP BY 1";
          } else {
            fQS =
              "select CASE " +
              selectedRule +
              " ELSE 'Remainder' END segment, count(distinct(di.cust_id)) count FROM " +
              this.decryptLocal("custDb") +
              ".display_customers di LEFT JOIN " +
              this.decryptLocal("custDb") +
              ".cust_analytic ca ON di.cust_id = ca.cust_id LEFT JOIN " +
              this.decryptLocal("custDb") +
              ".client_intellibase ci ON ci.cust_id = di.cust_id LEFT JOIN (SELECT * FROM (SELECT rank() OVER (partition by email_address, geo_concept ORDER BY em_match_level, cust_id) rank, * FROM " +
              this.decryptLocal("custDb") +
              ".owned_email ) WHERE rank = 1 ) oe ON oe.cust_id = di.cust_id AND oe.geo_concept = di.geo_concept LEFT JOIN " +
              this.decryptLocal("custDb") +
              ".geo geo ON geo.geo_id = di.geo_id AND geo.geo_concept = di.geo_concept WHERE " +
              globalFilter +
              " AND " +
              where +
              " AND di.audience_type = 'Customer'" +
              ((selectedChannel === 'a8f39ffb-24c5-432a-9bcd-e5d0166a320e')? " AND ((control_flag = true) or (NULLIF(di.address, '') IS NOT NULL AND NULLIF(di.city, '') IS NOT NULL AND NULLIF(di.state, '') IS NOT NULL AND NULLIF(di.zip, '') IS NOT NULL)) ": "")+
              // suppressionListCondition +
              " GROUP BY 1";
          }
        }
      } else if (
        selectedClientId === "dc0df8ce-c87e-4746-a00e-d2c9ee4d7534" ||
        selectedClientId === "f0d3b19b-a564-43e9-85dd-bd95f8b13f97" ||
        selectedClientId === "f0d3b19b-a564-43e9-85dd-bd95f8b13f97" 
      ) {
        // LouMalantis and DataDelivers Cafe
        if (
          selectedChannel === "d1606aea-0c0d-4fba-83e8-a124f414a953" ||
          selectedChannel === "a8f39ffb-24c5-432a-9bcd-e5d0166a320e"
          ) {
          //  Display Channel
          if (where == "") {
            fQS =
              "select CASE " +
              selectedRule +
              " ELSE 'Remainder' END segment, count(distinct(di.cust_id)) count FROM " +
              this.decryptLocal("custDb") +
              ".display_customers di LEFT JOIN " +
              this.decryptLocal("custDb") +
              ".cust_analytic ca ON di.cust_id = ca.cust_id LEFT JOIN " +
              this.decryptLocal("custDb") +
              ".client_intellibase ci ON ci.cust_id = di.cust_id LEFT JOIN (SELECT * FROM (SELECT rank() OVER (partition by email_address, geo_concept ORDER BY em_match_level, cust_id) rank, * FROM " +
              this.decryptLocal("custDb") +
              ".owned_email ) WHERE rank = 1 ) oe ON oe.cust_id = di.cust_id AND oe.geo_concept = di.geo_concept LEFT JOIN " +
              this.decryptLocal("custDb") +
              ".geo geo ON geo.geo_id = di.geo_id AND geo.geo_concept = di.geo_concept WHERE " +
              globalFilter +
              " AND di.audience_type = 'Customer'" +
              ((selectedChannel === 'a8f39ffb-24c5-432a-9bcd-e5d0166a320e')? " AND ((control_flag = true) or (NULLIF(di.address, '') IS NOT NULL AND NULLIF(di.city, '') IS NOT NULL AND NULLIF(di.state, '') IS NOT NULL AND NULLIF(di.zip, '') IS NOT NULL)) ": "")+
              // suppressionListCondition +
              " GROUP BY 1";
          } else {
            fQS =
              "select CASE " +
              selectedRule +
              " ELSE 'Remainder' END segment, count(distinct(di.cust_id)) count FROM " +
              this.decryptLocal("custDb") +
              ".display_customers di LEFT JOIN " +
              this.decryptLocal("custDb") +
              ".cust_analytic ca ON di.cust_id = ca.cust_id LEFT JOIN " +
              this.decryptLocal("custDb") +
              ".client_intellibase ci ON ci.cust_id = di.cust_id LEFT JOIN (SELECT * FROM (SELECT rank() OVER (partition by email_address, geo_concept ORDER BY em_match_level, cust_id) rank, * FROM " +
              this.decryptLocal("custDb") +
              ".owned_email ) WHERE rank = 1 ) oe ON oe.cust_id = di.cust_id AND oe.geo_concept = di.geo_concept LEFT JOIN " +
              this.decryptLocal("custDb") +
              ".geo geo ON geo.geo_id = di.geo_id AND geo.geo_concept = di.geo_concept WHERE " +
              globalFilter +
              " AND " +
              where +
              " AND di.audience_type = 'Customer'" +
              ((selectedChannel === 'a8f39ffb-24c5-432a-9bcd-e5d0166a320e')? " AND ((control_flag = true) or (NULLIF(di.address, '') IS NOT NULL AND NULLIF(di.city, '') IS NOT NULL AND NULLIF(di.state, '') IS NOT NULL AND NULLIF(di.zip, '') IS NOT NULL)) ": "")+
              // suppressionListCondition +
              " GROUP BY 1";
          }
        } else if (selectedChannel === "0905c46e-6f48-4ed8-b2a9-35dbbf3bae91") {
          if (where == "") {
            fQS =
              "select CASE " +
              selectedRule +
              " ELSE 'Remainder' END segment, count(distinct(ca.cust_id)) count FROM " +
              this.decryptLocal("custDb") +
              ".cust_analytic ca LEFT JOIN " +
              this.decryptLocal("custDb") +
              ".client_intellibase ci ON ci.cust_id = ca.cust_id LEFT JOIN (SELECT * FROM (SELECT rank() OVER (partition by email_address, geo_concept ORDER BY em_match_level, cust_id) rank, * FROM " +
              this.decryptLocal("custDb") +
              ".owned_email ) WHERE rank = 1 ) oe ON oe.cust_id = ca.cust_id AND oe.geo_concept = ca.geo_concept LEFT JOIN " +
              this.decryptLocal("custDb") +
              ".eclub ec ON ec.cust_id = ca.cust_id AND ec.eclub_geo_concept = ca.geo_concept LEFT JOIN " +
              this.decryptLocal("custDb") +
              ".geo geo ON geo.geo_id = ca.geo_id_fav AND geo.geo_concept = ca.geo_concept LEFT JOIN " +
              // JSON.parse(
              //   CryptoJS.AES.decrypt(
              //     localStorage.getItem("custDb"),
              //     process.env.REACT_APP_PASS
              //   ).toString(CryptoJS.enc.Utf8)
              // ) +
              // ".loyalty lo ON lo.cust_id = ca.cust_id AND lo.geo_concept = ca.geo_concept AND (ec.email_address_hh = lo.email_address_hh OR ec.name_addr_key = lo.name_addr_key OR ec.phone_home = lo.loyalty_phone_home OR ec.phone_mobile = lo.loyalty_phone_mobile) LEFT JOIN" +
              ` (SELECT cust_id,geo_concept, max(email_marketable) AS email_marketable FROM ${schemaName}.loyalty WHERE email_marketable IS NOT NULL GROUP BY 1,2) lo ON lo.cust_id = ca.cust_id AND lo.geo_concept = ca.geo_concept LEFT JOIN ` +
              ` cog_messages_curated.email_master_status ms ON oe.email_address = ms.email_address where (ca.global_control_flag = true or (final_reason['status'] = '1' and ca.global_control_flag = false and (if(contains(client_unsubscribes, '${
                cmpClientIdObject[
                  this.decryptLocal("clientId")
                ]
              }'),False ,True) or client_unsubscribes is null) and (if(contains(client_complaints, '${
                cmpClientIdObject[
                  this.decryptLocal("clientId")
                ]
              }'),false ,true) or client_complaints is null))) AND ` +
              this.decryptLocal("globalFilter") +
              (clientIdArrayWithoutSuppressionCondition.includes(
                this.decryptLocal("clientId")
              )
                ? ""
                : suppressionListCondition) +
              // " AND ca.cust_id <> '88'" +
              `AND ca.cust_id <> '${custIdToBeSuppressed}'` +
              " GROUP BY 1";
          } else {
            fQS =
              "select CASE " +
              selectedRule +
              " ELSE 'Remainder' END segment, count(distinct(ca.cust_id)) count FROM " +
              this.decryptLocal("custDb") +
              ".cust_analytic ca LEFT JOIN " +
              this.decryptLocal("custDb") +
              ".client_intellibase ci ON ci.cust_id = ca.cust_id LEFT JOIN (SELECT * FROM (SELECT rank() OVER (partition by email_address, geo_concept ORDER BY em_match_level, cust_id) rank, * FROM " +
              this.decryptLocal("custDb") +
              ".owned_email ) WHERE rank = 1 ) oe ON oe.cust_id = ca.cust_id AND oe.geo_concept = ca.geo_concept LEFT JOIN " +
              this.decryptLocal("custDb") +
              ".eclub ec ON ec.cust_id = ca.cust_id AND ec.eclub_geo_concept = ca.geo_concept LEFT JOIN " +
              this.decryptLocal("custDb") +
              ".geo geo ON geo.geo_id = ca.geo_id_fav AND geo.geo_concept = ca.geo_concept LEFT JOIN " +
              // JSON.parse(
              //   CryptoJS.AES.decrypt(
              //     localStorage.getItem("custDb"),
              //     process.env.REACT_APP_PASS
              //   ).toString(CryptoJS.enc.Utf8)
              // ) +
              // ".loyalty lo ON lo.cust_id = ca.cust_id AND lo.geo_concept = ca.geo_concept AND (ec.email_address_hh = lo.email_address_hh OR ec.name_addr_key = lo.name_addr_key OR ec.phone_home = lo.loyalty_phone_home OR ec.phone_mobile = lo.loyalty_phone_mobile) LEFT JOIN " +
              ` (SELECT cust_id,geo_concept, max(email_marketable) AS email_marketable FROM ${schemaName}.loyalty WHERE email_marketable IS NOT NULL GROUP BY 1,2) lo ON lo.cust_id = ca.cust_id AND lo.geo_concept = ca.geo_concept LEFT JOIN ` +
              ` cog_messages_curated.email_master_status ms ON oe.email_address = ms.email_address where (ca.global_control_flag = true or (final_reason['status'] = '1' and ca.global_control_flag = false and (if(contains(client_unsubscribes, '${
                cmpClientIdObject[
                  this.decryptLocal("clientId")
                ]
              }'),False ,True) or client_unsubscribes is null) and (if(contains(client_complaints, '${
                cmpClientIdObject[
                  this.decryptLocal("clientId")
                ]
              }'),false ,true) or client_complaints is null))) AND ` +
              this.decryptLocal("globalFilter") +
              " AND " +
              where +
              (clientIdArrayWithoutSuppressionCondition.includes(
                this.decryptLocal("clientId")
              )
                ? ""
                : suppressionListCondition) +
              `AND ca.cust_id <> '${custIdToBeSuppressed}'` +
              // " AND ca.cust_id <> '88'" +
              " GROUP BY 1";
          }
        } else if (selectedChannel === "f786cb0f-eecc-4b87-adef-34eb20f3f766") {
          if (where == "") {
            fQS =
              "select CASE " +
              selectedRule +
              " ELSE 'Remainder' END segment, count(distinct(ca.cust_id)) count FROM " +
              this.decryptLocal("custDb") +
              ".cust_analytic ca LEFT JOIN " +
              this.decryptLocal("custDb") +
              ".client_intellibase ci ON ci.cust_id = ca.cust_id LEFT JOIN (SELECT * FROM (SELECT rank() OVER (partition by email_address, geo_concept ORDER BY em_match_level, cust_id) rank, * FROM " +
              this.decryptLocal("custDb") +
              ".owned_email ) WHERE rank = 1 ) oe ON oe.cust_id = ca.cust_id AND oe.geo_concept = ca.geo_concept LEFT JOIN " +
              // JSON.parse(
              //   CryptoJS.AES.decrypt(
              //     localStorage.getItem("custDb"),
              //     process.env.REACT_APP_PASS
              //   ).toString(CryptoJS.enc.Utf8)
              // ) +
              // ".eclub ec ON ec.cust_id = ca.cust_id AND ec.eclub_geo_concept = ca.geo_concept LEFT JOIN " +
              ` (SELECT cust_id,eclub_geo_concept, max(email_marketable) AS email_marketable FROM ${schemaName}.eclub WHERE email_marketable IS NOT NULL GROUP BY 1,2) ec ON ec.cust_id = ca.cust_id AND ec.eclub_geo_concept = ca.geo_concept LEFT JOIN ` +
              this.decryptLocal("custDb") +
              ".geo geo ON geo.geo_id = ca.geo_id_fav AND geo.geo_concept = ca.geo_concept LEFT JOIN " +
              this.decryptLocal("custDb") +
              ".loyalty lo ON lo.cust_id = ca.cust_id AND lo.geo_concept = ca.geo_concept WHERE " +
              this.decryptLocal("globalFilter") +
              (clientIdArrayWithoutSuppressionCondition.includes(
                this.decryptLocal("clientId")
              )
                ? ""
                : suppressionListCondition) +
              `AND ca.cust_id <> '${custIdToBeSuppressed}'` +
              // " AND ca.cust_id <> '88'" +
              " GROUP BY 1";
          } else {
            fQS =
              "select CASE " +
              selectedRule +
              " ELSE 'Remainder' END segment, count(distinct(ca.cust_id)) count FROM " +
              this.decryptLocal("custDb") +
              ".cust_analytic ca LEFT JOIN " +
              this.decryptLocal("custDb") +
              ".client_intellibase ci ON ci.cust_id = ca.cust_id LEFT JOIN (SELECT * FROM (SELECT rank() OVER (partition by email_address, geo_concept ORDER BY em_match_level, cust_id) rank, * FROM " +
              this.decryptLocal("custDb") +
              ".owned_email ) WHERE rank = 1 ) oe ON oe.cust_id = ca.cust_id AND oe.geo_concept = ca.geo_concept LEFT JOIN " +
              // JSON.parse(
              //   CryptoJS.AES.decrypt(
              //     localStorage.getItem("custDb"),
              //     process.env.REACT_APP_PASS
              //   ).toString(CryptoJS.enc.Utf8)
              // ) +
              // ".eclub ec ON ec.cust_id = ca.cust_id AND ec.eclub_geo_concept = ca.geo_concept LEFT JOIN " +
              ` (SELECT cust_id,eclub_geo_concept, max(email_marketable) AS email_marketable FROM ${schemaName}.eclub WHERE email_marketable IS NOT NULL GROUP BY 1,2) ec ON ec.cust_id = ca.cust_id AND ec.eclub_geo_concept = ca.geo_concept LEFT JOIN ` +
              this.decryptLocal("custDb") +
              ".geo geo ON geo.geo_id = ca.geo_id_fav AND geo.geo_concept = ca.geo_concept LEFT JOIN " +
              this.decryptLocal("custDb") +
              ".loyalty lo ON lo.cust_id = ca.cust_id AND lo.geo_concept = ca.geo_concept WHERE " +
              this.decryptLocal("globalFilter") +
              " AND " +
              where +
              (clientIdArrayWithoutSuppressionCondition.includes(
                this.decryptLocal("clientId")
              )
                ? ""
                : suppressionListCondition) +
              `AND ca.cust_id <> '${custIdToBeSuppressed}'` +
              // " AND ca.cust_id <> '88'" +
              " GROUP BY 1";
          }
        } else if (selectedChannel === "3b3e90db-f06b-4ba4-9fbb-769637647ab0") {
          // ECLUB CHANNEL
          if (where == "") {
            fQS =
              "select CASE " +
              selectedRule +
              " ELSE 'Remainder' END segment, count(distinct(ca.cust_id)) count FROM " +
              this.decryptLocal("custDb") +
              ".cust_analytic ca LEFT JOIN " +
              this.decryptLocal("custDb") +
              ".client_intellibase ci ON ci.cust_id = ca.cust_id LEFT JOIN (SELECT * FROM (SELECT rank() OVER (partition by email_address, geo_concept ORDER BY em_match_level, cust_id) rank, * FROM " +
              this.decryptLocal("custDb") +
              ".owned_email ) WHERE rank = 1 ) oe ON oe.cust_id = ca.cust_id AND oe.geo_concept = ca.geo_concept LEFT JOIN " +
              this.decryptLocal("custDb") +
              ".eclub ec ON ec.cust_id = ca.cust_id AND ec.eclub_geo_concept = ca.geo_concept LEFT JOIN " +
              this.decryptLocal("custDb") +
              ".geo geo ON geo.geo_id = ca.geo_id_fav AND geo.geo_concept = ca.geo_concept LEFT JOIN " +
              // JSON.parse(
              //   CryptoJS.AES.decrypt(
              //     localStorage.getItem("custDb"),
              //     process.env.REACT_APP_PASS
              //   ).toString(CryptoJS.enc.Utf8)
              // ) +
              // ".loyalty lo ON lo.cust_id = ca.cust_id AND lo.geo_concept = ca.geo_concept AND (ec.email_address_hh = lo.email_address_hh OR ec.name_addr_key = lo.name_addr_key OR ec.phone_home = lo.loyalty_phone_home OR ec.phone_mobile = lo.loyalty_phone_mobile) LEFT JOIN" +
              ` (SELECT cust_id,geo_concept, max(email_marketable) AS email_marketable FROM ${schemaName}.loyalty WHERE email_marketable IS NOT NULL GROUP BY 1,2) lo ON lo.cust_id = ca.cust_id AND lo.geo_concept = ca.geo_concept WHERE ` +
              this.decryptLocal("globalFilter") +
              (clientIdArrayWithoutSuppressionCondition.includes(
                this.decryptLocal("clientId")
              )
                ? ""
                : suppressionListCondition) +
              `AND ca.cust_id <> '${custIdToBeSuppressed}'` +
              ' and ec.email_marketable = true ' +
              " GROUP BY 1";
          } else {
            fQS =
              "select CASE " +
              selectedRule +
              " ELSE 'Remainder' END segment, count(distinct(ca.cust_id)) count FROM " +
              this.decryptLocal("custDb") +
              ".cust_analytic ca LEFT JOIN " +
              this.decryptLocal("custDb") +
              ".client_intellibase ci ON ci.cust_id = ca.cust_id LEFT JOIN (SELECT * FROM (SELECT rank() OVER (partition by email_address, geo_concept ORDER BY em_match_level, cust_id) rank, * FROM " +
              this.decryptLocal("custDb") +
              ".owned_email ) WHERE rank = 1 ) oe ON oe.cust_id = ca.cust_id AND oe.geo_concept = ca.geo_concept LEFT JOIN " +
              this.decryptLocal("custDb") +
              ".eclub ec ON ec.cust_id = ca.cust_id AND ec.eclub_geo_concept = ca.geo_concept LEFT JOIN " +
              this.decryptLocal("custDb") +
              ".geo geo ON geo.geo_id = ca.geo_id_fav AND geo.geo_concept = ca.geo_concept LEFT JOIN " +
              // JSON.parse(
              //   CryptoJS.AES.decrypt(
              //     localStorage.getItem("custDb"),
              //     process.env.REACT_APP_PASS
              //   ).toString(CryptoJS.enc.Utf8)
              // ) +
              // ".loyalty lo ON lo.cust_id = ca.cust_id AND lo.geo_concept = ca.geo_concept AND (ec.email_address_hh = lo.email_address_hh OR ec.name_addr_key = lo.name_addr_key OR ec.phone_home = lo.loyalty_phone_home OR ec.phone_mobile = lo.loyalty_phone_mobile) LEFT JOIN " +
              ` (SELECT cust_id,geo_concept, max(email_marketable) AS email_marketable FROM ${schemaName}.loyalty WHERE email_marketable IS NOT NULL GROUP BY 1,2) lo ON lo.cust_id = ca.cust_id AND lo.geo_concept = ca.geo_concept WHERE ` +
              this.decryptLocal("globalFilter") +
              " AND " +
              where +
              (clientIdArrayWithoutSuppressionCondition.includes(
                this.decryptLocal("clientId")
              )
                ? ""
                : suppressionListCondition) +
              `AND ca.cust_id <> '${custIdToBeSuppressed}'` +
              ' and ec.email_marketable = true ' +
              " GROUP BY 1";
          }
        }
      } else if (selectedClientId === "ec0df8ce-c87e-4746-a00e-d2c9ee4d7534") {
        // Lous client
        if (
          selectedChannel === "d1606aea-0c0d-4fba-83e8-a124f414a953" ||
          selectedChannel === "a8f39ffb-24c5-432a-9bcd-e5d0166a320e"
        ) {
          //  Display Channel
          if (where == "") {
            fQS =
              "select CASE " +
              selectedRule +
              " ELSE 'Remainder' END segment, count(distinct(di.cust_id)) count FROM " +
              this.decryptLocal("custDb") +
              ".display_customers di LEFT JOIN " +
              this.decryptLocal("custDb") +
              ".cust_analytic ca ON di.cust_id = ca.cust_id LEFT JOIN " +
              this.decryptLocal("custDb") +
              ".client_intellibase ci ON ci.cust_id = di.cust_id LEFT JOIN (SELECT * FROM (SELECT rank() OVER (partition by email_address, geo_concept ORDER BY em_match_level, cust_id) rank, * FROM " +
              this.decryptLocal("custDb") +
              ".owned_email ) WHERE rank = 1 ) oe ON oe.cust_id = di.cust_id AND oe.geo_concept = di.geo_concept LEFT JOIN " +
              this.decryptLocal("custDb") +
              ".geo geo ON geo.geo_id = di.geo_id AND geo.geo_concept = di.geo_concept " + 
              ` LEFT JOIN lous_lookup.item_history ih on ih.cust_id = ca.cust_id ` +
              " WHERE " +
              globalFilter +
              " AND di.audience_type = 'Customer'" +
              ((selectedChannel === 'a8f39ffb-24c5-432a-9bcd-e5d0166a320e')? " AND ((control_flag = true) or (NULLIF(di.address, '') IS NOT NULL AND NULLIF(di.city, '') IS NOT NULL AND NULLIF(di.state, '') IS NOT NULL AND NULLIF(di.zip, '') IS NOT NULL)) ": "")+
              // suppressionListCondition +
              " GROUP BY 1";
          } else {
            fQS =
              "select CASE " +
              selectedRule +
              " ELSE 'Remainder' END segment, count(distinct(di.cust_id)) count FROM " +
              this.decryptLocal("custDb") +
              ".display_customers di LEFT JOIN " +
              this.decryptLocal("custDb") +
              ".cust_analytic ca ON di.cust_id = ca.cust_id LEFT JOIN " +
              this.decryptLocal("custDb") +
              ".client_intellibase ci ON ci.cust_id = di.cust_id LEFT JOIN (SELECT * FROM (SELECT rank() OVER (partition by email_address, geo_concept ORDER BY em_match_level, cust_id) rank, * FROM " +
              this.decryptLocal("custDb") +
              ".owned_email ) WHERE rank = 1 ) oe ON oe.cust_id = di.cust_id AND oe.geo_concept = di.geo_concept LEFT JOIN " +
              this.decryptLocal("custDb") +
              ".geo geo ON geo.geo_id = di.geo_id AND geo.geo_concept = di.geo_concept " + 
              ` LEFT JOIN lous_lookup.item_history ih on ih.cust_id = ca.cust_id ` +
              " WHERE " +
              globalFilter +
              " AND " +
              where +
              " AND di.audience_type = 'Customer'" +
              ((selectedChannel === 'a8f39ffb-24c5-432a-9bcd-e5d0166a320e')? " AND ((control_flag = true) or (NULLIF(di.address, '') IS NOT NULL AND NULLIF(di.city, '') IS NOT NULL AND NULLIF(di.state, '') IS NOT NULL AND NULLIF(di.zip, '') IS NOT NULL)) ": "")+
              // suppressionListCondition +
              " GROUP BY 1";
          }
        } else if (selectedChannel === "0905c46e-6f48-4ed8-b2a9-35dbbf3bae91") {
          if (where == "") {
            fQS =
              "select CASE " +
              selectedRule +
              " ELSE 'Remainder' END segment, count(distinct(ca.cust_id)) count FROM " +
              this.decryptLocal("custDb") +
              ".cust_analytic ca LEFT JOIN " +
              this.decryptLocal("custDb") +
              ".client_intellibase ci ON ci.cust_id = ca.cust_id LEFT JOIN (SELECT * FROM (SELECT rank() OVER (partition by email_address, geo_concept ORDER BY em_match_level, cust_id) rank, * FROM " +
              this.decryptLocal("custDb") +
              ".owned_email ) WHERE rank = 1 ) oe ON oe.cust_id = ca.cust_id AND oe.geo_concept = ca.geo_concept LEFT JOIN " +
              this.decryptLocal("custDb") +
              ".eclub ec ON ec.cust_id = ca.cust_id AND ec.eclub_geo_concept = ca.geo_concept LEFT JOIN " +
              this.decryptLocal("custDb") +
              ".geo geo ON geo.geo_id = ca.geo_id_fav AND geo.geo_concept = ca.geo_concept LEFT JOIN " +
              // JSON.parse(
              //   CryptoJS.AES.decrypt(
              //     localStorage.getItem("custDb"),
              //     process.env.REACT_APP_PASS
              //   ).toString(CryptoJS.enc.Utf8)
              // ) +
              // ".loyalty lo ON lo.cust_id = ca.cust_id AND lo.geo_concept = ca.geo_concept AND (ec.email_address_hh = lo.email_address_hh OR ec.name_addr_key = lo.name_addr_key OR ec.phone_home = lo.loyalty_phone_home OR ec.phone_mobile = lo.loyalty_phone_mobile) LEFT JOIN" +
              ` (SELECT cust_id,geo_concept, max(email_marketable) AS email_marketable FROM ${schemaName}.loyalty WHERE email_marketable IS NOT NULL GROUP BY 1,2) lo ON lo.cust_id = ca.cust_id AND lo.geo_concept = ca.geo_concept LEFT JOIN ` +
              ` cog_messages_curated.email_master_status ms ON oe.email_address = ms.email_address where (ca.global_control_flag = true or (final_reason['status'] = '1' and ca.global_control_flag = false and (if(contains(client_unsubscribes, '${
                cmpClientIdObject[
                  this.decryptLocal("clientId")
                ]
              }'),False ,True) or client_unsubscribes is null) and (if(contains(client_complaints, '${
                cmpClientIdObject[
                  this.decryptLocal("clientId")
                ]
              }'),false ,true) or client_complaints is null))) AND ` +
              this.decryptLocal("globalFilter") +
              (clientIdArrayWithoutSuppressionCondition.includes(
                this.decryptLocal("clientId")
              )
                ? ""
                : suppressionListCondition) +
              // " AND ca.cust_id <> '88'" +
              `AND ca.cust_id <> '${custIdToBeSuppressed}'` +
              " GROUP BY 1";
          } else {
            fQS =
              "select CASE " +
              selectedRule +
              " ELSE 'Remainder' END segment, count(distinct(ca.cust_id)) count FROM " +
              this.decryptLocal("custDb") +
              ".cust_analytic ca LEFT JOIN " +
              this.decryptLocal("custDb") +
              ".client_intellibase ci ON ci.cust_id = ca.cust_id LEFT JOIN (SELECT * FROM (SELECT rank() OVER (partition by email_address, geo_concept ORDER BY em_match_level, cust_id) rank, * FROM " +
              this.decryptLocal("custDb") +
              ".owned_email ) WHERE rank = 1 ) oe ON oe.cust_id = ca.cust_id AND oe.geo_concept = ca.geo_concept LEFT JOIN " +
              this.decryptLocal("custDb") +
              ".eclub ec ON ec.cust_id = ca.cust_id AND ec.eclub_geo_concept = ca.geo_concept LEFT JOIN " +
              this.decryptLocal("custDb") +
              ".geo geo ON geo.geo_id = ca.geo_id_fav AND geo.geo_concept = ca.geo_concept LEFT JOIN " +
              // JSON.parse(
              //   CryptoJS.AES.decrypt(
              //     localStorage.getItem("custDb"),
              //     process.env.REACT_APP_PASS
              //   ).toString(CryptoJS.enc.Utf8)
              // ) +
              // ".loyalty lo ON lo.cust_id = ca.cust_id AND lo.geo_concept = ca.geo_concept AND (ec.email_address_hh = lo.email_address_hh OR ec.name_addr_key = lo.name_addr_key OR ec.phone_home = lo.loyalty_phone_home OR ec.phone_mobile = lo.loyalty_phone_mobile) LEFT JOIN " +
              ` (SELECT cust_id,geo_concept, max(email_marketable) AS email_marketable FROM ${schemaName}.loyalty WHERE email_marketable IS NOT NULL GROUP BY 1,2) lo ON lo.cust_id = ca.cust_id AND lo.geo_concept = ca.geo_concept LEFT JOIN ` +
              ` cog_messages_curated.email_master_status ms ON oe.email_address = ms.email_address where (ca.global_control_flag = true or (final_reason['status'] = '1' and ca.global_control_flag = false and (if(contains(client_unsubscribes, '${
                cmpClientIdObject[
                  this.decryptLocal("clientId")
                ]
              }'),False ,True) or client_unsubscribes is null) and (if(contains(client_complaints, '${
                cmpClientIdObject[
                  this.decryptLocal("clientId")
                ]
              }'),false ,true) or client_complaints is null))) AND ` +
              this.decryptLocal("globalFilter") +
              " AND " +
              where +
              (clientIdArrayWithoutSuppressionCondition.includes(
                this.decryptLocal("clientId")
              )
                ? ""
                : suppressionListCondition) +
              `AND ca.cust_id <> '${custIdToBeSuppressed}'` +
              // " AND ca.cust_id <> '88'" +
              " GROUP BY 1";
          }
        } else if (selectedChannel === "f786cb0f-eecc-4b87-adef-34eb20f3f766") {
          if (where == "") {
            fQS =
              "select CASE " +
              selectedRule +
              " ELSE 'Remainder' END segment, count(distinct(ca.cust_id)) count FROM " +
              this.decryptLocal("custDb") +
              ".cust_analytic ca LEFT JOIN " +
              this.decryptLocal("custDb") +
              ".client_intellibase ci ON ci.cust_id = ca.cust_id LEFT JOIN (SELECT * FROM (SELECT rank() OVER (partition by email_address, geo_concept ORDER BY em_match_level, cust_id) rank, * FROM " +
              this.decryptLocal("custDb") +
              ".owned_email ) WHERE rank = 1 ) oe ON oe.cust_id = ca.cust_id AND oe.geo_concept = ca.geo_concept LEFT JOIN " +
              // JSON.parse(
              //   CryptoJS.AES.decrypt(
              //     localStorage.getItem("custDb"),
              //     process.env.REACT_APP_PASS
              //   ).toString(CryptoJS.enc.Utf8)
              // ) +
              // ".eclub ec ON ec.cust_id = ca.cust_id AND ec.eclub_geo_concept = ca.geo_concept LEFT JOIN " +
              ` (SELECT cust_id,eclub_geo_concept, max(email_marketable) AS email_marketable FROM ${schemaName}.eclub WHERE email_marketable IS NOT NULL GROUP BY 1,2) ec ON ec.cust_id = ca.cust_id AND ec.eclub_geo_concept = ca.geo_concept LEFT JOIN ` +
              this.decryptLocal("custDb") +
              ".geo geo ON geo.geo_id = ca.geo_id_fav AND geo.geo_concept = ca.geo_concept LEFT JOIN " +
              this.decryptLocal("custDb") +
              ".loyalty lo ON lo.cust_id = ca.cust_id AND lo.geo_concept = ca.geo_concept WHERE " +
              this.decryptLocal("globalFilter") +
              (clientIdArrayWithoutSuppressionCondition.includes(
                this.decryptLocal("clientId")
              )
                ? ""
                : suppressionListCondition) +
              `AND ca.cust_id <> '${custIdToBeSuppressed}'` +
              // " AND ca.cust_id <> '88'" +
              " GROUP BY 1";
          } else {
            fQS =
              "select CASE " +
              selectedRule +
              " ELSE 'Remainder' END segment, count(distinct(ca.cust_id)) count FROM " +
              this.decryptLocal("custDb") +
              ".cust_analytic ca LEFT JOIN " +
              this.decryptLocal("custDb") +
              ".client_intellibase ci ON ci.cust_id = ca.cust_id LEFT JOIN (SELECT * FROM (SELECT rank() OVER (partition by email_address, geo_concept ORDER BY em_match_level, cust_id) rank, * FROM " +
              this.decryptLocal("custDb") +
              ".owned_email ) WHERE rank = 1 ) oe ON oe.cust_id = ca.cust_id AND oe.geo_concept = ca.geo_concept LEFT JOIN " +
              // JSON.parse(
              //   CryptoJS.AES.decrypt(
              //     localStorage.getItem("custDb"),
              //     process.env.REACT_APP_PASS
              //   ).toString(CryptoJS.enc.Utf8)
              // ) +
              // ".eclub ec ON ec.cust_id = ca.cust_id AND ec.eclub_geo_concept = ca.geo_concept LEFT JOIN " +
              ` (SELECT cust_id,eclub_geo_concept, max(email_marketable) AS email_marketable FROM ${schemaName}.eclub WHERE email_marketable IS NOT NULL GROUP BY 1,2) ec ON ec.cust_id = ca.cust_id AND ec.eclub_geo_concept = ca.geo_concept LEFT JOIN ` +
              this.decryptLocal("custDb") +
              ".geo geo ON geo.geo_id = ca.geo_id_fav AND geo.geo_concept = ca.geo_concept LEFT JOIN " +
              this.decryptLocal("custDb") +
              ".loyalty lo ON lo.cust_id = ca.cust_id AND lo.geo_concept = ca.geo_concept WHERE " +
              this.decryptLocal("globalFilter") +
              " AND " +
              where +
              (clientIdArrayWithoutSuppressionCondition.includes(
                this.decryptLocal("clientId")
              )
                ? ""
                : suppressionListCondition) +
              `AND ca.cust_id <> '${custIdToBeSuppressed}'` +
              // " AND ca.cust_id <> '88'" +
              " GROUP BY 1";
          }
        } else if (selectedChannel === "3b3e90db-f06b-4ba4-9fbb-769637647ab0") {
          if (where == "") {
            fQS =
              "select CASE " +
              selectedRule +
              " ELSE 'Remainder' END segment, count(distinct(ca.cust_id)) count FROM " +
              this.decryptLocal("custDb") +
              ".cust_analytic ca LEFT JOIN " +
              this.decryptLocal("custDb") +
              ".client_intellibase ci ON ci.cust_id = ca.cust_id LEFT JOIN (SELECT * FROM (SELECT rank() OVER (partition by email_address, geo_concept ORDER BY em_match_level, cust_id) rank, * FROM " +
              this.decryptLocal("custDb") +
              ".owned_email ) WHERE rank = 1 ) oe ON oe.cust_id = ca.cust_id AND oe.geo_concept = ca.geo_concept LEFT JOIN " +
              this.decryptLocal("custDb") +
              ".eclub ec ON ec.cust_id = ca.cust_id AND ec.eclub_geo_concept = ca.geo_concept LEFT JOIN " +
              this.decryptLocal("custDb") +
              ".geo geo ON geo.geo_id = ca.geo_id_fav AND geo.geo_concept = ca.geo_concept LEFT JOIN " +
              // JSON.parse(
              //   CryptoJS.AES.decrypt(
              //     localStorage.getItem("custDb"),
              //     process.env.REACT_APP_PASS
              //   ).toString(CryptoJS.enc.Utf8)
              // ) +
              // ".loyalty lo ON lo.cust_id = ca.cust_id AND lo.geo_concept = ca.geo_concept AND (ec.email_address_hh = lo.email_address_hh OR ec.name_addr_key = lo.name_addr_key OR ec.phone_home = lo.loyalty_phone_home OR ec.phone_mobile = lo.loyalty_phone_mobile) LEFT JOIN" +
              ` (SELECT cust_id,geo_concept, max(email_marketable) AS email_marketable FROM ${schemaName}.loyalty WHERE email_marketable IS NOT NULL GROUP BY 1,2) lo ON lo.cust_id = ca.cust_id AND lo.geo_concept = ca.geo_concept WHERE ` +
              this.decryptLocal("globalFilter") +
              (clientIdArrayWithoutSuppressionCondition.includes(
                this.decryptLocal("clientId")
              )
                ? ""
                : suppressionListCondition) +
              `AND ca.cust_id <> '${custIdToBeSuppressed}'` +
              ' and ec.email_marketable = true ' +
              " GROUP BY 1";
          } else {
            fQS =
              "select CASE " +
              selectedRule +
              " ELSE 'Remainder' END segment, count(distinct(ca.cust_id)) count FROM " +
              this.decryptLocal("custDb") +
              ".cust_analytic ca LEFT JOIN " +
              this.decryptLocal("custDb") +
              ".client_intellibase ci ON ci.cust_id = ca.cust_id LEFT JOIN (SELECT * FROM (SELECT rank() OVER (partition by email_address, geo_concept ORDER BY em_match_level, cust_id) rank, * FROM " +
              this.decryptLocal("custDb") +
              ".owned_email ) WHERE rank = 1 ) oe ON oe.cust_id = ca.cust_id AND oe.geo_concept = ca.geo_concept LEFT JOIN " +
              this.decryptLocal("custDb") +
              ".eclub ec ON ec.cust_id = ca.cust_id AND ec.eclub_geo_concept = ca.geo_concept LEFT JOIN " +
              this.decryptLocal("custDb") +
              ".geo geo ON geo.geo_id = ca.geo_id_fav AND geo.geo_concept = ca.geo_concept LEFT JOIN " +
              // JSON.parse(
              //   CryptoJS.AES.decrypt(
              //     localStorage.getItem("custDb"),
              //     process.env.REACT_APP_PASS
              //   ).toString(CryptoJS.enc.Utf8)
              // ) +
              // ".loyalty lo ON lo.cust_id = ca.cust_id AND lo.geo_concept = ca.geo_concept AND (ec.email_address_hh = lo.email_address_hh OR ec.name_addr_key = lo.name_addr_key OR ec.phone_home = lo.loyalty_phone_home OR ec.phone_mobile = lo.loyalty_phone_mobile) LEFT JOIN " +
              ` (SELECT cust_id,geo_concept, max(email_marketable) AS email_marketable FROM ${schemaName}.loyalty WHERE email_marketable IS NOT NULL GROUP BY 1,2) lo ON lo.cust_id = ca.cust_id AND lo.geo_concept = ca.geo_concept WHERE ` +
              this.decryptLocal("globalFilter") +
              " AND " +
              where +
              (clientIdArrayWithoutSuppressionCondition.includes(
                this.decryptLocal("clientId")
              )
                ? ""
                : suppressionListCondition) +
              `AND ca.cust_id <> '${custIdToBeSuppressed}'` +
              ' and ec.email_marketable = true ' +
              " GROUP BY 1";
          }
        }
      } else if (
        (selectedClientId === "30b8b18b-4a66-4f1a-9ee6-a60bb0da062f" ||
          selectedClientId === "ca2d8a6b-0eb8-48e2-b81a-41d12c14e04c" ||
          selectedClientId === "687c8c2a-0986-4147-bf38-0d5bac9f7530" ||
          selectedClientId === "b44cc84d-73b5-4457-bb48-68e9626d08e1" ||
          selectedClientId === "1857ba2f-010f-4f49-bcd1-f9fd09db2799" ||
          selectedClientId === "e722fa14-9dbd-11ee-8c90-0242ac120002") &&
        (
          selectedChannel === "d1606aea-0c0d-4fba-83e8-a124f414a953" ||
          selectedChannel === "a8f39ffb-24c5-432a-9bcd-e5d0166a320e"
        )
      ) {
        if (where == "") {
          fQS =
            "select CASE " +
            selectedRule +
            " ELSE 'Remainder' END segment, count(distinct(di.cust_id)) count FROM " +
            this.decryptLocal("custDb") +
            ".display_customers di LEFT JOIN " +
            this.decryptLocal("custDb") +
            ".cust_analytic ca ON di.cust_id = ca.cust_id LEFT JOIN " +
            this.decryptLocal("custDb") +
            ".client_intellibase ci ON ci.cust_id = di.cust_id LEFT JOIN (SELECT * FROM (SELECT rank() OVER (partition by email_address, geo_concept ORDER BY em_match_level, cust_id) rank, * FROM " +
            this.decryptLocal("custDb") +
            ".owned_email ) WHERE rank = 1 ) oe ON oe.cust_id = di.cust_id AND oe.geo_concept = di.geo_concept LEFT JOIN " +
            this.decryptLocal("custDb") +
            ".geo geo ON geo.geo_id = di.geo_id AND geo.geo_concept = di.geo_concept WHERE " +
            globalFilter +
            " AND di.audience_type = 'Customer'" +
            ((selectedChannel === 'a8f39ffb-24c5-432a-9bcd-e5d0166a320e')? " AND ((control_flag = true) or (NULLIF(di.address, '') IS NOT NULL AND NULLIF(di.city, '') IS NOT NULL AND NULLIF(di.state, '') IS NOT NULL AND NULLIF(di.zip, '') IS NOT NULL)) ": "")+
            // suppressionListCondition +
            " GROUP BY 1";
        } else {
          fQS =
            "select CASE " +
            selectedRule +
            " ELSE 'Remainder' END segment, count(distinct(di.cust_id)) count FROM " +
            this.decryptLocal("custDb") +
            ".display_customers di LEFT JOIN " +
            this.decryptLocal("custDb") +
            ".cust_analytic ca ON di.cust_id = ca.cust_id LEFT JOIN " +
            this.decryptLocal("custDb") +
            ".client_intellibase ci ON ci.cust_id = di.cust_id LEFT JOIN (SELECT * FROM (SELECT rank() OVER (partition by email_address, geo_concept ORDER BY em_match_level, cust_id) rank, * FROM " +
            this.decryptLocal("custDb") +
            ".owned_email ) WHERE rank = 1 ) oe ON oe.cust_id = di.cust_id AND oe.geo_concept = di.geo_concept LEFT JOIN " +
            this.decryptLocal("custDb") +
            ".geo geo ON geo.geo_id = di.geo_id AND geo.geo_concept = di.geo_concept WHERE " +
            globalFilter +
            " AND " +
            where +
            " AND di.audience_type = 'Customer'" +
            ((selectedChannel === 'a8f39ffb-24c5-432a-9bcd-e5d0166a320e')? " AND ((control_flag = true) or (NULLIF(di.address, '') IS NOT NULL AND NULLIF(di.city, '') IS NOT NULL AND NULLIF(di.state, '') IS NOT NULL AND NULLIF(di.zip, '') IS NOT NULL)) ": "")+
            // suppressionListCondition +
            " GROUP BY 1";
        }
      } else {
        // ToC Email Channel
        if (this.decryptLocal("activeChannel") === "1905c46e-6f48-4ed8-b2a9-35dbbf3bae91") {
          fQS =
            "select CASE " +
            selectedRule +
            " ELSE 'Remainder' END segment, count(distinct(ca.cust_id)) count FROM " +
            this.decryptLocal("custDb") +
            ".cust_analytic ca LEFT JOIN " +
            this.decryptLocal("custDb") +
            ".client_intellibase ci ON ci.cust_id = ca.cust_id LEFT JOIN (SELECT * FROM (SELECT rank() OVER (partition by email_address, geo_concept ORDER BY em_match_level, cust_id) rank, * FROM " +
            this.decryptLocal("custDb") +
            ".owned_email ) WHERE rank = 1 ) oe ON oe.cust_id = ca.cust_id AND oe.geo_concept = ca.geo_concept LEFT JOIN " +
            this.decryptLocal("custDb") +
            ".eclub ec ON ec.cust_id = ca.cust_id AND ec.eclub_geo_concept = ca.geo_concept LEFT JOIN " +
            this.decryptLocal("custDb") +
            ".geo geo ON geo.geo_id = ca.geo_id_fav AND geo.geo_concept = ca.geo_concept LEFT JOIN " +
            this.decryptLocal("custDb") +
            ".loyalty lo ON lo.cust_id = ca.cust_id AND lo.geo_concept = ca.geo_concept LEFT JOIN " +
            ` cog_messages_curated.email_master_status ms ON oe.email_address = ms.email_address where (ca.global_control_flag = true or (final_reason['status'] = '1' and ca.global_control_flag = false and (if(contains(client_unsubscribes, '${
              cmpClientIdObject[
                this.decryptLocal("clientId")
              ]
            }'),False ,True) or client_unsubscribes is null) and (if(contains(client_complaints, '${
              cmpClientIdObject[
                this.decryptLocal("clientId")
              ]
            }'),false ,true) or client_complaints is null))) AND ` +
            this.decryptLocal("globalFilter") +
            (clientIdArrayWithoutSuppressionCondition.includes(
              this.decryptLocal("clientId")
            )
              ? ""
              : suppressionListCondition) +
            " GROUP BY 1";
        }
        // ToC Eclub Channel
        else if(this.decryptLocal("activeChannel") === "3b3e90db-f06b-4ba4-9fbb-769637647ab0") {
          if (where == "") {
            fQS =
              "select CASE " +
              selectedRule +
              " ELSE 'Remainder' END segment, count(distinct(ca.cust_id)) count FROM " +
              this.decryptLocal("custDb") +
              ".cust_analytic ca LEFT JOIN " +
              this.decryptLocal("custDb") +
              ".client_intellibase ci ON ci.cust_id = ca.cust_id LEFT JOIN (SELECT * FROM (SELECT rank() OVER (partition by email_address, geo_concept ORDER BY em_match_level, cust_id) rank, * FROM " +
              this.decryptLocal("custDb") +
              ".owned_email ) WHERE rank = 1 ) oe ON oe.cust_id = ca.cust_id AND oe.geo_concept = ca.geo_concept LEFT JOIN " +
              this.decryptLocal("custDb") +
              ".eclub ec ON ec.cust_id = ca.cust_id AND ec.eclub_geo_concept = ca.geo_concept LEFT JOIN " +
              this.decryptLocal("custDb") +
              ".geo geo ON geo.geo_id = ca.geo_id_fav AND geo.geo_concept = ca.geo_concept LEFT JOIN " +
              this.decryptLocal("custDb") +
              ".loyalty lo ON lo.cust_id = ca.cust_id AND lo.geo_concept = ca.geo_concept WHERE " +
              this.decryptLocal("globalFilter") +
              suppressionListCondition +
              " GROUP BY 1";
          } else {
            if (where.includes("li.")) {
              fQS =
                "select CASE " +
                selectedRule +
                " ELSE 'Remainder' END segment, count(distinct(ca.cust_id)) count FROM " +
                this.decryptLocal("custDb") +
                ".cust_analytic ca LEFT JOIN " +
                this.decryptLocal("custDb") +
                ".client_intellibase ci ON ci.cust_id = ca.cust_id LEFT JOIN (SELECT * FROM (SELECT rank() OVER (partition by email_address, geo_concept ORDER BY em_match_level, cust_id) rank, * FROM " +
                this.decryptLocal("custDb") +
                ".owned_email ) WHERE rank = 1 ) oe ON oe.cust_id = ca.cust_id AND oe.geo_concept = ca.geo_concept LEFT JOIN " +
                this.decryptLocal("custDb") +
                ".eclub ec ON ec.cust_id = ca.cust_id AND ec.eclub_geo_concept = ca.geo_concept LEFT JOIN " +
                this.decryptLocal("custDb") +
                ".geo geo ON geo.geo_id = ca.geo_id_fav AND geo.geo_concept = ca.geo_concept LEFT JOIN " +
                this.decryptLocal("custDb") +
                ".loyalty lo ON lo.cust_id = ca.cust_id AND lo.geo_concept = ca.geo_concept WHERE " +
                this.decryptLocal("globalFilter") +
                " AND " +
                where +
                suppressionListCondition +
                " GROUP BY 1";
            } else {
              fQS =
                "select CASE " +
                selectedRule +
                " ELSE 'Remainder' END segment, count(distinct(ca.cust_id)) count FROM " +
                this.decryptLocal("custDb") +
                ".cust_analytic ca LEFT JOIN " +
                this.decryptLocal("custDb") +
                ".client_intellibase ci ON ci.cust_id = ca.cust_id LEFT JOIN (SELECT * FROM (SELECT rank() OVER (partition by email_address, geo_concept ORDER BY em_match_level, cust_id) rank, * FROM " +
                this.decryptLocal("custDb") +
                ".owned_email ) WHERE rank = 1 ) oe ON oe.cust_id = ca.cust_id AND oe.geo_concept = ca.geo_concept LEFT JOIN " +
                this.decryptLocal("custDb") +
                ".eclub ec ON ec.cust_id = ca.cust_id AND ec.eclub_geo_concept = ca.geo_concept LEFT JOIN " +
                this.decryptLocal("custDb") +
                ".geo geo ON geo.geo_id = ca.geo_id_fav AND geo.geo_concept = ca.geo_concept LEFT JOIN " +
                this.decryptLocal("custDb") +
                ".loyalty lo ON lo.cust_id = ca.cust_id AND lo.geo_concept = ca.geo_concept WHERE " +
                this.decryptLocal("globalFilter") +
                " AND " +
                where +
                suppressionListCondition +
                " GROUP BY 1";
            }
          }
        }
        else if (where == "") {
          if (
            this.decryptLocal("activeChannel") === "0905c46e-6f48-4ed8-b2a9-35dbbf3bae91"
          ) {
            // Other clients Preclub channel
            fQS =
              "select CASE " +
              selectedRule +
              " ELSE 'Remainder' END segment, count(distinct(ca.cust_id)) count FROM " +
              this.decryptLocal("custDb") +
              ".cust_analytic ca LEFT JOIN " +
              this.decryptLocal("custDb") +
              ".client_intellibase ci ON ci.cust_id = ca.cust_id LEFT JOIN (SELECT * FROM (SELECT rank() OVER (partition by email_address, geo_concept ORDER BY em_match_level, cust_id) rank, * FROM " +
              this.decryptLocal("custDb") +
              ".owned_email ) WHERE rank = 1 ) oe ON oe.cust_id = ca.cust_id AND oe.geo_concept = ca.geo_concept LEFT JOIN " +
              this.decryptLocal("custDb") +
              ".eclub ec ON ec.cust_id = ca.cust_id AND ec.eclub_geo_concept = ca.geo_concept LEFT JOIN " +
              this.decryptLocal("custDb") +
              ".geo geo ON geo.geo_id = ca.geo_id_fav AND geo.geo_concept = ca.geo_concept LEFT JOIN " +
              this.decryptLocal("custDb") +
              ".loyalty lo ON lo.cust_id = ca.cust_id AND lo.geo_concept = ca.geo_concept LEFT JOIN " +
              ` cog_messages_curated.email_master_status ms ON oe.email_address = ms.email_address where (ca.global_control_flag = true or (final_reason['status'] = '1' and ca.global_control_flag = false and (if(contains(client_unsubscribes, '${
                cmpClientIdObject[
                  this.decryptLocal("clientId")
                ]
              }'),False ,True) or client_unsubscribes is null) and (if(contains(client_complaints, '${
                cmpClientIdObject[
                  this.decryptLocal("clientId")
                ]
              }'),false ,true) or client_complaints is null))) AND ` +
              this.decryptLocal("globalFilter") +
              (clientIdArrayWithoutSuppressionCondition.includes(
                this.decryptLocal("clientId")
              )
                ? ""
                : suppressionListCondition) +
              " GROUP BY 1";
          }
          else {
            // Other clients - Non Preclub channel
            fQS =
              "select CASE " +
              selectedRule +
              " ELSE 'Remainder' END segment, count(distinct(ca.cust_id)) count FROM " +
              this.decryptLocal("custDb") +
              ".cust_analytic ca LEFT JOIN " +
              this.decryptLocal("custDb") +
              ".client_intellibase ci ON ci.cust_id = ca.cust_id LEFT JOIN (SELECT * FROM (SELECT rank() OVER (partition by email_address, geo_concept ORDER BY em_match_level, cust_id) rank, * FROM " +
              this.decryptLocal("custDb") +
              ".owned_email ) WHERE rank = 1 ) oe ON oe.cust_id = ca.cust_id AND oe.geo_concept = ca.geo_concept LEFT JOIN " +
              this.decryptLocal("custDb") +
              ".eclub ec ON ec.cust_id = ca.cust_id AND ec.eclub_geo_concept = ca.geo_concept LEFT JOIN " +
              this.decryptLocal("custDb") +
              ".geo geo ON geo.geo_id = ca.geo_id_fav AND geo.geo_concept = ca.geo_concept LEFT JOIN " +
              this.decryptLocal("custDb") +
              ".loyalty lo ON lo.cust_id = ca.cust_id AND lo.geo_concept = ca.geo_concept WHERE " +
              this.decryptLocal("globalFilter") +
              (clientIdArrayWithoutSuppressionCondition.includes(
                this.decryptLocal("clientId")
              )
                ? ""
                : suppressionListCondition) +
              " GROUP BY 1";
          }
        } else {
          if (where.includes("li.")) {
            if (
              this.decryptLocal("activeChannel") === "0905c46e-6f48-4ed8-b2a9-35dbbf3bae91"
            ) {
              fQS =
                "select CASE " +
                selectedRule +
                " ELSE 'Remainder' END segment, count(distinct(ca.cust_id)) count FROM " +
                this.decryptLocal("custDb") +
                ".cust_analytic ca LEFT JOIN " +
                this.decryptLocal("custDb") +
                ".client_intellibase ci ON ci.cust_id = ca.cust_id LEFT JOIN (SELECT * FROM (SELECT rank() OVER (partition by email_address, geo_concept ORDER BY em_match_level, cust_id) rank, * FROM " +
                this.decryptLocal("custDb") +
                ".owned_email ) WHERE rank = 1 ) oe ON oe.cust_id = ca.cust_id AND oe.geo_concept = ca.geo_concept LEFT JOIN " +
                this.decryptLocal("custDb") +
                ".eclub ec ON ec.cust_id = ca.cust_id AND ec.eclub_geo_concept = ca.geo_concept LEFT JOIN " +
                this.decryptLocal("custDb") +
                ".geo geo ON geo.geo_id = ca.geo_id_fav AND geo.geo_concept = ca.geo_concept LEFT JOIN " +
                this.decryptLocal("custDb") +
                ".loyalty lo ON lo.cust_id = ca.cust_id AND lo.geo_concept = ca.geo_concept LEFT JOIN " +
                this.decryptLocal("custDb").split("_")[0] +
                "_raw." +
                (this.decryptLocal("model") === "restaurant_v2"
                  ? "lists_preclub"
                  : "deliveries") +
                " li ON li.cust_id = ca.cust_id LEFT JOIN " +
                ` cog_messages_curated.email_master_status ms ON oe.email_address = ms.email_address where (ca.global_control_flag = true or (final_reason['status'] = '1' and ca.global_control_flag = false and (if(contains(client_unsubscribes, '${
                  cmpClientIdObject[
                    this.decryptLocal("clientId")
                  ]
                }'),False ,True) or client_unsubscribes is null) and (if(contains(client_complaints, '${
                  cmpClientIdObject[
                    this.decryptLocal("clientId")
                  ]
                }'),false ,true) or client_complaints is null))) AND ` +
                this.decryptLocal("globalFilter") +
                " AND " +
                where +
                (clientIdArrayWithoutSuppressionCondition.includes(
                  this.decryptLocal("clientId")
                )
                  ? ""
                  : suppressionListCondition) +
                " GROUP BY 1";
            } else {
              // Non-Preclub channel
              fQS =
                "select CASE " +
                selectedRule +
                " ELSE 'Remainder' END segment, count(distinct(ca.cust_id)) count FROM " +
                this.decryptLocal("custDb") +
                ".cust_analytic ca LEFT JOIN " +
                this.decryptLocal("custDb") +
                ".client_intellibase ci ON ci.cust_id = ca.cust_id LEFT JOIN (SELECT * FROM (SELECT rank() OVER (partition by email_address, geo_concept ORDER BY em_match_level, cust_id) rank, * FROM " +
                this.decryptLocal("custDb") +
                ".owned_email ) WHERE rank = 1 ) oe ON oe.cust_id = ca.cust_id AND oe.geo_concept = ca.geo_concept LEFT JOIN " +
                this.decryptLocal("custDb") +
                ".eclub ec ON ec.cust_id = ca.cust_id AND ec.eclub_geo_concept = ca.geo_concept LEFT JOIN " +
                this.decryptLocal("custDb") +
                ".geo geo ON geo.geo_id = ca.geo_id_fav AND geo.geo_concept = ca.geo_concept LEFT JOIN " +
                this.decryptLocal("custDb") +
                ".loyalty lo ON lo.cust_id = ca.cust_id AND lo.geo_concept = ca.geo_concept LEFT JOIN " +
                this.decryptLocal("custDb").split("_")[0] +
                "_raw." +
                (this.decryptLocal("model") === "restaurant_v2"
                  ? "lists_preclub"
                  : "deliveries") +
                " li ON li.cust_id = ca.cust_id WHERE " +
                this.decryptLocal("globalFilter") +
                " AND " +
                where +
                (clientIdArrayWithoutSuppressionCondition.includes(
                  this.decryptLocal("clientId")
                )
                  ? ""
                  : suppressionListCondition) +
                " GROUP BY 1";
            }
          } else {
            if (
              this.decryptLocal("clientId") === "2bdbd6af-6cd3-4358-a1a0-437226a20ee9"
            ) {
              fQS =
                "select CASE " +
                selectedRule +
                " ELSE 'Remainder' END segment, count(distinct(ca.cust_id)) count FROM " +
                this.decryptLocal("custDb") +
                ".cust_analytic ca LEFT JOIN " +
                this.decryptLocal("custDb") +
                ".client_intellibase ci ON ci.cust_id = ca.cust_id LEFT JOIN (SELECT * FROM (SELECT rank() OVER (partition by email_address, geo_concept ORDER BY em_match_level, cust_id) rank, * FROM " +
                this.decryptLocal("custDb") +
                ".owned_email ) WHERE rank = 1 ) oe ON oe.cust_id = ca.cust_id AND oe.geo_concept = ca.geo_concept LEFT JOIN " +
                this.decryptLocal("custDb") +
                ".eclub ec ON ec.cust_id = ca.cust_id AND ec.eclub_geo_concept = ca.geo_concept LEFT JOIN " +
                this.decryptLocal("custDb") +
                ".geo geo ON geo.geo_id = ca.geo_id_fav AND geo.geo_concept = ca.geo_concept LEFT JOIN " +
                this.decryptLocal("custDb") +
                ".loyalty lo ON lo.cust_id = ca.cust_id AND lo.geo_concept = ca.geo_concept WHERE " +
                this.decryptLocal("globalFilter") +
                " AND " +
                where +
                " AND lo.email_address NOT IN (select email_address from goodwill_refined.dnc_list)" +
                suppressionListCondition +
                " GROUP BY 1";
            } else {
              if (
                this.decryptLocal("activeChannel") === "0905c46e-6f48-4ed8-b2a9-35dbbf3bae91"
              ) {
                fQS =
                  "select CASE " +
                  selectedRule +
                  " ELSE 'Remainder' END segment, count(distinct(ca.cust_id)) count FROM " +
                  this.decryptLocal("custDb") +
                  ".cust_analytic ca LEFT JOIN " +
                  this.decryptLocal("custDb") +
                  ".client_intellibase ci ON ci.cust_id = ca.cust_id LEFT JOIN (SELECT * FROM (SELECT rank() OVER (partition by email_address, geo_concept ORDER BY em_match_level, cust_id) rank, * FROM " +
                  this.decryptLocal("custDb") +
                  ".owned_email ) WHERE rank = 1 ) oe ON oe.cust_id = ca.cust_id AND oe.geo_concept = ca.geo_concept LEFT JOIN " +
                  this.decryptLocal("custDb") +
                  ".eclub ec ON ec.cust_id = ca.cust_id AND ec.eclub_geo_concept = ca.geo_concept LEFT JOIN " +
                  this.decryptLocal("custDb") +
                  ".geo geo ON geo.geo_id = ca.geo_id_fav AND geo.geo_concept = ca.geo_concept LEFT JOIN " +
                  this.decryptLocal("custDb") +
                  ".loyalty lo ON lo.cust_id = ca.cust_id AND lo.geo_concept = ca.geo_concept LEFT JOIN " +
                  ` cog_messages_curated.email_master_status ms ON oe.email_address = ms.email_address where (ca.global_control_flag = true or (final_reason['status'] = '1' and ca.global_control_flag = false and (if(contains(client_unsubscribes, '${
                    cmpClientIdObject[
                      this.decryptLocal("clientId")
                    ]
                  }'),False ,True) or client_unsubscribes is null) and (if(contains(client_complaints, '${
                    cmpClientIdObject[
                      this.decryptLocal("clientId")
                    ]
                  }'),false ,true) or client_complaints is null))) AND ` +
                  this.decryptLocal("globalFilter") +
                  " AND " +
                  where +
                  (clientIdArrayWithoutSuppressionCondition.includes(
                    this.decryptLocal("clientId")
                  )
                    ? ""
                    : suppressionListCondition) +
                  " GROUP BY 1";
              } else {
                // Non-Preclub
                fQS =
                  "select CASE " +
                  selectedRule +
                  " ELSE 'Remainder' END segment, count(distinct(ca.cust_id)) count FROM " +
                  this.decryptLocal("custDb") +
                  ".cust_analytic ca LEFT JOIN " +
                  this.decryptLocal("custDb") +
                  ".client_intellibase ci ON ci.cust_id = ca.cust_id LEFT JOIN (SELECT * FROM (SELECT rank() OVER (partition by email_address, geo_concept ORDER BY em_match_level, cust_id) rank, * FROM " +
                  this.decryptLocal("custDb") +
                  ".owned_email ) WHERE rank = 1 ) oe ON oe.cust_id = ca.cust_id AND oe.geo_concept = ca.geo_concept LEFT JOIN " +
                  this.decryptLocal("custDb") +
                  ".eclub ec ON ec.cust_id = ca.cust_id AND ec.eclub_geo_concept = ca.geo_concept LEFT JOIN " +
                  this.decryptLocal("custDb") +
                  ".geo geo ON geo.geo_id = ca.geo_id_fav AND geo.geo_concept = ca.geo_concept LEFT JOIN " +
                  this.decryptLocal("custDb") +
                  ".loyalty lo ON lo.cust_id = ca.cust_id AND lo.geo_concept = ca.geo_concept WHERE " +
                  this.decryptLocal("globalFilter") +
                  " AND " +
                  where +
                  (clientIdArrayWithoutSuppressionCondition.includes(
                    this.decryptLocal("clientId")
                  )
                    ? ""
                    : suppressionListCondition);
                (" GROUP BY 1");
              }
            }
          }
        }
      }
    } else if (selectedCustomerType === "Acquistion") {
      if (
        this.decryptLocal("clientId") === "3fe7e557-16f5-406c-bbc8-887fdec7ba8b"
      ) {
        // ColdStone
        if (
          this.decryptLocal("activeChannel") === "d977fc2b-2352-473b-9a54-b80765f0400c"
        ) {
          //Email Channel
          if (where == "") {
            fQS =
              "select CASE " +
              selectedRule +
              " ELSE 'Remainder' END segment, count(distinct(if(email_address is not null,mkey2))) as count FROM " +
              `coldstonecreamery_lookup.intellibase_household_refined_horiz_agg hh ` +
              " GROUP BY 1";
          } else {
            fQS =
              "select CASE " +
              selectedRule +
              " ELSE 'Remainder' END segment, count(distinct(if(email_address is not null,mkey2))) as count FROM " +
              `coldstonecreamery_lookup.intellibase_household_refined_horiz_agg hh ` +
              " WHERE " +
              where +
              " GROUP BY 1";
          }
        } else {
          // Display Channel
          if (where == "") {
            fQS =
              "select CASE " +
              selectedRule +
              " ELSE 'Remainder' END segment, count(distinct(mkey2)) as count FROM " +
              ` coldstonecreamery_lookup.intellibase_household_refined_horiz_agg hh ` +
              " GROUP BY 1";
          } else {
            fQS =
              "select CASE " +
              selectedRule +
              " ELSE 'Remainder' END segment, count(distinct(mkey2)) as count FROM " +
              ` coldstonecreamery_lookup.intellibase_household_refined_horiz_agg hh ` +
              " WHERE " +
              where +
              " GROUP BY 1";
          }
        }
      } else if (
        this.decryptLocal("clientId") === "8c001fde-3728-48dc-9950-b8480ca9fbee" ||
        this.decryptLocal("clientId") === "7203dd51-f88b-4a4b-877c-92326d027915" ||
        this.decryptLocal("clientId") === "f1fbce23-e2ef-463c-bc97-6cde3c4cc4ac" ||
        this.decryptLocal("clientId") === "874b6c6a-83ff-480b-b615-1972538813ba" ||
        this.decryptLocal("clientId") === "b76e7818-deb1-4526-93a7-b398df3ea357" ||
        this.decryptLocal("clientId") === "e08840c5-c7d0-48c7-9c24-124b4cd80735" || 
        this.decryptLocal("clientId") === "68a4d4cc-1e57-4ccf-9dd1-a5ae890d0f2e" ||
        this.decryptLocal("clientId") === "0bc2a383-9ae0-4e9e-9652-0fb762ba6119" ||
        this.decryptLocal("clientId") === "7bf99619-30a3-47a3-b1de-d72b4f7f99a7" ||
        this.decryptLocal("clientId") === "a4dda78e-7678-4aaf-9bef-60a229085fc8" ||
        this.decryptLocal("clientId") === "cf6144d2-bb68-43b6-9876-dbf620b57c21" ||
        this.decryptLocal("clientId") === "83da098f-2fc7-4b98-8455-c08f9aceb4ed" ||
        this.decryptLocal("clientId") === "37f97bea-f005-4be1-8e41-286ad79a7f3a" ||
        this.decryptLocal("clientId") === "ec5a162e-5e87-4819-93bd-70bbf3b5f096" ||
        this.decryptLocal("clientId") === "24ab940a-50d2-41fd-b3b2-c67ca6cb0304" ||
        this.decryptLocal("clientId") === "535a90f3-b463-4d5a-9a83-39c522589a6c" 
      ) {
        // BajaFresh
        if (
          this.decryptLocal("activeChannel") === "d977fc2b-2352-473b-9a54-b80765f0400c"
        ) {
          //Email Channel
          if (where == "") {
            fQS =
              "select CASE " +
              selectedRule +
              " ELSE 'Remainder' END segment, count(distinct(if(email_address is not null,mkey2))) as count FROM " +
              `bajafresh_lookup.intellibase_household_refined_horiz_agg hh ` +
              " GROUP BY 1";
          } else {
            fQS =
              "select CASE " +
              selectedRule +
              " ELSE 'Remainder' END segment, count(distinct(if(email_address is not null,mkey2))) as count FROM " +
              `bajafresh_lookup.intellibase_household_refined_horiz_agg hh ` +
              " WHERE " +
              where +
              " GROUP BY 1";
          }
        } else {
          if (where == "") {
            fQS =
              "select CASE " +
              selectedRule +
              " ELSE 'Remainder' END segment, count(distinct(mkey2)) as count FROM " +
              ` bajafresh_lookup.intellibase_household_refined_horiz_agg hh ` +
              " GROUP BY 1";
          } else {
            fQS =
              "select CASE " +
              selectedRule +
              " ELSE 'Remainder' END segment, count(distinct(mkey2)) as count FROM " +
              ` bajafresh_lookup.intellibase_household_refined_horiz_agg hh ` +
              " WHERE " +
              where +
              " GROUP BY 1";
          }
        }
      } else {
        if (
          this.decryptLocal("activeChannel") === "d977fc2b-2352-473b-9a54-b80765f0400c"
        ) {
          //Email Channel
          if (where == "") {
            fQS =
              "select CASE " +
              selectedRule +
              " ELSE 'Remainder' END segment, count(distinct(if(email_address is not null,mkey2))) as count FROM " +
              `loumalnatis_lookup.intellibase_household_refined_horiz_agg hh ` +
              " GROUP BY 1";
          } else {
            fQS =
              "select CASE " +
              selectedRule +
              " ELSE 'Remainder' END segment, count(distinct(if(email_address is not null,mkey2))) as count FROM " +
              `loumalnatis_lookup.intellibase_household_refined_horiz_agg hh ` +
              " WHERE " +
              where +
              " GROUP BY 1";
          }
        } else {
          // Lou Malnatis
          if (where == "") {
            fQS =
              "select CASE " +
              selectedRule +
              " ELSE 'Remainder' END segment, count(distinct(mkey2)) as count FROM " +
              ` loumalnatis_lookup.intellibase_household_refined_horiz_agg hh ` +
              " GROUP BY 1";
          } else {
            fQS =
              "select CASE " +
              selectedRule +
              " ELSE 'Remainder' END segment, count(distinct(mkey2)) as count FROM " +
              ` loumalnatis_lookup.intellibase_household_refined_horiz_agg hh ` +
              " WHERE " +
              where +
              " GROUP BY 1";
          }
        }
      }
    } else {
      // Combined Audience Type:
      // let clientName = "coldstonecreamery";
      // if (
      //   JSON.parse(
      //     CryptoJS.AES.decrypt(
      //       localStorage.getItem("clientId"),
      //       process.env.REACT_APP_PASS
      //     ).toString(CryptoJS.enc.Utf8)
      //   ) === "8c001fde-3728-48dc-9950-b8480ca9fbee" ||
      //   JSON.parse(
      //     CryptoJS.AES.decrypt(
      //       localStorage.getItem("clientId"),
      //       process.env.REACT_APP_PASS
      //     ).toString(CryptoJS.enc.Utf8)
      //   ) === "3fe7e557-16f5-406c-bbc8-887fdec7ba8b"
      // ) {
      //   // ("KAHALA CLIENT");
      //   {
      //     if (
      //       JSON.parse(
      //         CryptoJS.AES.decrypt(
      //           localStorage.getItem("clientId"),
      //           process.env.REACT_APP_PASS
      //         ).toString(CryptoJS.enc.Utf8)
      //       ) === "8c001fde-3728-48dc-9950-b8480ca9fbee"
      //     ) {
      //       clientName = "bajafresh";
      //     } else {
      //       clientName = "coldstonecreamery";
      //     }
      //     let splittedSelectedRule = selectedRule.split("WHEN");
      //     if (selectedRule !== "") {
      //       splittedSelectedRule.forEach((element) => {
      //         if (element.includes("hh.")) {
      //           if (prospectSelectedRule === "") {
      //             prospectSelectedRule += element;
      //           } else {
      //             prospectSelectedRule += "WHEN " + element;
      //           }
      //         } else {
      //           if (customerSelectedRule === "") {
      //             customerSelectedRule += element;
      //           } else {
      //             customerSelectedRule += "WHEN " + element;
      //           }
      //         }
      //       });
      //     }
      //     let splittedSelectedRuleFilter = where.split("AND");
      //     let prospectWhere = "";
      //     let customerWhere = "";
      //     if (where !== "") {
      //       splittedSelectedRuleFilter.forEach((element) => {
      //         if (element.includes("hh.")) {
      //           prospectWhere += " AND " + element;
      //         } else {
      //           customerWhere += " AND " + element;
      //         }
      //       });
      //     }
      //     if (prospectSelectedRule === "" && customerSelectedRule !== "") {
      //       // alert("ProspectÎ Empty");
      //       fQS = `select segment,
      //       sum(count) count
      //     from (
      //         select 'Prospect' as segment,
      //           count(distinct(hh.cac_hh_pid)) count
      //         from ${clientName}_lookup.intellibase_household_refined_horiz_agg hh
      //         where mkey2 not in (
      //             select name_addr_key
      //             from ${clientName}_refined.client_name_addr
      //           )
      //         ${prospectWhere !== "" ? prospectWhere : ""}
      //         GROUP BY 1
      //         union all
      //         select CASE WHEN ${customerSelectedRule}
      //           ELSE 'Customer Remainder' END segment,
      //           count(distinct(ci.cac_hh_pid)) count
      //         FROM ${clientName}_refined.cust_analytic ca
      //           LEFT JOIN ${clientName}_refined.client_intellibase ci ON ci.cust_id = ca.cust_id
      //           LEFT JOIN (
      //             SELECT *
      //             FROM (
      //                 SELECT rank() OVER (
      //                     partition by email_address,
      //                     geo_concept
      //                     ORDER BY em_match_level,
      //                       cust_id
      //                   ) rank,
      //                   *
      //                 FROM ${clientName}_refined.owned_email
      //               )
      //             WHERE rank = 1
      //           ) oe ON oe.cust_id = ca.cust_id
      //           AND oe.geo_concept = ca.geo_concept
      //           LEFT JOIN ${clientName}_refined.eclub ec ON ec.cust_id = ca.cust_id
      //           AND ec.eclub_geo_concept = ca.geo_concept
      //           LEFT JOIN ${clientName}_refined.geo geo ON geo.geo_id = ca.geo_id_fav
      //           AND geo.geo_concept = ca.geo_concept
      //           LEFT JOIN ${clientName}_refined.loyalty lo ON lo.cust_id = ca.cust_id
      //           AND lo.geo_concept = ca.geo_concept
      //           ${customerWhere !== "" ? customerWhere : ""}
      //         GROUP BY 1
      //       )
      //     group by 1`;
      //     } else if (
      //       prospectSelectedRule !== "" &&
      //       customerSelectedRule === ""
      //     ) {
      //       // alert("Customer Empty");
      //       fQS = `select segment,
      //       sum(count) count
      //     from (
      //       select CASE WHEN ${prospectSelectedRule}
      //       ELSE 'Prospect Remainder' END segment,
      //           count(distinct(hh.cac_hh_pid)) count
      //         from ${clientName}_lookup.intellibase_household_refined_horiz_agg hh
      //         where mkey2 not in (
      //             select name_addr_key
      //             from ${clientName}_refined.client_name_addr
      //           )
      //         ${prospectWhere !== "" ? prospectWhere : ""}
      //         GROUP BY 1
      //         union all
      //         select 'Customer' as segment,
      //           count(distinct(ci.cac_hh_pid)) count
      //         FROM ${clientName}_refined.cust_analytic ca
      //           LEFT JOIN ${clientName}_refined.client_intellibase ci ON ci.cust_id = ca.cust_id
      //           LEFT JOIN (
      //             SELECT *
      //             FROM (
      //                 SELECT rank() OVER (
      //                     partition by email_address,
      //                     geo_concept
      //                     ORDER BY em_match_level,
      //                       cust_id
      //                   ) rank,
      //                   *
      //                 FROM ${clientName}_refined.owned_email
      //               )
      //             WHERE rank = 1
      //           ) oe ON oe.cust_id = ca.cust_id
      //           AND oe.geo_concept = ca.geo_concept
      //           LEFT JOIN ${clientName}_refined.eclub ec ON ec.cust_id = ca.cust_id
      //           AND ec.eclub_geo_concept = ca.geo_concept
      //           LEFT JOIN ${clientName}_refined.geo geo ON geo.geo_id = ca.geo_id_fav
      //           AND geo.geo_concept = ca.geo_concept
      //           LEFT JOIN ${clientName}_refined.loyalty lo ON lo.cust_id = ca.cust_id
      //           AND lo.geo_concept = ca.geo_concept
      //           ${customerWhere !== "" ? customerWhere : ""}
      //         GROUP BY 1
      //       )
      //     group by 1`;
      //     } else {
      //       // alert("Both present");
      //       fQS = `select segment,
      //       sum(count) count
      //     from (
      //       select CASE WHEN ${prospectSelectedRule}
      //       ELSE 'Prospect Remainder' END segment,
      //           count(distinct(hh.cac_hh_pid)) count
      //         from ${clientName}_lookup.intellibase_household_refined_horiz_agg hh
      //         where mkey2 not in (
      //             select name_addr_key
      //             from ${clientName}_refined.client_name_addr
      //           )
      //           ${prospectWhere !== "" ? prospectWhere : ""}
      //         GROUP BY 1
      //         union all
      //         select CASE WHEN ${customerSelectedRule}
      //           ELSE 'Customer Remainder' END segment,
      //           count(distinct(ci.cac_hh_pid)) count
      //         FROM ${clientName}_refined.cust_analytic ca
      //           LEFT JOIN ${clientName}_refined.client_intellibase ci ON ci.cust_id = ca.cust_id
      //           LEFT JOIN (
      //             SELECT *
      //             FROM (
      //                 SELECT rank() OVER (
      //                     partition by email_address,
      //                     geo_concept
      //                     ORDER BY em_match_level,
      //                       cust_id
      //                   ) rank,
      //                   *
      //                 FROM ${clientName}_refined.owned_email
      //               )
      //             WHERE rank = 1
      //           ) oe ON oe.cust_id = ca.cust_id
      //           AND oe.geo_concept = ca.geo_concept
      //           LEFT JOIN ${clientName}_refined.eclub ec ON ec.cust_id = ca.cust_id
      //           AND ec.eclub_geo_concept = ca.geo_concept
      //           LEFT JOIN ${clientName}_refined.geo geo ON geo.geo_id = ca.geo_id_fav
      //           AND geo.geo_concept = ca.geo_concept
      //           LEFT JOIN ${clientName}_refined.loyalty lo ON lo.cust_id = ca.cust_id
      //           AND lo.geo_concept = ca.geo_concept
      //           ${customerWhere !== "" ? customerWhere : ""}
      //         GROUP BY 1
      //       )
      //     group by 1`;
      //     }
      //   }
      // }
    }

    // if (where == "") {
    //   if (
    //     this.state.localStorageClientId ===
    //     "2bdbd6af-6cd3-4358-a1a0-437226a20ee9"
    //   ) {
    //     fQS =
    //       "select CASE " +
    //       selectedRule +
    //       " ELSE 'Remainder' END segment, count(distinct(ca.cust_id)) count FROM " +
    //       JSON.parse(
    //         CryptoJS.AES.decrypt(
    //           localStorage.getItem("custDb"),
    //           process.env.REACT_APP_PASS
    //         ).toString(CryptoJS.enc.Utf8)
    //       ) +
    //       ".cust_analytic ca LEFT JOIN " +
    //       JSON.parse(
    //         CryptoJS.AES.decrypt(
    //           localStorage.getItem("custDb"),
    //           process.env.REACT_APP_PASS
    //         ).toString(CryptoJS.enc.Utf8)
    //       ) +
    //       ".client_intellibase ci ON ci.cust_id = ca.cust_id LEFT JOIN (SELECT * FROM (SELECT rank() OVER (partition by email_address, geo_concept ORDER BY em_match_level, cust_id) rank, * FROM " +
    //       JSON.parse(
    //         CryptoJS.AES.decrypt(
    //           localStorage.getItem("custDb"),
    //           process.env.REACT_APP_PASS
    //         ).toString(CryptoJS.enc.Utf8)
    //       ) +
    //       ".owned_email ) WHERE rank = 1 ) oe ON oe.cust_id = ca.cust_id AND oe.geo_concept = ca.geo_concept LEFT JOIN " +
    //       JSON.parse(
    //         CryptoJS.AES.decrypt(
    //           localStorage.getItem("custDb"),
    //           process.env.REACT_APP_PASS
    //         ).toString(CryptoJS.enc.Utf8)
    //       ) +
    //       ".eclub ec ON ec.cust_id = ca.cust_id AND ec.eclub_geo_concept = ca.geo_concept LEFT JOIN " +
    //       JSON.parse(
    //         CryptoJS.AES.decrypt(
    //           localStorage.getItem("custDb"),
    //           process.env.REACT_APP_PASS
    //         ).toString(CryptoJS.enc.Utf8)
    //       ) +
    //       ".geo geo ON geo.geo_id = ca.geo_id_fav AND geo.geo_concept = ca.geo_concept LEFT JOIN " +
    //       JSON.parse(
    //         CryptoJS.AES.decrypt(
    //           localStorage.getItem("custDb"),
    //           process.env.REACT_APP_PASS
    //         ).toString(CryptoJS.enc.Utf8)
    //       ) +
    //       ".loyalty lo ON lo.cust_id = ca.cust_id AND lo.geo_concept = ca.geo_concept WHERE " +
    //       JSON.parse(
    //         CryptoJS.AES.decrypt(
    //           localStorage.getItem("globalFilter"),
    //           process.env.REACT_APP_PASS
    //         ).toString(CryptoJS.enc.Utf8)
    //       ) +
    //       " AND lo.email_address NOT IN (select email_address from goodwill_refined.dnc_list)" +
    //       " GROUP BY 1";
    //   } else {
    //     if (
    //       this.state.localStorageClientId ===
    //         "712cc8e9-3a79-4900-b122-ec9812e0f0ca" &&
    //       JSON.parse(
    //         CryptoJS.AES.decrypt(
    //           localStorage.getItem("activeChannel"),
    //           process.env.REACT_APP_PASS
    //         ).toString(CryptoJS.enc.Utf8)
    //       ) === "8905c46e-6f48-4ed8-b2a9-35dbbf3bae91"
    //     ) {
    //       // alert("Friday's OLO Channel");
    //       fQS =
    //         "select CASE " +
    //         selectedRule +
    //         " ELSE 'Remainder' END segment, count(distinct(ca.cust_id)) count FROM " +
    //         JSON.parse(
    //           CryptoJS.AES.decrypt(
    //             localStorage.getItem("custDb"),
    //             process.env.REACT_APP_PASS
    //           ).toString(CryptoJS.enc.Utf8)
    //         ) +
    //         ".cust_analytic ca LEFT JOIN " +
    //         JSON.parse(
    //           CryptoJS.AES.decrypt(
    //             localStorage.getItem("custDb"),
    //             process.env.REACT_APP_PASS
    //           ).toString(CryptoJS.enc.Utf8)
    //         ) +
    //         ".client_intellibase ci ON ci.cust_id = ca.cust_id LEFT JOIN (SELECT * FROM (SELECT rank() OVER (partition by email_address, geo_concept ORDER BY em_match_level, cust_id) rank, * FROM " +
    //         JSON.parse(
    //           CryptoJS.AES.decrypt(
    //             localStorage.getItem("custDb"),
    //             process.env.REACT_APP_PASS
    //           ).toString(CryptoJS.enc.Utf8)
    //         ) +
    //         ".owned_email ) WHERE rank = 1 ) oe ON oe.cust_id = ca.cust_id AND oe.geo_concept = ca.geo_concept LEFT JOIN " +
    //         JSON.parse(
    //           CryptoJS.AES.decrypt(
    //             localStorage.getItem("custDb"),
    //             process.env.REACT_APP_PASS
    //           ).toString(CryptoJS.enc.Utf8)
    //         ) +
    //         ".eclub ec ON ec.cust_id = ca.cust_id AND ec.eclub_geo_concept = ca.geo_concept LEFT JOIN " +
    //         JSON.parse(
    //           CryptoJS.AES.decrypt(
    //             localStorage.getItem("custDb"),
    //             process.env.REACT_APP_PASS
    //           ).toString(CryptoJS.enc.Utf8)
    //         ) +
    //         ".geo geo ON geo.geo_id = ca.geo_id_fav AND geo.geo_concept = ca.geo_concept LEFT JOIN " +
    //         JSON.parse(
    //           CryptoJS.AES.decrypt(
    //             localStorage.getItem("custDb"),
    //             process.env.REACT_APP_PASS
    //           ).toString(CryptoJS.enc.Utf8)
    //         ) +
    //         ".olo_customer oc on oc.cust_id = ca.cust_id LEFT JOIN " +
    //         JSON.parse(
    //           CryptoJS.AES.decrypt(
    //             localStorage.getItem("custDb"),
    //             process.env.REACT_APP_PASS
    //           ).toString(CryptoJS.enc.Utf8)
    //         ) +
    //         ".loyalty lo ON lo.cust_id = ca.cust_id AND lo.geo_concept = ca.geo_concept WHERE " +
    //         JSON.parse(
    //           CryptoJS.AES.decrypt(
    //             localStorage.getItem("globalFilter"),
    //             process.env.REACT_APP_PASS
    //           ).toString(CryptoJS.enc.Utf8)
    //         ) +
    //         " AND (oc.email_address not in (select distinct email from fridays_refined.cheetah_events where event_type = 'unsubscribe'))" +
    //         // " AND ca.olo = true AND ca.loyalty = false " +
    //         " GROUP BY 1";
    //     } else if (
    //       this.state.localStorageClientId ===
    //         "712cc8e9-3a79-4900-b122-ec9812e0f0ca" &&
    //       JSON.parse(
    //         CryptoJS.AES.decrypt(
    //           localStorage.getItem("activeChannel"),
    //           process.env.REACT_APP_PASS
    //         ).toString(CryptoJS.enc.Utf8)
    //       ) === "g786cb0f-eecc-4b87-adef-34eb20f3f766"
    //     ) {
    //       // alert("Friday's Loyalty Channel");
    //       fQS =
    //         "select CASE " +
    //         selectedRule +
    //         " ELSE 'Remainder' END segment, count(distinct(ca.cust_id)) count FROM " +
    //         JSON.parse(
    //           CryptoJS.AES.decrypt(
    //             localStorage.getItem("custDb"),
    //             process.env.REACT_APP_PASS
    //           ).toString(CryptoJS.enc.Utf8)
    //         ) +
    //         ".cust_analytic ca LEFT JOIN " +
    //         JSON.parse(
    //           CryptoJS.AES.decrypt(
    //             localStorage.getItem("custDb"),
    //             process.env.REACT_APP_PASS
    //           ).toString(CryptoJS.enc.Utf8)
    //         ) +
    //         ".client_intellibase ci ON ci.cust_id = ca.cust_id LEFT JOIN (SELECT * FROM (SELECT rank() OVER (partition by email_address, geo_concept ORDER BY em_match_level, cust_id) rank, * FROM " +
    //         JSON.parse(
    //           CryptoJS.AES.decrypt(
    //             localStorage.getItem("custDb"),
    //             process.env.REACT_APP_PASS
    //           ).toString(CryptoJS.enc.Utf8)
    //         ) +
    //         ".owned_email ) WHERE rank = 1 ) oe ON oe.cust_id = ca.cust_id AND oe.geo_concept = ca.geo_concept LEFT JOIN " +
    //         JSON.parse(
    //           CryptoJS.AES.decrypt(
    //             localStorage.getItem("custDb"),
    //             process.env.REACT_APP_PASS
    //           ).toString(CryptoJS.enc.Utf8)
    //         ) +
    //         ".eclub ec ON ec.cust_id = ca.cust_id AND ec.eclub_geo_concept = ca.geo_concept LEFT JOIN " +
    //         JSON.parse(
    //           CryptoJS.AES.decrypt(
    //             localStorage.getItem("custDb"),
    //             process.env.REACT_APP_PASS
    //           ).toString(CryptoJS.enc.Utf8)
    //         ) +
    //         ".geo geo ON geo.geo_id = ca.geo_id_fav AND geo.geo_concept = ca.geo_concept LEFT JOIN " +
    //         JSON.parse(
    //           CryptoJS.AES.decrypt(
    //             localStorage.getItem("custDb"),
    //             process.env.REACT_APP_PASS
    //           ).toString(CryptoJS.enc.Utf8)
    //         ) +
    //         ".olo_customer oc on oc.cust_id = ca.cust_id LEFT JOIN " +
    //         JSON.parse(
    //           CryptoJS.AES.decrypt(
    //             localStorage.getItem("custDb"),
    //             process.env.REACT_APP_PASS
    //           ).toString(CryptoJS.enc.Utf8)
    //         ) +
    //         ".loyalty lo ON lo.cust_id = ca.cust_id AND lo.geo_concept = ca.geo_concept WHERE " +
    //         JSON.parse(
    //           CryptoJS.AES.decrypt(
    //             localStorage.getItem("globalFilter"),
    //             process.env.REACT_APP_PASS
    //           ).toString(CryptoJS.enc.Utf8)
    //         ) +
    //         " AND (lo.email_address not in (select distinct email from fridays_refined.cheetah_events where event_type = 'unsubscribe'))" +
    //         // " AND ca.olo = true AND ca.loyalty = false " +
    //         " GROUP BY 1";
    //     } else {
    //       if (
    //         this.state.localStorageClientId ===
    //           "dc0df8ce-c87e-4746-a00e-d2c9ee4d7534" ||
    //         this.state.localStorageClientId ===
    //           "f0d3b19b-a564-43e9-85dd-bd95f8b13f97"
    //       ) {
    //         fQS =
    //           "select CASE " +
    //           selectedRule +
    //           " ELSE 'Remainder' END segment, count(distinct(ca.cust_id)) count FROM " +
    //           JSON.parse(
    //             CryptoJS.AES.decrypt(
    //               localStorage.getItem("custDb"),
    //               process.env.REACT_APP_PASS
    //             ).toString(CryptoJS.enc.Utf8)
    //           ) +
    //           ".cust_analytic ca LEFT JOIN " +
    //           JSON.parse(
    //             CryptoJS.AES.decrypt(
    //               localStorage.getItem("custDb"),
    //               process.env.REACT_APP_PASS
    //             ).toString(CryptoJS.enc.Utf8)
    //           ) +
    //           ".client_intellibase ci ON ci.cust_id = ca.cust_id LEFT JOIN (SELECT * FROM (SELECT rank() OVER (partition by email_address, geo_concept ORDER BY em_match_level, cust_id) rank, * FROM " +
    //           JSON.parse(
    //             CryptoJS.AES.decrypt(
    //               localStorage.getItem("custDb"),
    //               process.env.REACT_APP_PASS
    //             ).toString(CryptoJS.enc.Utf8)
    //           ) +
    //           ".owned_email ) WHERE rank = 1 ) oe ON oe.cust_id = ca.cust_id AND oe.geo_concept = ca.geo_concept LEFT JOIN " +
    //           JSON.parse(
    //             CryptoJS.AES.decrypt(
    //               localStorage.getItem("custDb"),
    //               process.env.REACT_APP_PASS
    //             ).toString(CryptoJS.enc.Utf8)
    //           ) +
    //           ".eclub ec ON ec.cust_id = ca.cust_id AND ec.eclub_geo_concept = ca.geo_concept LEFT JOIN " +
    //           JSON.parse(
    //             CryptoJS.AES.decrypt(
    //               localStorage.getItem("custDb"),
    //               process.env.REACT_APP_PASS
    //             ).toString(CryptoJS.enc.Utf8)
    //           ) +
    //           ".geo geo ON geo.geo_id = ca.geo_id_fav AND geo.geo_concept = ca.geo_concept LEFT JOIN " +
    //           JSON.parse(
    //             CryptoJS.AES.decrypt(
    //               localStorage.getItem("custDb"),
    //               process.env.REACT_APP_PASS
    //             ).toString(CryptoJS.enc.Utf8)
    //           ) +
    //           ".loyalty lo ON lo.cust_id = ca.cust_id AND lo.geo_concept = ca.geo_concept AND (ec.email_address_hh = lo.email_address_hh OR ec.name_addr_key = lo.name_addr_key OR ec.phone_home = lo.loyalty_phone_home OR ec.phone_mobile = lo.loyalty_phone_mobile) WHERE " +
    //           JSON.parse(
    //             CryptoJS.AES.decrypt(
    //               localStorage.getItem("globalFilter"),
    //               process.env.REACT_APP_PASS
    //             ).toString(CryptoJS.enc.Utf8)
    //           ) +
    //           " GROUP BY 1";
    //       } else {
    //         fQS =
    //           "select CASE " +
    //           selectedRule +
    //           " ELSE 'Remainder' END segment, count(distinct(ca.cust_id)) count FROM " +
    //           JSON.parse(
    //             CryptoJS.AES.decrypt(
    //               localStorage.getItem("custDb"),
    //               process.env.REACT_APP_PASS
    //             ).toString(CryptoJS.enc.Utf8)
    //           ) +
    //           ".cust_analytic ca LEFT JOIN " +
    //           JSON.parse(
    //             CryptoJS.AES.decrypt(
    //               localStorage.getItem("custDb"),
    //               process.env.REACT_APP_PASS
    //             ).toString(CryptoJS.enc.Utf8)
    //           ) +
    //           ".client_intellibase ci ON ci.cust_id = ca.cust_id LEFT JOIN (SELECT * FROM (SELECT rank() OVER (partition by email_address, geo_concept ORDER BY em_match_level, cust_id) rank, * FROM " +
    //           JSON.parse(
    //             CryptoJS.AES.decrypt(
    //               localStorage.getItem("custDb"),
    //               process.env.REACT_APP_PASS
    //             ).toString(CryptoJS.enc.Utf8)
    //           ) +
    //           ".owned_email ) WHERE rank = 1 ) oe ON oe.cust_id = ca.cust_id AND oe.geo_concept = ca.geo_concept LEFT JOIN " +
    //           JSON.parse(
    //             CryptoJS.AES.decrypt(
    //               localStorage.getItem("custDb"),
    //               process.env.REACT_APP_PASS
    //             ).toString(CryptoJS.enc.Utf8)
    //           ) +
    //           ".eclub ec ON ec.cust_id = ca.cust_id AND ec.eclub_geo_concept = ca.geo_concept LEFT JOIN " +
    //           JSON.parse(
    //             CryptoJS.AES.decrypt(
    //               localStorage.getItem("custDb"),
    //               process.env.REACT_APP_PASS
    //             ).toString(CryptoJS.enc.Utf8)
    //           ) +
    //           ".geo geo ON geo.geo_id = ca.geo_id_fav AND geo.geo_concept = ca.geo_concept LEFT JOIN " +
    //           JSON.parse(
    //             CryptoJS.AES.decrypt(
    //               localStorage.getItem("custDb"),
    //               process.env.REACT_APP_PASS
    //             ).toString(CryptoJS.enc.Utf8)
    //           ) +
    //           ".loyalty lo ON lo.cust_id = ca.cust_id AND lo.geo_concept = ca.geo_concept WHERE " +
    //           JSON.parse(
    //             CryptoJS.AES.decrypt(
    //               localStorage.getItem("globalFilter"),
    //               process.env.REACT_APP_PASS
    //             ).toString(CryptoJS.enc.Utf8)
    //           ) +
    //           " GROUP BY 1";
    //       }
    //     }
    //   }
    //   //fQS = "select case " + selectedRule + " else 'remainder' end segment, count_if(ca.eclub) eclub_count, count_if(ca.preclub) preclub_count, count_if(if(ca.eclub or ca.preclub,true,false)) email_count, count(distinct(ci.cust_id)) dm_count from " + JSON.parse(CryptoJS.AES.decrypt(localStorage.getItem('custDb'),'secretpass').toString(CryptoJS.enc.Utf8)) + " .cust_analytic ca left join " + JSON.parse(CryptoJS.AES.decrypt(localStorage.getItem('custDb'),'secretpass').toString(CryptoJS.enc.Utf8)) + " .client_intellibase ci on ca.cust_id = ci.cust_id where " + JSON.parse(CryptoJS.AES.decrypt(localStorage.getItem('globalFilter'),'secretpass').toString(CryptoJS.enc.Utf8)) + " and " + where + " group by 1";
    //   /*fQS =
    //     "SELECT segment, count(*) as count from (SELECT CASE " +
    //     selectedRule +
    //     "ELSE 'Remainder' END AS segment FROM " + process.env.REACT_APP_ATHENA_TABLE + " WHERE cac_addr_state='IN' ) GROUP BY segment";*/
    // } else {
    //   if (where.includes("li.")) {
    //     fQS =
    //       "select CASE " +
    //       selectedRule +
    //       " ELSE 'Remainder' END segment, count(distinct(ca.cust_id)) count FROM " +
    //       JSON.parse(
    //         CryptoJS.AES.decrypt(
    //           localStorage.getItem("custDb"),
    //           process.env.REACT_APP_PASS
    //         ).toString(CryptoJS.enc.Utf8)
    //       ) +
    //       ".cust_analytic ca LEFT JOIN " +
    //       JSON.parse(
    //         CryptoJS.AES.decrypt(
    //           localStorage.getItem("custDb"),
    //           process.env.REACT_APP_PASS
    //         ).toString(CryptoJS.enc.Utf8)
    //       ) +
    //       ".client_intellibase ci ON ci.cust_id = ca.cust_id LEFT JOIN (SELECT * FROM (SELECT rank() OVER (partition by email_address, geo_concept ORDER BY em_match_level, cust_id) rank, * FROM " +
    //       JSON.parse(
    //         CryptoJS.AES.decrypt(
    //           localStorage.getItem("custDb"),
    //           process.env.REACT_APP_PASS
    //         ).toString(CryptoJS.enc.Utf8)
    //       ) +
    //       ".owned_email ) WHERE rank = 1 ) oe ON oe.cust_id = ca.cust_id AND oe.geo_concept = ca.geo_concept LEFT JOIN " +
    //       JSON.parse(
    //         CryptoJS.AES.decrypt(
    //           localStorage.getItem("custDb"),
    //           process.env.REACT_APP_PASS
    //         ).toString(CryptoJS.enc.Utf8)
    //       ) +
    //       ".eclub ec ON ec.cust_id = ca.cust_id AND ec.eclub_geo_concept = ca.geo_concept LEFT JOIN " +
    //       JSON.parse(
    //         CryptoJS.AES.decrypt(
    //           localStorage.getItem("custDb"),
    //           process.env.REACT_APP_PASS
    //         ).toString(CryptoJS.enc.Utf8)
    //       ) +
    //       ".geo geo ON geo.geo_id = ca.geo_id_fav AND geo.geo_concept = ca.geo_concept LEFT JOIN " +
    //       JSON.parse(
    //         CryptoJS.AES.decrypt(
    //           localStorage.getItem("custDb"),
    //           process.env.REACT_APP_PASS
    //         ).toString(CryptoJS.enc.Utf8)
    //       ) +
    //       ".loyalty lo ON lo.cust_id = ca.cust_id AND lo.geo_concept = ca.geo_concept LEFT JOIN " +
    //       JSON.parse(
    //         CryptoJS.AES.decrypt(
    //           localStorage.getItem("custDb"),
    //           process.env.REACT_APP_PASS
    //         ).toString(CryptoJS.enc.Utf8)
    //       ).split("_")[0] +
    //       "_raw." +
    //       (JSON.parse(
    //         CryptoJS.AES.decrypt(
    //           localStorage.getItem("model"),
    //           process.env.REACT_APP_PASS
    //         ).toString(CryptoJS.enc.Utf8)
    //       ) === "restaurant_v2"
    //         ? "lists_preclub"
    //         : "deliveries") +
    //       " li ON li.cust_id = ca.cust_id WHERE " +
    //       JSON.parse(
    //         CryptoJS.AES.decrypt(
    //           localStorage.getItem("globalFilter"),
    //           process.env.REACT_APP_PASS
    //         ).toString(CryptoJS.enc.Utf8)
    //       ) +
    //       " AND " +
    //       where +
    //       " GROUP BY 1";
    //   } else {
    //     if (
    //       this.state.localStorageClientId ===
    //       "2bdbd6af-6cd3-4358-a1a0-437226a20ee9"
    //     ) {
    //       fQS =
    //         "select CASE " +
    //         selectedRule +
    //         " ELSE 'Remainder' END segment, count(distinct(ca.cust_id)) count FROM " +
    //         JSON.parse(
    //           CryptoJS.AES.decrypt(
    //             localStorage.getItem("custDb"),
    //             process.env.REACT_APP_PASS
    //           ).toString(CryptoJS.enc.Utf8)
    //         ) +
    //         ".cust_analytic ca LEFT JOIN " +
    //         JSON.parse(
    //           CryptoJS.AES.decrypt(
    //             localStorage.getItem("custDb"),
    //             process.env.REACT_APP_PASS
    //           ).toString(CryptoJS.enc.Utf8)
    //         ) +
    //         ".client_intellibase ci ON ci.cust_id = ca.cust_id LEFT JOIN (SELECT * FROM (SELECT rank() OVER (partition by email_address, geo_concept ORDER BY em_match_level, cust_id) rank, * FROM " +
    //         JSON.parse(
    //           CryptoJS.AES.decrypt(
    //             localStorage.getItem("custDb"),
    //             process.env.REACT_APP_PASS
    //           ).toString(CryptoJS.enc.Utf8)
    //         ) +
    //         ".owned_email ) WHERE rank = 1 ) oe ON oe.cust_id = ca.cust_id AND oe.geo_concept = ca.geo_concept LEFT JOIN " +
    //         JSON.parse(
    //           CryptoJS.AES.decrypt(
    //             localStorage.getItem("custDb"),
    //             process.env.REACT_APP_PASS
    //           ).toString(CryptoJS.enc.Utf8)
    //         ) +
    //         ".eclub ec ON ec.cust_id = ca.cust_id AND ec.eclub_geo_concept = ca.geo_concept LEFT JOIN " +
    //         JSON.parse(
    //           CryptoJS.AES.decrypt(
    //             localStorage.getItem("custDb"),
    //             process.env.REACT_APP_PASS
    //           ).toString(CryptoJS.enc.Utf8)
    //         ) +
    //         ".geo geo ON geo.geo_id = ca.geo_id_fav AND geo.geo_concept = ca.geo_concept LEFT JOIN " +
    //         JSON.parse(
    //           CryptoJS.AES.decrypt(
    //             localStorage.getItem("custDb"),
    //             process.env.REACT_APP_PASS
    //           ).toString(CryptoJS.enc.Utf8)
    //         ) +
    //         ".loyalty lo ON lo.cust_id = ca.cust_id AND lo.geo_concept = ca.geo_concept WHERE " +
    //         JSON.parse(
    //           CryptoJS.AES.decrypt(
    //             localStorage.getItem("globalFilter"),
    //             process.env.REACT_APP_PASS
    //           ).toString(CryptoJS.enc.Utf8)
    //         ) +
    //         " AND " +
    //         where +
    //         " AND lo.email_address NOT IN (select email_address from goodwill_refined.dnc_list)" +
    //         " GROUP BY 1";
    //     } else {
    //       if (
    //         this.state.localStorageClientId ===
    //           "712cc8e9-3a79-4900-b122-ec9812e0f0ca" &&
    //         JSON.parse(
    //           CryptoJS.AES.decrypt(
    //             localStorage.getItem("activeChannel"),
    //             process.env.REACT_APP_PASS
    //           ).toString(CryptoJS.enc.Utf8)
    //         ) === "8905c46e-6f48-4ed8-b2a9-35dbbf3bae91"
    //       ) {
    //         fQS =
    //           "select CASE " +
    //           selectedRule +
    //           " ELSE 'Remainder' END segment, count(distinct(ca.cust_id)) count FROM " +
    //           JSON.parse(
    //             CryptoJS.AES.decrypt(
    //               localStorage.getItem("custDb"),
    //               process.env.REACT_APP_PASS
    //             ).toString(CryptoJS.enc.Utf8)
    //           ) +
    //           ".cust_analytic ca LEFT JOIN " +
    //           JSON.parse(
    //             CryptoJS.AES.decrypt(
    //               localStorage.getItem("custDb"),
    //               process.env.REACT_APP_PASS
    //             ).toString(CryptoJS.enc.Utf8)
    //           ) +
    //           ".client_intellibase ci ON ci.cust_id = ca.cust_id LEFT JOIN (SELECT * FROM (SELECT rank() OVER (partition by email_address, geo_concept ORDER BY em_match_level, cust_id) rank, * FROM " +
    //           JSON.parse(
    //             CryptoJS.AES.decrypt(
    //               localStorage.getItem("custDb"),
    //               process.env.REACT_APP_PASS
    //             ).toString(CryptoJS.enc.Utf8)
    //           ) +
    //           ".owned_email ) WHERE rank = 1 ) oe ON oe.cust_id = ca.cust_id AND oe.geo_concept = ca.geo_concept LEFT JOIN " +
    //           JSON.parse(
    //             CryptoJS.AES.decrypt(
    //               localStorage.getItem("custDb"),
    //               process.env.REACT_APP_PASS
    //             ).toString(CryptoJS.enc.Utf8)
    //           ) +
    //           ".eclub ec ON ec.cust_id = ca.cust_id AND ec.eclub_geo_concept = ca.geo_concept LEFT JOIN " +
    //           JSON.parse(
    //             CryptoJS.AES.decrypt(
    //               localStorage.getItem("custDb"),
    //               process.env.REACT_APP_PASS
    //             ).toString(CryptoJS.enc.Utf8)
    //           ) +
    //           ".geo geo ON geo.geo_id = ca.geo_id_fav AND geo.geo_concept = ca.geo_concept LEFT JOIN " +
    //           JSON.parse(
    //             CryptoJS.AES.decrypt(
    //               localStorage.getItem("custDb"),
    //               process.env.REACT_APP_PASS
    //             ).toString(CryptoJS.enc.Utf8)
    //           ) +
    //           ".olo_customer oc on oc.cust_id = ca.cust_id LEFT JOIN " +
    //           JSON.parse(
    //             CryptoJS.AES.decrypt(
    //               localStorage.getItem("custDb"),
    //               process.env.REACT_APP_PASS
    //             ).toString(CryptoJS.enc.Utf8)
    //           ) +
    //           ".loyalty lo ON lo.cust_id = ca.cust_id AND lo.geo_concept = ca.geo_concept WHERE " +
    //           JSON.parse(
    //             CryptoJS.AES.decrypt(
    //               localStorage.getItem("globalFilter"),
    //               process.env.REACT_APP_PASS
    //             ).toString(CryptoJS.enc.Utf8)
    //           ) +
    //           " AND " +
    //           where +
    //           " AND (oc.email_address not in (select distinct email from fridays_refined.cheetah_events where event_type = 'unsubscribe'))" +
    //           // " AND ca.olo = true AND ca.loyalty = false" +
    //           " GROUP BY 1";
    //       } else if (
    //         this.state.localStorageClientId ===
    //           "712cc8e9-3a79-4900-b122-ec9812e0f0ca" &&
    //         JSON.parse(
    //           CryptoJS.AES.decrypt(
    //             localStorage.getItem("activeChannel"),
    //             process.env.REACT_APP_PASS
    //           ).toString(CryptoJS.enc.Utf8)
    //         ) === "g786cb0f-eecc-4b87-adef-34eb20f3f766"
    //       ) {
    //         fQS =
    //           "select CASE " +
    //           selectedRule +
    //           " ELSE 'Remainder' END segment, count(distinct(ca.cust_id)) count FROM " +
    //           JSON.parse(
    //             CryptoJS.AES.decrypt(
    //               localStorage.getItem("custDb"),
    //               process.env.REACT_APP_PASS
    //             ).toString(CryptoJS.enc.Utf8)
    //           ) +
    //           ".cust_analytic ca LEFT JOIN " +
    //           JSON.parse(
    //             CryptoJS.AES.decrypt(
    //               localStorage.getItem("custDb"),
    //               process.env.REACT_APP_PASS
    //             ).toString(CryptoJS.enc.Utf8)
    //           ) +
    //           ".client_intellibase ci ON ci.cust_id = ca.cust_id LEFT JOIN (SELECT * FROM (SELECT rank() OVER (partition by email_address, geo_concept ORDER BY em_match_level, cust_id) rank, * FROM " +
    //           JSON.parse(
    //             CryptoJS.AES.decrypt(
    //               localStorage.getItem("custDb"),
    //               process.env.REACT_APP_PASS
    //             ).toString(CryptoJS.enc.Utf8)
    //           ) +
    //           ".owned_email ) WHERE rank = 1 ) oe ON oe.cust_id = ca.cust_id AND oe.geo_concept = ca.geo_concept LEFT JOIN " +
    //           JSON.parse(
    //             CryptoJS.AES.decrypt(
    //               localStorage.getItem("custDb"),
    //               process.env.REACT_APP_PASS
    //             ).toString(CryptoJS.enc.Utf8)
    //           ) +
    //           ".eclub ec ON ec.cust_id = ca.cust_id AND ec.eclub_geo_concept = ca.geo_concept LEFT JOIN " +
    //           JSON.parse(
    //             CryptoJS.AES.decrypt(
    //               localStorage.getItem("custDb"),
    //               process.env.REACT_APP_PASS
    //             ).toString(CryptoJS.enc.Utf8)
    //           ) +
    //           ".geo geo ON geo.geo_id = ca.geo_id_fav AND geo.geo_concept = ca.geo_concept LEFT JOIN " +
    //           JSON.parse(
    //             CryptoJS.AES.decrypt(
    //               localStorage.getItem("custDb"),
    //               process.env.REACT_APP_PASS
    //             ).toString(CryptoJS.enc.Utf8)
    //           ) +
    //           ".olo_customer oc on oc.cust_id = ca.cust_id LEFT JOIN " +
    //           JSON.parse(
    //             CryptoJS.AES.decrypt(
    //               localStorage.getItem("custDb"),
    //               process.env.REACT_APP_PASS
    //             ).toString(CryptoJS.enc.Utf8)
    //           ) +
    //           ".loyalty lo ON lo.cust_id = ca.cust_id AND lo.geo_concept = ca.geo_concept WHERE " +
    //           JSON.parse(
    //             CryptoJS.AES.decrypt(
    //               localStorage.getItem("globalFilter"),
    //               process.env.REACT_APP_PASS
    //             ).toString(CryptoJS.enc.Utf8)
    //           ) +
    //           " AND " +
    //           where +
    //           " AND (lo.email_address not in (select distinct email from fridays_refined.cheetah_events where event_type = 'unsubscribe'))" +
    //           " GROUP BY 1";
    //       } else {
    //         if (
    //           this.state.localStorageClientId ===
    //             "dc0df8ce-c87e-4746-a00e-d2c9ee4d7534" ||
    //           this.state.localStorageClientId ===
    //             "f0d3b19b-a564-43e9-85dd-bd95f8b13f97"
    //         ) {
    //           fQS =
    //             "select CASE " +
    //             selectedRule +
    //             " ELSE 'Remainder' END segment, count(distinct(ca.cust_id)) count FROM " +
    //             JSON.parse(
    //               CryptoJS.AES.decrypt(
    //                 localStorage.getItem("custDb"),
    //                 process.env.REACT_APP_PASS
    //               ).toString(CryptoJS.enc.Utf8)
    //             ) +
    //             ".cust_analytic ca LEFT JOIN " +
    //             JSON.parse(
    //               CryptoJS.AES.decrypt(
    //                 localStorage.getItem("custDb"),
    //                 process.env.REACT_APP_PASS
    //               ).toString(CryptoJS.enc.Utf8)
    //             ) +
    //             ".client_intellibase ci ON ci.cust_id = ca.cust_id LEFT JOIN (SELECT * FROM (SELECT rank() OVER (partition by email_address, geo_concept ORDER BY em_match_level, cust_id) rank, * FROM " +
    //             JSON.parse(
    //               CryptoJS.AES.decrypt(
    //                 localStorage.getItem("custDb"),
    //                 process.env.REACT_APP_PASS
    //               ).toString(CryptoJS.enc.Utf8)
    //             ) +
    //             ".owned_email ) WHERE rank = 1 ) oe ON oe.cust_id = ca.cust_id AND oe.geo_concept = ca.geo_concept LEFT JOIN " +
    //             JSON.parse(
    //               CryptoJS.AES.decrypt(
    //                 localStorage.getItem("custDb"),
    //                 process.env.REACT_APP_PASS
    //               ).toString(CryptoJS.enc.Utf8)
    //             ) +
    //             ".eclub ec ON ec.cust_id = ca.cust_id AND ec.eclub_geo_concept = ca.geo_concept LEFT JOIN " +
    //             JSON.parse(
    //               CryptoJS.AES.decrypt(
    //                 localStorage.getItem("custDb"),
    //                 process.env.REACT_APP_PASS
    //               ).toString(CryptoJS.enc.Utf8)
    //             ) +
    //             ".geo geo ON geo.geo_id = ca.geo_id_fav AND geo.geo_concept = ca.geo_concept LEFT JOIN " +
    //             JSON.parse(
    //               CryptoJS.AES.decrypt(
    //                 localStorage.getItem("custDb"),
    //                 process.env.REACT_APP_PASS
    //               ).toString(CryptoJS.enc.Utf8)
    //             ) +
    //             ".loyalty lo ON lo.cust_id = ca.cust_id AND lo.geo_concept = ca.geo_concept AND (ec.email_address_hh = lo.email_address_hh OR ec.name_addr_key = lo.name_addr_key OR ec.phone_home = lo.loyalty_phone_home OR ec.phone_mobile = lo.loyalty_phone_mobile) WHERE " +
    //             JSON.parse(
    //               CryptoJS.AES.decrypt(
    //                 localStorage.getItem("globalFilter"),
    //                 process.env.REACT_APP_PASS
    //               ).toString(CryptoJS.enc.Utf8)
    //             ) +
    //             " AND " +
    //             where +
    //             " GROUP BY 1";
    //         } else {
    //           fQS =
    //             "select CASE " +
    //             selectedRule +
    //             " ELSE 'Remainder' END segment, count(distinct(ca.cust_id)) count FROM " +
    //             JSON.parse(
    //               CryptoJS.AES.decrypt(
    //                 localStorage.getItem("custDb"),
    //                 process.env.REACT_APP_PASS
    //               ).toString(CryptoJS.enc.Utf8)
    //             ) +
    //             ".cust_analytic ca LEFT JOIN " +
    //             JSON.parse(
    //               CryptoJS.AES.decrypt(
    //                 localStorage.getItem("custDb"),
    //                 process.env.REACT_APP_PASS
    //               ).toString(CryptoJS.enc.Utf8)
    //             ) +
    //             ".client_intellibase ci ON ci.cust_id = ca.cust_id LEFT JOIN (SELECT * FROM (SELECT rank() OVER (partition by email_address, geo_concept ORDER BY em_match_level, cust_id) rank, * FROM " +
    //             JSON.parse(
    //               CryptoJS.AES.decrypt(
    //                 localStorage.getItem("custDb"),
    //                 process.env.REACT_APP_PASS
    //               ).toString(CryptoJS.enc.Utf8)
    //             ) +
    //             ".owned_email ) WHERE rank = 1 ) oe ON oe.cust_id = ca.cust_id AND oe.geo_concept = ca.geo_concept LEFT JOIN " +
    //             JSON.parse(
    //               CryptoJS.AES.decrypt(
    //                 localStorage.getItem("custDb"),
    //                 process.env.REACT_APP_PASS
    //               ).toString(CryptoJS.enc.Utf8)
    //             ) +
    //             ".eclub ec ON ec.cust_id = ca.cust_id AND ec.eclub_geo_concept = ca.geo_concept LEFT JOIN " +
    //             JSON.parse(
    //               CryptoJS.AES.decrypt(
    //                 localStorage.getItem("custDb"),
    //                 process.env.REACT_APP_PASS
    //               ).toString(CryptoJS.enc.Utf8)
    //             ) +
    //             ".geo geo ON geo.geo_id = ca.geo_id_fav AND geo.geo_concept = ca.geo_concept LEFT JOIN " +
    //             JSON.parse(
    //               CryptoJS.AES.decrypt(
    //                 localStorage.getItem("custDb"),
    //                 process.env.REACT_APP_PASS
    //               ).toString(CryptoJS.enc.Utf8)
    //             ) +
    //             ".loyalty lo ON lo.cust_id = ca.cust_id AND lo.geo_concept = ca.geo_concept WHERE " +
    //             JSON.parse(
    //               CryptoJS.AES.decrypt(
    //                 localStorage.getItem("globalFilter"),
    //                 process.env.REACT_APP_PASS
    //               ).toString(CryptoJS.enc.Utf8)
    //             ) +
    //             " AND " +
    //             where +
    //             " GROUP BY 1";
    //         }
    //       }
    //     }
    //   }
    //   //fQS = "select case " + selectedRule + "else 'remainder' end segment, count_if(ca.eclub) eclub_count, count_if(ca.preclub) preclub_count, count_if(if(ca.eclub or ca.preclub,true,false)) email_count, count(distinct(ci.cust_id)) dm_count from " + JSON.parse(CryptoJS.AES.decrypt(localStorage.getItem('custDb'),'secretpass').toString(CryptoJS.enc.Utf8)) + " .cust_analytic ca left join " + JSON.parse(CryptoJS.AES.decrypt(localStorage.getItem('custDb'),'secretpass').toString(CryptoJS.enc.Utf8)) + " .client_intellibase ci on ca.cust_id = ci.cust_id where " + JSON.parse(CryptoJS.AES.decrypt(localStorage.getItem('globalFilter'),'secretpass').toString(CryptoJS.enc.Utf8)) + " group by 1";
    //   /*fQS =
    //     "SELECT segment, count(*) as count from (SELECT CASE " +
    //     selectedRule +
    //     "ELSE 'Remainder' END AS segment FROM " + process.env.REACT_APP_ATHENA_TABLE + " WHERE " +
    //     where +
    //     ") GROUP BY segment";*/
    // }

    // Item History Changes
    if(fQS.includes("ih.item_id") || fQS.includes("ih.item_category")) {
      let newRegex = new RegExp(`FROM +${schemaName}.cust_analytic +ca *`, 'i')
      let newJoin = `FROM ${schemaName}.cust_analytic ca left join (select cust_id as "c_id", item_id, item_category from ${schemaName.split('_')[0]}_lookup.item_history) ih on ca.cust_id = ih.c_id `
      fQS = fQS.replace(newRegex, newJoin)

      newRegex = new RegExp(`FROM +${schemaName}.display_customers +di *`, 'i')
      newJoin = `FROM ${schemaName}.display_customers di left join (select cust_id as "c_id", item_id, item_category from ${schemaName.split('_')[0]}_lookup.item_history) ih on di.cust_id = ih.c_id `
      fQS = fQS.replace(newRegex, newJoin)
    }
    
    // fQS = fQS.replaceAll("ca.segment", "CAST(ca.segment AS varchar)");
    fQS = fQS.replaceAll("lo.loyalty_birthday = ", "");
    fQS = fQS.replaceAll("lo.loyalty_half_birthday = ", "");

    // Delivery File Suppression Changes -- JR
    if (localStorage.getItem("automationSelectedId") !== null) {
      if (
        this.decryptLocal("model") === "restaurant_v3"
      ) {
        let currDb = this.decryptLocal("custDb")
        // IN
        let currRegex = /\( *li\.list_id +IN *\((.*?)\)/g;
        let currMatch = (' ' + fQS).slice(1).match(currRegex);
        let singleRegex, currAutomation
        if (currMatch) {
          let singleRegex = /\( *li\.list_id +IN *\((.*?)\)/;
          for(let idx in currMatch) {
            currAutomation = (' ' + currMatch[idx]).slice(1).match(singleRegex)
            fQS = fQS.replace(
              singleRegex,
              // Replace With
              "(ca.cust_id IN" +
                "(" + 
                  "SELECT cust_id from " +
                  currDb + ".deliveries where delivery_id IN " +
                  "(" +
                    "select delivery_id " +
                    "from " + currDb + ".cmp_deliveries " + 
                    "where automation_id in ("+currAutomation[1]+")" +
                  ")" + 
                ")"
            );
          }
        }
        
        // NOT IN
        currRegex = /\( *li\.list_id +NOT +IN *\((.*?)\)/g;
        currMatch = (' ' + fQS).slice(1).match(currRegex);
        if (currMatch) {
          singleRegex = /\( *li\.list_id +NOT +IN *\((.*?)\)/;
          for(let idx in currMatch) {
            currAutomation = (' ' + currMatch[idx]).slice(1).match(singleRegex)
            fQS = fQS.replace(
              singleRegex,
              // Replace With
              "(ca.cust_id NOT IN" +
                "(" + 
                  "SELECT cust_id from " +
                  currDb + ".deliveries where delivery_id IN " +
                  "(" +
                    "select delivery_id " +
                    "from " + currDb + ".cmp_deliveries " + 
                    "where automation_id in ("+currAutomation[1]+")" +
                  ")" + 
                ")"
            );
          }
        }
      }
    
      // console.log(fQS)
    }

    for (let i = 1; i <= 12; i++) {
      var firstIndex = fQS.indexOf(
        `'if(month(date(lo.loyalty_birthday)) = ${i},true)'`
      );
      if (firstIndex !== -1) {
        var lastIndex = firstIndex + 46;
        if (i >= 10) {
          lastIndex = firstIndex + 47;
        }
        var whatIHave =
          fQS.slice(0, firstIndex) +
          `if(month(date(lo.loyalty_birthday)) = ${i},true)` +
          fQS.slice(lastIndex + 1);
        fQS = whatIHave;
      }
    }

    for (let i = 1; i <= 12; i++) {
      var firstIndex = fQS.indexOf(
        `'if(month(date(lo.loyalty_half_birthday)) = ${i},true)'`
      );
      if (firstIndex !== -1) {
        var lastIndex = firstIndex + 51;
        if (i >= 10) {
          lastIndex = firstIndex + 52;
        }
        var whatIHave =
          fQS.slice(0, firstIndex) +
          `if(month(date(lo.loyalty_half_birthday)) = ${i},true)` +
          fQS.slice(lastIndex + 1);
        fQS = whatIHave;
      }
    }

    for (let i = 1; i <= 12; i++) {
      var firstIndex = fQS.indexOf(
        `'if(month(date(lo.loyalty_birthday)) = ${i},true)'`
      );
      if (firstIndex !== -1) {
        var lastIndex = firstIndex + 46;
        if (i >= 10) {
          lastIndex = firstIndex + 47;
        }
        var whatIHave =
          fQS.slice(0, firstIndex) +
          `if(month(date(lo.loyalty_birthday)) = ${i},true)` +
          fQS.slice(lastIndex + 1);
        fQS = whatIHave;
      }
    }

    for (let i = 1; i <= 12; i++) {
      var firstIndex = fQS.indexOf(
        `'if(month(date(lo.loyalty_half_birthday)) = ${i},true)'`
      );
      if (firstIndex !== -1) {
        var lastIndex = firstIndex + 51;
        if (i >= 10) {
          lastIndex = firstIndex + 52;
        }
        var whatIHave =
          fQS.slice(0, firstIndex) +
          `if(month(date(lo.loyalty_half_birthday)) = ${i},true)` +
          fQS.slice(lastIndex + 1);
        fQS = whatIHave;
      }
    }

    fQS = fQS.replaceAll(
      "ca.member_tenure = true",
      "(ca.member_tenure >= 90 or ca.trans_ltd > 1)"
    );

    fQS = fQS.replaceAll(
      "ca.member_tenure = false",
      "(ca.member_tenure < 90 and ca.trans_ltd <= 1)"
    );

    fQS = fQS.replaceAll(
      "(ca.trans_ltd in (0,1) or ca.trans_ltd is null) AND ca.member_tenure = 14",
      "ca.member_tenure = 14"
    );

    fQS = fQS.replaceAll(
      "(ca.trans_ltd in (0,1) or ca.trans_ltd is null) AND ca.member_tenure = 7",
      "ca.member_tenure = 7"
    );

    fQS = fQS.replaceAll(
      "(ca.trans_ltd in (0,1) or ca.trans_ltd is null) AND ca.member_tenure = 0",
      "ca.member_tenure = 0"
    );

    fQS = fQS.replaceAll(
      "(ca.cust_id IN (select cust_id from goodwill_refined.loyalty where loyalty_id IN(select customer_id from goodwill_source.tb_coupon where coupon_id NOT IN (select coupon_id from goodwill_source.tb_coupon_used) AND date(date_parse(act_date,'%c/%e/%Y %r')) <= current_date AND date(date_parse(deact_time,'%c/%e/%Y %r')) > current_date AND orig_template_id = '1037')",
      "ca.cust_id IN (select cust_id from goodwill_refined.loyalty where loyalty_id IN(select customer_id from goodwill_source.tb_coupon where coupon_id NOT IN (select coupon_id from goodwill_source.tb_coupon_used) AND date(date_parse(act_date,'%c/%e/%Y %r')) <= current_date AND date(date_parse(deact_time,'%c/%e/%Y %r')) > current_date AND orig_template_id = '1037'))"
    );

    fQS = fQS.replaceAll(
      "((ca.cust_id IN (select cust_id from goodwill_refined.loyalty where loyalty_id IN(select customer_id from goodwill_source.tb_coupon where coupon_id NOT IN (select coupon_id from goodwill_source.tb_coupon_used) AND date(date_parse(act_date,'%c/%e/%Y %r')) <= current_date AND date(date_parse(deact_time,'%c/%e/%Y %r')) > current_date AND orig_template_id = '1037' AND ca.geo_concept = '1'))",
      "ca.cust_id IN (select cust_id from goodwill_refined.loyalty where loyalty_id IN(select customer_id from goodwill_source.tb_coupon where coupon_id NOT IN (select coupon_id from goodwill_source.tb_coupon_used) AND date(date_parse(act_date,'%c/%e/%Y %r')) <= current_date AND date(date_parse(deact_time,'%c/%e/%Y %r')) > current_date AND orig_template_id = '1037'))"
    );

    if (
      (this.decryptLocal("clientId") === "3fe7e557-16f5-406c-bbc8-887fdec7ba8b" ||
        this.decryptLocal("clientId") === "8c001fde-3728-48dc-9950-b8480ca9fbee") &&
      (
        this.decryptLocal("activeChannel") === "d1606aea-0c0d-4fba-83e8-a124f414a953" ||
        this.decryptLocal("activeChannel") === "a8f39ffb-24c5-432a-9bcd-e5d0166a320e"
      )
    ) {
      fQS = fQS.replace("ca.dim_lifecycle", "di.dim_lifecycle");
      fQS = fQS.replace("ca.geo_id_fav", "di.geo_id");
      fQS = fQS.replace(
        "(ca.loyalty = false)",
        "(ca.loyalty = false OR ca.loyalty is null)"
      );
    }

    if (
      this.decryptLocal("clientId") === "712cc8e9-3a79-4900-b122-ec9812e0f0ca" &&
      this.decryptLocal("activeChannel") === "8905c46e-6f48-4ed8-b2a9-35dbbf3bae91"
    ) {
      fQS = fQS.replaceAll(
        "lo.email_marketable = true",
        "oc.email_marketable = true"
      );
      fQS = fQS.replaceAll(
        "ec.email_marketable = true",
        "oc.email_marketable = true"
      );
    }

    if (
      this.decryptLocal("clientId") === "712cc8e9-3a79-4900-b122-ec9812e0f0ca" &&
      this.decryptLocal("activeChannel") === "g786cb0f-eecc-4b87-adef-34eb20f3f766"
    ) {
      fQS = fQS.replaceAll(
        "oc.email_marketable = true",
        "lo.email_marketable = true"
      );

      fQS = fQS.replaceAll(
        "ec.email_marketable = true",
        "lo.email_marketable = true"
      );
    }

    if (
      this.decryptLocal("clientId") === "712cc8e9-3a79-4900-b122-ec9812e0f0ca" &&
      this.decryptLocal("activeChannel") === "92ec41c7-6724-4891-bc17-24981a3261dd"
    ) {
      fQS = fQS.replaceAll(
        "oc.email_marketable = true",
        "ec.email_marketable = true"
      );

      fQS = fQS.replaceAll(
        "lo.email_marketable = true",
        "ec.email_marketable = true"
      );
    }

    let query = fQS;

    let myInitCount = {
      headers: {},
      body: {
        sql: fQS,
        isCustSegment: true,
        custDb: this.decryptLocal("custDb"),
      },
    };

    // if (
    //   this.props.cust_summaryDetails["segments_tab_details"]["condition"] ===
    //     "" ||
    //   this.props.cust_summaryDetails["segments_tab_details"]["condition"] !==
    //     fQS
    // ) {
    //   API.post(apiName, "/counts", myInitCount)
    //     .then((response) => {
    //       this.props.dispatch({
    //         type: "CUST_UPDATE_SUMMARY_DETAILS",
    //         segmentsTabPayload: fQS,
    //         segmentsTabValue: response["final_result"]["Items"],
    //       });
    //       this.props.dispatch({
    //         type: "CUST_UPDATE_QUERY_COUNT_SEGMENT",
    //         segmentData: response["final_result"]["Items"],
    //       });
    //     })
    //     .catch((error) => {
    //       console.log(error);
    //     });
    // } else {
    //   if (
    //     this.props.cust_summaryDetails["segments_tab_details"]["value"] !==
    //     undefined
    //   ) {
    //     this.props.dispatch({
    //       type: "CUST_UPDATE_QUERY_COUNT_SEGMENT",
    //       segmentData: this.props.cust_summaryDetails["segments_tab_details"][
    //         "value"
    //       ],
    //     });
    //   } else {
    //     API.post(apiName, "/counts", myInitCount)
    //       .then((response) => {
    //         this.props.dispatch({
    //           type: "CUST_UPDATE_SUMMARY_DETAILS",
    //           segmentsTabPayload: fQS,
    //           segmentsTabValue: response["final_result"]["Items"],
    //         });
    //         this.props.dispatch({
    //           type: "CUST_UPDATE_QUERY_COUNT_SEGMENT",
    //           segmentData: response["final_result"]["Items"],
    //         });
    //       })
    //       .catch((error) => {
    //         console.log(error);
    //       });
    //   }
    // }

    if (selectedCustomerType === "Acquistion") {
      if (
        this.props.cust_summaryDetails["segments_tab_details"]["condition"] ===
          "" ||
        this.props.cust_summaryDetails["segments_tab_details"]["condition"] !==
          fQS
      ) {
        this.fetchProspectQueryData(
          modelDecileSelectedRule,
          nonModelDecileSelectedRule,
          samplingSelectedRule,
          selectedRule,
          fQS,
          filtersNonModelDecileSelectedRule,
          filtersModelDecileSelectedRule,
          filtersSamplingSelectedRule
        );
      } else {
        if (
          this.props.cust_summaryDetails["segments_tab_details"]["value"] !==
          undefined
        ) {
          this.props.dispatch({
            type: "CUST_UPDATE_QUERY_COUNT_SEGMENT",
            segmentData: this.props.cust_summaryDetails["segments_tab_details"][
              "value"
            ],
          });
        } else {
          this.fetchProspectQueryData(
            modelDecileSelectedRule,
            nonModelDecileSelectedRule,
            samplingSelectedRule,
            selectedRule,
            fQS,
            filtersNonModelDecileSelectedRule,
            filtersModelDecileSelectedRule,
            filtersSamplingSelectedRule
          );
        }
      }
    } else {
      if (
        this.props.cust_summaryDetails["segments_tab_details"]["condition"] ===
          "" ||
        this.props.cust_summaryDetails["segments_tab_details"]["condition"] !==
          fQS
      ) {
        API.post(apiName, "/counts", myInitCount)
          .then((response) => {
            this.props.dispatch({
              type: "CUST_UPDATE_SUMMARY_DETAILS",
              segmentsTabPayload: fQS,
              segmentsTabValue: response["final_result"]["Items"],
            });
            this.props.dispatch({
              type: "CUST_UPDATE_QUERY_COUNT_SEGMENT",
              segmentData: response["final_result"]["Items"],
            });
          })
          .catch((error) => {
            console.log(error);
          });
      } else {
        if (
          this.props.cust_summaryDetails["segments_tab_details"]["value"] !==
          undefined
        ) {
          this.props.dispatch({
            type: "CUST_UPDATE_QUERY_COUNT_SEGMENT",
            segmentData: this.props.cust_summaryDetails["segments_tab_details"][
              "value"
            ],
          });
        } else {
          API.post(apiName, "/counts", myInitCount)
            .then((response) => {
              this.props.dispatch({
                type: "CUST_UPDATE_SUMMARY_DETAILS",
                segmentsTabPayload: fQS,
                segmentsTabValue: response["final_result"]["Items"],
              });
              this.props.dispatch({
                type: "CUST_UPDATE_QUERY_COUNT_SEGMENT",
                segmentData: response["final_result"]["Items"],
              });
            })
            .catch((error) => {
              console.log(error);
            });
        }
      }
    }
  }

  fetchQueryData() {}

  render() {
    if (this.props.index === 0) {
      this.displayQuery();
    }
    const { classes } = this.props;
    let tillSqlSelectionArr = this.props.selectedValue;
    let afterSqlSelectionArr = this.props.cust_afterSqlSelectionArrSegment[
      this.props.index
    ];
    let selectedRule = "";
    let selectedOptionValue = "";
    let selectedResult = [];
    tillSqlSelectionArr.map((options, key) => {
      let length = options.length;
      selectedRule =
        "<strong>" +
        options[length - 2].label +
        "</strong> " +
        options[length - 1].label +
        " ";
      let data = afterSqlSelectionArr[key];
      if (data.length > 0) {
        data.map((result, key) => {
          if (
            options[length - 1].value == "IN" ||
            options[length - 1].value == "NOT IN"
          ) {
            if (key == 0) {
              selectedRule += ``;
            }
            selectedRule += `<strong> ${result.label} </strong>, `;
            if (key == data.length - 1) {
              selectedRule = selectedRule.replace(/,(\s+)?$/, "");
              selectedRule += ``;
            }
          } else {
            if (
              result.label == "number_field_name" ||
              result.label == "string_field_name"
            ) {
              selectedRule += `<strong> ${result.value} <strong>, `;
            } else {
              selectedRule += `<strong> ${result.label} <strong>, `;
            }
          }
        });
      }
      selectedRule = selectedRule.replace(/,(\s+)?$/, "");
      selectedResult.push(selectedRule);
    });
    let htmlContent = selectedResult.map((options, key) => (
      <li key={key}>
        <a
          href="javascript:void(0)"
          className="borderbtn"
          dangerouslySetInnerHTML={{ __html: options }}
        />
        <div className="editandclosespace">
          <Button
            style={{ textAlign: "center" }}
            className="btn btncreate editableicon"
            color="danger"
            onClick={() => this.deleteRuleClick(key)}
          >
            <i className="fa fa-trash" />
          </Button>
          <Modal
            titleName="Edit Rule"
            buttonLabel="Edit"
            selectedIndex={this.props.index}
            selectedRule={key}
            mode="Edit"
            type="rule"
            buttonType="edit button"
            class="editableicon"
          />
        </div>
        {selectedResult.length > 0 && selectedResult.length - 1 != key ? (
          <div
            className="andorbtngroupwrap"
            // <div className="andorbtngroupwrap parentwrap"
            //  style={{left: "-65px", marginTop:"10px", bottom:"-38px"}}
          >
            <div className="andorgroup">
              <ToggleButton
                selectedIndex={this.props.index}
                selectedRule={key}
                type="Rule"
              />
            </div>
          </div>
        ) : (
          ""
        )}
      </li>
    ));
    return (
      <React.Fragment>
        {/* <ul className="addrulelisting"> */}
        <ul
          className={
            htmlContent.length === 1 ? "addrulelisting-c" : "addrulelisting"
          }
        >
          {htmlContent}
        </ul>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  cust_countSegment: state.cust_countSegment,
  cust_tillSqlSelectionArrSegment: state.cust_tillSqlSelectionArrSegment,
  cust_afterSqlSelectionArrSegment: state.cust_afterSqlSelectionArrSegment,
  cust_ruleLeveltoggleSegment: state.cust_ruleLeveltoggleSegment,
  cust_groupLeveltoggleSegment: state.cust_groupLeveltoggleSegment,
  cust_segmentName: state.cust_segmentName,

  cust_count: state.cust_count,
  cust_tillSqlSelectionArr: state.cust_tillSqlSelectionArr,
  cust_afterSqlSelectionArr: state.cust_afterSqlSelectionArr,
  cust_ruleLeveltoggle: state.cust_ruleLeveltoggle,
  cust_groupLeveltoggle: state.cust_groupLeveltoggle,
  cust_summaryDetails: state.cust_summaryDetails,
});

export default connect(mapStateToProps)(
  withStyles(notificationsStyle)(AddRule)
);



// WEBPACK FOOTER //
// ./src/views/Audiences/CSegmentQueryBuilder/AddRule.jsx